!(function () {
    var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {},
        e = {},
        s = {},
        i = t.parcelRequire3852;
    null == i &&
        (((i = function (t) {
            if (t in e) return e[t].exports;
            if (t in s) {
                var i = s[t];
                delete s[t];
                var n = { id: t, exports: {} };
                return (e[t] = n), i.call(n.exports, n, n.exports), n.exports;
            }
            var o = new Error("Cannot find module '" + t + "'");
            throw ((o.code = "MODULE_NOT_FOUND"), o);
        }).register = function (t, e) {
            s[t] = e;
        }),
        (t.parcelRequire3852 = i)),
        i.register("6X0JW", function (t, e) {
            var s, i;
            (s = "undefined" != typeof window ? window : {}),
                (i = (function (t, e, s) {
                    "use strict";
                    var i, n;
                    if (
                        ((function () {
                            var e,
                                s = {
                                    lazyClass: "lazyload",
                                    loadedClass: "lazyloaded",
                                    loadingClass: "lazyloading",
                                    preloadClass: "lazypreload",
                                    errorClass: "lazyerror",
                                    autosizesClass: "lazyautosizes",
                                    fastLoadedClass: "ls-is-cached",
                                    iframeLoadMode: 0,
                                    srcAttr: "data-src",
                                    srcsetAttr: "data-srcset",
                                    sizesAttr: "data-sizes",
                                    minSize: 40,
                                    customMedia: {},
                                    init: !0,
                                    expFactor: 1.5,
                                    hFac: 0.8,
                                    loadMode: 2,
                                    loadHidden: !0,
                                    ricTimeout: 0,
                                    throttleDelay: 125,
                                };
                            for (e in ((n = t.lazySizesConfig || t.lazysizesConfig || {}), s)) e in n || (n[e] = s[e]);
                        })(),
                        !e || !e.getElementsByClassName)
                    )
                        return { init: function () {}, cfg: n, noSupport: !0 };
                    var o,
                        a,
                        r,
                        l,
                        c,
                        h,
                        d,
                        u,
                        p,
                        m,
                        _,
                        g,
                        f,
                        b,
                        v,
                        y,
                        S,
                        w,
                        C,
                        k,
                        E,
                        x,
                        I,
                        L,
                        T,
                        M,
                        B,
                        A,
                        P,
                        D,
                        q,
                        O,
                        R,
                        F,
                        N,
                        H,
                        V,
                        z,
                        $,
                        K,
                        W,
                        U,
                        Y,
                        X,
                        Q,
                        j = e.documentElement,
                        G = t.HTMLPictureElement,
                        Z = "addEventListener",
                        J = "getAttribute",
                        tt = t[Z].bind(t),
                        et = t.setTimeout,
                        st = t.requestAnimationFrame || et,
                        it = t.requestIdleCallback,
                        nt = /^picture$/i,
                        ot = ["load", "error", "lazyincluded", "_lazyloaded"],
                        at = {},
                        rt = Array.prototype.forEach,
                        lt = function (t, e) {
                            return at[e] || (at[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), at[e].test(t[J]("class") || "") && at[e];
                        },
                        ct = function (t, e) {
                            lt(t, e) || t.setAttribute("class", (t[J]("class") || "").trim() + " " + e);
                        },
                        ht = function (t, e) {
                            var s;
                            (s = lt(t, e)) && t.setAttribute("class", (t[J]("class") || "").replace(s, " "));
                        },
                        dt = function (t, e, s) {
                            var i = s ? Z : "removeEventListener";
                            s && dt(t, e),
                                ot.forEach(function (s) {
                                    t[i](s, e);
                                });
                        },
                        ut = function (t, s, n, o, a) {
                            var r = e.createEvent("Event");
                            return n || (n = {}), (n.instance = i), r.initEvent(s, !o, !a), (r.detail = n), t.dispatchEvent(r), r;
                        },
                        pt = function (e, s) {
                            var i;
                            !G && (i = t.picturefill || n.pf) ? (s && s.src && !e[J]("srcset") && e.setAttribute("srcset", s.src), i({ reevaluate: !0, elements: [e] })) : s && s.src && (e.src = s.src);
                        },
                        mt = function (t, e) {
                            return (getComputedStyle(t, null) || {})[e];
                        },
                        _t = function (t, e, s) {
                            for (s = s || t.offsetWidth; s < n.minSize && e && !t._lazysizesWidth; ) (s = e.offsetWidth), (e = e.parentNode);
                            return s;
                        },
                        gt =
                            ((U = []),
                            (Y = W = []),
                            (X = function () {
                                var t = Y;
                                for (Y = W.length ? U : W, $ = !0, K = !1; t.length; ) t.shift()();
                                $ = !1;
                            }),
                            (Q = function (t, s) {
                                $ && !s ? t.apply(this, arguments) : (Y.push(t), K || ((K = !0), (e.hidden ? et : st)(X)));
                            }),
                            (Q._lsFlush = X),
                            Q),
                        ft = function (t, e) {
                            return e
                                ? function () {
                                      gt(t);
                                  }
                                : function () {
                                      var e = this,
                                          s = arguments;
                                      gt(function () {
                                          t.apply(e, s);
                                      });
                                  };
                        },
                        bt = function (t) {
                            var e,
                                i = 0,
                                o = n.throttleDelay,
                                a = n.ricTimeout,
                                r = function () {
                                    (e = !1), (i = s.now()), t();
                                },
                                l =
                                    it && a > 49
                                        ? function () {
                                              it(r, { timeout: a }), a !== n.ricTimeout && (a = n.ricTimeout);
                                          }
                                        : ft(function () {
                                              et(r);
                                          }, !0);
                            return function (t) {
                                var n;
                                (t = !0 === t) && (a = 33), e || ((e = !0), (n = o - (s.now() - i)) < 0 && (n = 0), t || n < 9 ? l() : et(l, n));
                            };
                        },
                        vt = function (t) {
                            var e,
                                i,
                                n = 99,
                                o = function () {
                                    (e = null), t();
                                },
                                a = function () {
                                    var t = s.now() - i;
                                    t < n ? et(a, n - t) : (it || o)(o);
                                };
                            return function () {
                                (i = s.now()), e || (e = et(a, n));
                            };
                        },
                        yt =
                            ((S = /^img$/i),
                            (w = /^iframe$/i),
                            (C = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent)),
                            (k = 0),
                            (E = 0),
                            (x = 0),
                            (I = -1),
                            (L = function (t) {
                                x--, (!t || x < 0 || !t.target) && (x = 0);
                            }),
                            (T = function (t) {
                                return null == y && (y = "hidden" == mt(e.body, "visibility")), y || !("hidden" == mt(t.parentNode, "visibility") && "hidden" == mt(t, "visibility"));
                            }),
                            (M = function (t, s) {
                                var i,
                                    n = t,
                                    o = T(t);
                                for (g -= s, v += s, f -= s, b += s; o && (n = n.offsetParent) && n != e.body && n != j; )
                                    (o = (mt(n, "opacity") || 1) > 0) && "visible" != mt(n, "overflow") && ((i = n.getBoundingClientRect()), (o = b > i.left && f < i.right && v > i.top - 1 && g < i.bottom + 1));
                                return o;
                            }),
                            (A = bt(
                                (B = function () {
                                    var t,
                                        s,
                                        o,
                                        a,
                                        r,
                                        l,
                                        d,
                                        p,
                                        S,
                                        w,
                                        L,
                                        B,
                                        A = i.elements;
                                    if ((u = n.loadMode) && x < 8 && (t = A.length)) {
                                        for (s = 0, I++; s < t; s++)
                                            if (A[s] && !A[s]._lazyRace)
                                                if (!C || (i.prematureUnveil && i.prematureUnveil(A[s]))) N(A[s]);
                                                else if (
                                                    (((p = A[s][J]("data-expand")) && (l = 1 * p)) || (l = E),
                                                    w ||
                                                        ((w = !n.expand || n.expand < 1 ? (j.clientHeight > 500 && j.clientWidth > 500 ? 500 : 370) : n.expand),
                                                        (i._defEx = w),
                                                        (L = w * n.expFactor),
                                                        (B = n.hFac),
                                                        (y = null),
                                                        E < L && x < 1 && I > 2 && u > 2 && !e.hidden ? ((E = L), (I = 0)) : (E = u > 1 && I > 1 && x < 6 ? w : k)),
                                                    S !== l && ((m = innerWidth + l * B), (_ = innerHeight + l), (d = -1 * l), (S = l)),
                                                    (o = A[s].getBoundingClientRect()),
                                                    (v = o.bottom) >= d &&
                                                        (g = o.top) <= _ &&
                                                        (b = o.right) >= d * B &&
                                                        (f = o.left) <= m &&
                                                        (v || b || f || g) &&
                                                        (n.loadHidden || T(A[s])) &&
                                                        ((h && x < 3 && !p && (u < 3 || I < 4)) || M(A[s], l)))
                                                ) {
                                                    if ((N(A[s]), (r = !0), x > 9)) break;
                                                } else !r && h && !a && x < 4 && I < 4 && u > 2 && (c[0] || n.preloadAfterLoad) && (c[0] || (!p && (v || b || f || g || "auto" != A[s][J](n.sizesAttr)))) && (a = c[0] || A[s]);
                                        a && !r && N(a);
                                    }
                                })
                            )),
                            (D = ft(
                                (P = function (t) {
                                    var e = t.target;
                                    e._lazyCache ? delete e._lazyCache : (L(t), ct(e, n.loadedClass), ht(e, n.loadingClass), dt(e, q), ut(e, "lazyloaded"));
                                })
                            )),
                            (q = function (t) {
                                D({ target: t.target });
                            }),
                            (O = function (t, e) {
                                var s = t.getAttribute("data-load-mode") || n.iframeLoadMode;
                                0 == s ? t.contentWindow.location.replace(e) : 1 == s && (t.src = e);
                            }),
                            (R = function (t) {
                                var e,
                                    s = t[J](n.srcsetAttr);
                                (e = n.customMedia[t[J]("data-media") || t[J]("media")]) && t.setAttribute("media", e), s && t.setAttribute("srcset", s);
                            }),
                            (F = ft(function (t, e, s, i, o) {
                                var a, r, l, c, h, u;
                                (h = ut(t, "lazybeforeunveil", e)).defaultPrevented ||
                                    (i && (s ? ct(t, n.autosizesClass) : t.setAttribute("sizes", i)),
                                    (r = t[J](n.srcsetAttr)),
                                    (a = t[J](n.srcAttr)),
                                    o && (c = (l = t.parentNode) && nt.test(l.nodeName || "")),
                                    (u = e.firesLoad || ("src" in t && (r || a || c))),
                                    (h = { target: t }),
                                    ct(t, n.loadingClass),
                                    u && (clearTimeout(d), (d = et(L, 2500)), dt(t, q, !0)),
                                    c && rt.call(l.getElementsByTagName("source"), R),
                                    r ? t.setAttribute("srcset", r) : a && !c && (w.test(t.nodeName) ? O(t, a) : (t.src = a)),
                                    o && (r || c) && pt(t, { src: a })),
                                    t._lazyRace && delete t._lazyRace,
                                    ht(t, n.lazyClass),
                                    gt(function () {
                                        var e = t.complete && t.naturalWidth > 1;
                                        (u && !e) ||
                                            (e && ct(t, n.fastLoadedClass),
                                            P(h),
                                            (t._lazyCache = !0),
                                            et(function () {
                                                "_lazyCache" in t && delete t._lazyCache;
                                            }, 9)),
                                            "lazy" == t.loading && x--;
                                    }, !0);
                            })),
                            (N = function (t) {
                                if (!t._lazyRace) {
                                    var e,
                                        s = S.test(t.nodeName),
                                        i = s && (t[J](n.sizesAttr) || t[J]("sizes")),
                                        o = "auto" == i;
                                    ((!o && h) || !s || (!t[J]("src") && !t.srcset) || t.complete || lt(t, n.errorClass) || !lt(t, n.lazyClass)) &&
                                        ((e = ut(t, "lazyunveilread").detail), o && St.updateElem(t, !0, t.offsetWidth), (t._lazyRace = !0), x++, F(t, e, o, i, s));
                                }
                            }),
                            (H = vt(function () {
                                (n.loadMode = 3), A();
                            })),
                            (z = function () {
                                h || (s.now() - p < 999 ? et(z, 999) : ((h = !0), (n.loadMode = 3), A(), tt("scroll", V, !0)));
                            }),
                            {
                                _: function () {
                                    (p = s.now()),
                                        (i.elements = e.getElementsByClassName(n.lazyClass)),
                                        (c = e.getElementsByClassName(n.lazyClass + " " + n.preloadClass)),
                                        tt("scroll", A, !0),
                                        tt("resize", A, !0),
                                        tt("pageshow", function (t) {
                                            if (t.persisted) {
                                                var s = e.querySelectorAll("." + n.loadingClass);
                                                s.length &&
                                                    s.forEach &&
                                                    st(function () {
                                                        s.forEach(function (t) {
                                                            t.complete && N(t);
                                                        });
                                                    });
                                            }
                                        }),
                                        t.MutationObserver ? new MutationObserver(A).observe(j, { childList: !0, subtree: !0, attributes: !0 }) : (j[Z]("DOMNodeInserted", A, !0), j[Z]("DOMAttrModified", A, !0), setInterval(A, 999)),
                                        tt("hashchange", A, !0),
                                        ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (t) {
                                            e[Z](t, A, !0);
                                        }),
                                        /d$|^c/.test(e.readyState) ? z() : (tt("load", z), e[Z]("DOMContentLoaded", A), et(z, 2e4)),
                                        i.elements.length ? (B(), gt._lsFlush()) : A();
                                },
                                checkElems: A,
                                unveil: N,
                                _aLSL: (V = function () {
                                    3 == n.loadMode && (n.loadMode = 2), H();
                                }),
                            }),
                        St =
                            ((a = ft(function (t, e, s, i) {
                                var n, o, a;
                                if (((t._lazysizesWidth = i), (i += "px"), t.setAttribute("sizes", i), nt.test(e.nodeName || ""))) for (o = 0, a = (n = e.getElementsByTagName("source")).length; o < a; o++) n[o].setAttribute("sizes", i);
                                s.detail.dataAttr || pt(t, s.detail);
                            })),
                            (r = function (t, e, s) {
                                var i,
                                    n = t.parentNode;
                                n && ((s = _t(t, n, s)), (i = ut(t, "lazybeforesizes", { width: s, dataAttr: !!e })).defaultPrevented || ((s = i.detail.width) && s !== t._lazysizesWidth && a(t, n, i, s)));
                            }),
                            {
                                _: function () {
                                    (o = e.getElementsByClassName(n.autosizesClass)), tt("resize", l);
                                },
                                checkElems: (l = vt(function () {
                                    var t,
                                        e = o.length;
                                    if (e) for (t = 0; t < e; t++) r(o[t]);
                                })),
                                updateElem: r,
                            }),
                        wt = function () {
                            !wt.i && e.getElementsByClassName && ((wt.i = !0), St._(), yt._());
                        };
                    return (
                        et(function () {
                            n.init && wt();
                        }),
                        (i = { cfg: n, autoSizer: St, loader: yt, init: wt, uP: pt, aC: ct, rC: ht, hC: lt, fire: ut, gW: _t, rAF: gt })
                    );
                })(s, s.document, Date)),
                (s.lazySizes = i),
                t.exports && (t.exports = i);
        }),
        i("6X0JW");
    var n = {};
    function o(t, e) {
        for (const s in e) {
            const i = e[s];
            t.addEventListener(s, i.listener || i, i.options || void 0);
        }
    }
    !(function (t, e) {
        if (t) {
            var s = function () {
                e(t.lazySizes), t.removeEventListener("lazyunveilread", s, !0);
            };
            (e = e.bind(null, t, t.document)), n ? e(i("6X0JW")) : "function" == typeof define && define.amd ? define(["lazysizes"], e) : t.lazySizes ? s() : t.addEventListener("lazyunveilread", s, !0);
        }
    })("undefined" != typeof window ? window : 0, function (t, e, s) {
        "use strict";
        if (t.addEventListener) {
            var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                n = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                o = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                a = /^picture$/i,
                r = s.cfg,
                l = {
                    getParent: function (e, s) {
                        var i = e,
                            n = e.parentNode;
                        return (
                            (s && "prev" != s) || !n || !a.test(n.nodeName || "") || (n = n.parentNode),
                            "self" != s && (i = "prev" == s ? e.previousElementSibling : (s && (n.closest || t.jQuery) && (n.closest ? n.closest(s) : jQuery(n).closest(s)[0])) || n),
                            i
                        );
                    },
                    getFit: function (t) {
                        var e,
                            s,
                            i = getComputedStyle(t, null) || {},
                            a = i.content || i.fontFamily,
                            r = { fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit") };
                        return (
                            !r.fit && a && (e = a.match(n)) && (r.fit = e[1]),
                            r.fit ? (!(s = t._lazysizesParentContainer || t.getAttribute("data-parent-container")) && a && (e = a.match(o)) && (s = e[1]), (r.parent = l.getParent(t, s))) : (r.fit = i.objectFit),
                            r
                        );
                    },
                    getImageRatio: function (e) {
                        var s,
                            n,
                            o,
                            l,
                            c,
                            h,
                            d,
                            u = e.parentNode,
                            p = u && a.test(u.nodeName || "") ? u.querySelectorAll("source, img") : [e];
                        for (s = 0; s < p.length; s++)
                            if (
                                ((n = (e = p[s]).getAttribute(r.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || ""),
                                (o = e._lsMedia || e.getAttribute("media")),
                                (o = r.customMedia[e.getAttribute("data-media") || o] || o),
                                n && (!o || ((t.matchMedia && matchMedia(o)) || {}).matches))
                            ) {
                                (l = parseFloat(e.getAttribute("data-aspectratio"))) ||
                                    ((c = n.match(i)) ? ("w" == c[2] ? ((h = c[1]), (d = c[3])) : ((h = c[3]), (d = c[1]))) : ((h = e.getAttribute("width")), (d = e.getAttribute("height"))), (l = h / d));
                                break;
                            }
                        return l;
                    },
                    calculateSize: function (t, e) {
                        var s,
                            i,
                            n,
                            o = this.getFit(t),
                            a = o.fit,
                            r = o.parent;
                        return "width" == a || (("contain" == a || "cover" == a) && (i = this.getImageRatio(t)))
                            ? (r ? (e = r.clientWidth) : (r = t), (n = e), "width" == a ? (n = e) : (s = e / r.clientHeight) && (("cover" == a && s < i) || ("contain" == a && s > i)) && (n = e * (i / s)), n)
                            : e;
                    },
                };
            (s.parentFit = l),
                e.addEventListener("lazybeforesizes", function (t) {
                    if (!t.defaultPrevented && t.detail.instance == s) {
                        var e = t.target;
                        t.detail.width = l.calculateSize(e, t.detail.width);
                    }
                });
        }
    });
    const a = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype,
        r = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
        l = ["src", "poster"];
    function c(t, e) {
        for (const s of l) s in t.dataset && (t.setAttribute(s, t.dataset[s]), t.classList.contains(e) && t.classList.remove(e));
    }
    function h(t, e, s, i) {
        if ("VIDEO" == t.nodeName) {
            const s = Array.from(t.querySelectorAll("source"));
            for (const t of s) c(t, e);
            t.load();
        }
        c(t, e);
        const n = t.classList;
        n.contains(s) && (n.remove(s), n.add(i));
    }
    var d = class {
        constructor(t) {
            this._notification = t;
        }
        show(t, e) {
            this._notification.show(t, e);
        }
    };
    const u = new (class {
            constructor() {
                const t = document.querySelector("#GlobalNotification");
                t && (this.notification = new d(t)), (this.isScrolling = !1), (this.overlaySelector = "#BodyOverlay"), window.addEventListener("wheel", this._handleWindowScroll), (this.overlayCalls = []);
            }
            _handleWindowScroll = () => {
                this._timeoutScrollId && (clearTimeout(this._timeoutScrollId), (this.isScrolling = !0)),
                    (this._timeoutScrollId = setTimeout(() => {
                        this.isScrolling = !1;
                    }, 300));
            };
            showOverlay(t, e) {
                const s = document.querySelector(this.overlaySelector);
                s && ((this.overlayCalls = [...this.overlayCalls, { key: t, styles: e }]), this.setBodyOverlayStyles({ zIndex: 3, backgroundColor: "var(--gsc-black-color-50)", ...e }), s.setAttribute("visible", ""), this.setScrollLock());
            }
            hideOverlay(t) {
                const e = document.querySelector(this.overlaySelector);
                if (!e) return;
                if (!e.hasAttribute("visible")) return;
                this.overlayCalls = this.overlayCalls.filter((e) => e.key !== t);
                const s = this.overlayCalls[this.overlayCalls.length - 1];
                s ? this.setBodyOverlayStyles(s.styles) : (e.removeAttribute("visible"), e.setAttribute("style", ""), this.unsetScrollLock());
            }
            setScrollLock() {
                (document.body.style.top = `-${window.scrollY || Math.abs(parseInt(document.body.style.top || "0"))}px`), document.body.setAttribute("scroll-y-off", "");
            }
            unsetScrollLock() {
                const t = document.body.style.top;
                document.body.removeAttribute("scroll-y-off"), (document.body.style.top = ""), window.scrollTo(0, -1 * parseInt(t || "0"));
            }
            setBodyOverlayStyles(t) {
                const e = document.querySelector(this.overlaySelector);
                if (e && t) {
                    Object.keys(t).forEach((s) => {
                        e.style[s] = t[s];
                    });
                }
            }
        })(),
        p = {
            SECTION_LOAD: "shopify:section:load",
            SECTION_UNLOAD: "shopify:section:unload",
            SECTION_SELECT: "shopify:section:select",
            SECTION_DESELECT: "shopify:section:deselect",
            SECTION_REORDER: "shopify:section:reorder",
            BLOCK_SELECT: "shopify:block:select",
            BLOCK_DESELECT: "shopify:block:deselect",
        },
        m = {
            ARROW_LEFT_STRING_KEY: "ArrowLeft",
            ARROW_RIGHT_STRING_KEY: "ArrowRight",
            ARROW_LEFT_NUMBER_KEY: 37,
            ARROW_RIGHT_NUMBER_KEY: 39,
            ENTER_STRING_KEY: "Enter",
            ENTER_NUMBER_KEY: 13,
            ESCAPE_STRING_KEY: "Escape",
            ESCAPE_NUMBER_KEY: 27,
        },
        _ = (t) => {
            const e = t.slice(0, 1),
                s = t.slice(1);
            return e.toUpperCase() + s;
        },
        g = (t) =>
            new Promise((e, s) => {
                setTimeout(e, t);
            }),
        f = (t, e, s, i) => {
            if (!s || !t || !e) return;
            t[`${i}EventListener`](e, s);
        },
        b = (t, e, s) => {
            f(t, e, s, "add");
        },
        v = (t, e, s) => {
            f(t, e, s, "remove");
        },
        y = new IntersectionObserver((t, e) => {
            t.forEach((t) => {
                const e = t.isIntersecting,
                    s = t.target.closest('[aria-hidden="true"], .hidden');
                t.target.toggleAttribute("data-is-in-viewport", e && !s);
            });
        }),
        S = () => ["button", "[href]", "[data-focus-trap-target]", "a", "[tabindex]"].map((t) => `${t}:not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)`).join(","),
        w = (t) => {
            const e = document.createElement("div");
            return e.classList.add("hidden"), document.body.appendChild(e), e.appendChild(t), e;
        },
        C = (t) => {
            t.remove();
        },
        k = (t) => t === m.ENTER_NUMBER_KEY || t === m.ENTER_STRING_KEY,
        E = (t) => t === m.ARROW_RIGHT_NUMBER_KEY || t === m.ARROW_RIGHT_STRING_KEY,
        x = (t) => t === m.ARROW_LEFT_NUMBER_KEY || t === m.ARROW_LEFT_STRING_KEY;
    var I = class {
        constructor() {
            this._listeners = {};
        }
        subscribe(t, e) {
            this._listeners[t] || (this._listeners[t] = []), b(document, p[t], e), this._listeners[t].push(e);
        }
        unsubscribe(t, e) {
            this._listeners[t] && (v(document, p[t], e), (this._listeners[t] = this._listeners[t].filter((t) => t !== e)));
        }
        destroy() {
            Object.keys(this._listeners).forEach((t) => {
                this._listeners[t].forEach((e) => {
                    this.unsubscribe(t, e);
                });
            }),
                (this._listeners = {});
        }
    };
    const { Shopify: L } = window;
    class T extends HTMLElement {
        constructor() {
            super(), (this._editor = new I()), (this._isEditorMode = L.designMode), (this._listeners = {});
        }
        subscribe(t, e) {
            this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e);
        }
        unsubscribe(t, e) {
            this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((t) => t !== e));
        }
        emit(t, e) {
            this._listeners[t] && this._listeners[t].forEach((t) => t(e));
        }
    }
    var M = T;
    var B = class extends M {
        constructor() {
            super(), (this.forms = [...this.querySelectorAll("[data-login-form]")]);
        }
        connectedCallback() {
            this.updateFocus(), this.addEventListener("click", this._handleClick);
        }
        disconnectedCallback() {
            this.removeEventListener("click", this._handleClick);
        }
        _handleClick = (t) => {
            const e = t.target;
            if (e.hasAttribute("data-login-form-button")) {
                const t = e.dataset.loginFormId || "";
                this.setFormVisibleById(t), this.updateFocus();
            }
        };
        setFormVisibleById(t) {
            this.forms.forEach((e) => {
                const s = e.getAttribute("data-login-form") === t;
                e.classList.toggle("hidden", !s);
            });
        }
        updateFocus() {
            this.forms.forEach((t) => {
                const e = t.classList.contains("hidden"),
                    s = t.querySelector('[type="email"]');
                !e && s && s.focus();
            });
        }
    };
    class A extends HTMLElement {
        constructor() {
            super(), (this.button = this.querySelector("[data-back-to-top-button]"));
        }
        connectedCallback() {
            this.button && this.button.addEventListener("click", this._handleButtonClick), window.addEventListener("scroll", this._handleWindowScroll);
        }
        disconnectedCallback() {
            this.button && this.button.removeEventListener("click", this._handleButtonClick), window.removeEventListener("scroll", this._handleWindowScroll);
        }
        _handleWindowScroll = () => {
            this.updateButtonVisible();
        };
        _handleButtonClick = () => {
            this.scrollToTop();
        };
        updateButtonVisible() {
            if (!this.button) return;
            const t = window.scrollY > window.innerHeight;
            this.button.toggleAttribute("visible", t);
        }
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }
    var P = A;
    class D extends HTMLElement {
        constructor() {
            super(), (this.button = this.querySelector("[data-cart-sticky-button]"));
        }
        connectedCallback() {
            window.addEventListener("scroll", this._handleWindowScroll);
        }
        disconnectedCallback() {
            window.removeEventListener("scroll", this._handleWindowScroll);
        }
        _handleWindowScroll = () => {
            const t = document.querySelector(".shopify-section.shopify-section-header");
            if (t && this.button) {
                const e = t.getBoundingClientRect().bottom + this.button.offsetHeight < 0;
                this.button.toggleAttribute("visible", e);
            }
        };
    }
    var q = D;
    var O = class extends M {
        constructor() {
            super(), (this.inputSelector = "[data-quantity-input]"), (this.input = this.querySelector(this.inputSelector)), (this._prevValue = this._value), (this._stockValue = this.dataset.stock || "0");
        }
        connectedCallback() {
            this._updateButtonsDisabled(), b(this.input, "keypress", this._handleKeydown), b(this.input, "input", this._handleInput), b(this.input, "blur", this._handleBlur);
        }
        disconnectedCallback() {
            v(this.input, "keypress", this._handleKeydown), v(this.input, "input", this._handleInput), v(this.input, "blur", this._handleBlur);
        }
        _handleBlur = (t) => {
            if (this.input) {
                const e = t.target.value || "0";
                (this.input.value = e), this._updateButtonsDisabled(), (this._prevValue = e);
            }
        };
        _handleKeydown = (t) => {
            if (this.input) {
                k(t.key || t.keyCode) && (t.preventDefault(), this.input.blur());
            }
        };
        _handleInput = (t) => {
            if (this.input) {
                const e = t.target.value;
                (this.input.value = this._isMoreThanStock ? this._stockValue : e), this._updateButtonsDisabled(), (this._prevValue = e);
            }
        };
        inputChange(t) {
            this.input && ("minus" === t ? this.input.stepDown() : this.input.stepUp(), +this._prevValue != +this._value && this.input.dispatchEvent(new Event("change", { bubbles: !0 })), this._updateButtonsDisabled());
        }
        _updateButtonsDisabled() {
            this._updateButtonDisabled("minus", this._isLessThanMin), this._updateButtonDisabled("plus", this._isMoreThanStock);
        }
        setDisable(t) {
            this._updateButtonDisabled("minus", t), this._updateButtonDisabled("plus", t);
        }
        _updateButtonDisabled(t, e) {
            const s = this.querySelector(`quantity-btn[data-action="${t}"]`);
            s && s.toggleAttribute("disabled", e);
        }
        get _value() {
            return this.input ? this.input.value : "0";
        }
        get _isLessThanMin() {
            return !!this.input && +this._value <= +this.input.min;
        }
        get _isMoreThanStock() {
            return +this._value >= +this._stockValue;
        }
    };
    var R = class extends M {
        constructor() {
            super(), (this._quantity = this.closest("quantity-component"));
        }
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = (t) => {
            t.preventDefault(), this.update();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            const e = k(t.key || t.keyCode),
                s = t.target;
            e && !s.hasAttribute("disabled") && (t.preventDefault(), this.update());
        };
        update() {
            const t = this.dataset.action;
            this._quantity && t && (this._quantity.inputChange(t), "minus" === t && this._setDisabled());
        }
        _setDisabled() {
            if (this._quantity && this._quantity.input) {
                const t = "1" === this._quantity.input.value;
                this.toggleAttribute("disabled", t);
            }
        }
    };
    var F = class extends M {
        constructor() {
            super(), (this.inputSelector = "[data-localization-input]"), (this.formSelector = "form"), (this.input = this.querySelector(this.inputSelector)), (this.form = this.querySelector(this.formSelector));
        }
        connectedCallback() {
            b(this, "click", this._handleClick);
        }
        disconnectedCallback() {
            v(this, "click", this._handleClick);
        }
        _handleClick = (t) => {
            t.preventDefault();
            const e = t.target;
            e.hasAttribute("data-localization-item") && this.input && this.form && e.dataset.value && ((this.input.value = e.dataset.value), this.form.submit());
        };
    };
    var N = class extends M {
        constructor() {
            super(),
                (this._closeBtnSelector = "[data-notification-close-button]"),
                (this._alertSelector = "[data-notification-alert]"),
                (this._alertTextSelector = "[data-notification-alert-text]"),
                (this._closeBtn = this.querySelector(this._closeBtnSelector)),
                (this._alert = this.querySelector(this._alertSelector)),
                (this._alertText = this.querySelector(this._alertTextSelector));
        }
        connectedCallback() {
            this._closeBtn && this._closeBtn.addEventListener("click", this._handleCloseButtonClick);
        }
        disconnectedCallback() {
            this._closeBtn && this._closeBtn.removeEventListener("click", this._handleCloseButtonClick);
        }
        _handleCloseButtonClick = () => {
            this.hide();
        };
        show(t, e) {
            this._setAlert(t, e || "warning"),
                this.showTimeoutId && clearTimeout(this.showTimeoutId),
                this._setVisible(!0),
                (this.showTimeoutId = setTimeout(() => {
                    this._setVisible(!1);
                }, 3e3));
        }
        hide() {
            this._setVisible(!1);
        }
        _setVisible(t) {
            this.toggleAttribute("open", t);
        }
        _setAlert(t, e) {
            this._alert && this._alertText && (this._alert.setAttribute("alert-type", e), (this._alertText.innerHTML = t));
        }
    };
    var H = class {
        constructor(t) {
            this.element = t;
        }
        update(t) {
            const e = t === this.element.getAttribute("data-id");
            this.element.classList.toggle("selected", e);
        }
    };
    const V = (t) => {
            t && t.classList.remove("hidden");
        },
        z = (t) => {
            t && t.classList.add("hidden");
        },
        $ = (t, e) => getComputedStyle(t)[e],
        K = (t) => 1e3 * parseFloat($(t, "transitionDuration")),
        W = (t) => 1e3 * parseFloat($(t, "transitionDelay")),
        U = (t) => t.content.cloneNode(!0),
        Y = (t) => t.content.firstElementChild.cloneNode(!0),
        X = (t, e) => {
            t && t.classList.toggle("forward-transition", e);
        },
        Q = (t) => new DOMParser().parseFromString(t, "text/html");
    var j = class extends M {
        constructor() {
            super(),
                (this.containerSelector = "[data-tabs-container]"),
                (this.templateSelector = "[data-tabs-elements-template]"),
                (this.tabSelector = "tab-component"),
                (this.tabNameSelector = "[data-tabs-name]"),
                (this.container = this.querySelector(this.containerSelector)),
                (this.template = this.querySelector(this.templateSelector)),
                (this.templateContent = U(this.template)),
                (this.tabNames = [...this.querySelectorAll(this.tabNameSelector)]),
                (this.tabMap = this.generateTabMap());
        }
        connectedCallback() {
            this.tabNames.forEach((t) => {
                t.addEventListener("keydown", this._handleKeyDown), t.addEventListener("click", this._handleTabNameClick);
            });
        }
        disconnectedCallback() {
            this.tabNames.forEach((t) => {
                t.removeEventListener("keydown", this._handleKeyDown), t.removeEventListener("click", this._handleTabNameClick);
            });
        }
        _handleTabNameClick = (t) => {
            t.preventDefault();
            const e = t.target;
            e.dataset.id && this.selectTab(e.dataset.id);
        };
        _handleKeyDown = (t) => {
            const e = t.target;
            if (!e.dataset.id) return;
            k(t.key || t.keyCode) && (t.preventDefault(), this.selectTab(e.dataset.id));
        };
        generateTabMap() {
            return [this.querySelector(this.tabSelector), ...this.templateContent.querySelectorAll(this.tabSelector)].reduce((t, e) => {
                const s = e.dataset.id;
                return s ? { ...t, [s]: e } : t;
            }, {});
        }
        selectTab(t) {
            this._updateNameById(t), this._setTabById(t), this.emit("selectTab", t);
        }
        _unmountTab(t) {
            t.remove();
        }
        _mountTab(t) {
            this.container && this.container.appendChild(t);
        }
        _updateNameById(t) {
            this.tabNames.forEach((e) => {
                new H(e).update(t);
            });
        }
        _setTabById(t) {
            const e = this.tabMap[t],
                s = this.tabMap[this.dataset.selectedTabId];
            s && e && (this.showNextTab(e), s !== e && this.hideCurrentTab(s));
        }
        showNextTab(t) {
            const e = t.getAttribute("data-id");
            e && (this._mountTab(t), t.show(), (this.dataset.selectedTabId = e));
        }
        hideCurrentTab(t) {
            t.hide().then(() => {
                this._unmountTab(t);
            });
        }
    };
    var G = class extends M {
        constructor() {
            super(),
                (this.itemSelector = "[data-list-item]"),
                (this.expandBtnSelector = 'list-btn[data-trigger="expand"]'),
                (this.collapseBtnSelector = 'list-btn[data-trigger="collapse"]'),
                (this.visibleItemSelector = `${this.itemSelector}:not(.hidden)`),
                (this.hiddenItemSelector = `${this.itemSelector}.hidden`),
                (this._expandBtn = this.querySelector(this.expandBtnSelector)),
                (this._collapseBtn = this.querySelector(this.collapseBtnSelector));
        }
        _setInitialHeight() {
            (this._initialHeight = this.offsetHeight), (this.style.maxHeight = `${this._initialHeight}px`);
        }
        _setMaxHeight() {
            (this._maxHeight = this.scrollHeight), (this.style.maxHeight = `${this._maxHeight}px`);
        }
        collapse = () => {
            this._hideItems(), z(this._collapseBtn), V(this._expandBtn);
        };
        expand = () => {
            this._initialHeight || this._setInitialHeight(), this._showItems(), this._tryHideExpandBtn(), V(this._collapseBtn), this._setMaxHeight();
        };
        _hideItems() {
            const t = this.querySelectorAll(this.visibleItemSelector),
                e = K(this);
            (this.style.maxHeight = `${this._initialHeight}px`),
                setTimeout(() => {
                    t.forEach((t, e) => {
                        e + 1 > +(this.dataset.initialCount ? +this.dataset.initialCount : 0) && z(t);
                    });
                }, e);
        }
        _showItems() {
            this.querySelectorAll(this.hiddenItemSelector).forEach((t, e) => {
                e + 1 < +(this.dataset.showCount ? this.dataset.showCount : 0) && V(t);
            }),
                (this.style.maxHeight = `${this._maxHeight}px`);
        }
        _tryHideExpandBtn() {
            0 === this.querySelectorAll(this.hiddenItemSelector).length && z(this._expandBtn);
        }
    };
    var Z = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.update();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.update());
        };
        update() {
            const t = this.closest("list-component");
            t && ("collapse" === this.dataset.trigger ? t.collapse() : t.expand(), this.emit("click", t));
        }
    };
    function J(t) {
        return t.split("-")[1];
    }
    function tt(t) {
        return "y" === t ? "height" : "width";
    }
    function et(t) {
        return t.split("-")[0];
    }
    function st(t) {
        return ["top", "bottom"].includes(et(t)) ? "x" : "y";
    }
    function it(t, e, s) {
        let { reference: i, floating: n } = t;
        const o = i.x + i.width / 2 - n.width / 2,
            a = i.y + i.height / 2 - n.height / 2,
            r = st(e),
            l = tt(r),
            c = i[l] / 2 - n[l] / 2,
            h = "x" === r;
        let d;
        switch (et(e)) {
            case "top":
                d = { x: o, y: i.y - n.height };
                break;
            case "bottom":
                d = { x: o, y: i.y + i.height };
                break;
            case "right":
                d = { x: i.x + i.width, y: a };
                break;
            case "left":
                d = { x: i.x - n.width, y: a };
                break;
            default:
                d = { x: i.x, y: i.y };
        }
        switch (J(e)) {
            case "start":
                d[r] -= c * (s && h ? -1 : 1);
                break;
            case "end":
                d[r] += c * (s && h ? -1 : 1);
        }
        return d;
    }
    const nt = async (t, e, s) => {
        const { placement: i = "bottom", strategy: n = "absolute", middleware: o = [], platform: a } = s,
            r = o.filter(Boolean),
            l = await (null == a.isRTL ? void 0 : a.isRTL(e));
        let c = await a.getElementRects({ reference: t, floating: e, strategy: n }),
            { x: h, y: d } = it(c, i, l),
            u = i,
            p = {},
            m = 0;
        for (let s = 0; s < r.length; s++) {
            const { name: o, fn: _ } = r[s],
                { x: g, y: f, data: b, reset: v } = await _({ x: h, y: d, initialPlacement: i, placement: u, strategy: n, middlewareData: p, rects: c, platform: a, elements: { reference: t, floating: e } });
            (h = null != g ? g : h),
                (d = null != f ? f : d),
                (p = { ...p, [o]: { ...p[o], ...b } }),
                v &&
                    m <= 50 &&
                    (m++,
                    "object" == typeof v && (v.placement && (u = v.placement), v.rects && (c = !0 === v.rects ? await a.getElementRects({ reference: t, floating: e, strategy: n }) : v.rects), ({ x: h, y: d } = it(c, u, l))),
                    (s = -1));
        }
        return { x: h, y: d, placement: u, strategy: n, middlewareData: p };
    };
    function ot(t) {
        return "number" != typeof t
            ? (function (t) {
                  return { top: 0, right: 0, bottom: 0, left: 0, ...t };
              })(t)
            : { top: t, right: t, bottom: t, left: t };
    }
    function at(t) {
        return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
    }
    async function rt(t, e) {
        var s;
        void 0 === e && (e = {});
        const { x: i, y: n, platform: o, rects: a, elements: r, strategy: l } = t,
            { boundary: c = "clippingAncestors", rootBoundary: h = "viewport", elementContext: d = "floating", altBoundary: u = !1, padding: p = 0 } = e,
            m = ot(p),
            _ = r[u ? ("floating" === d ? "reference" : "floating") : d],
            g = at(
                await o.getClippingRect({
                    element: null == (s = await (null == o.isElement ? void 0 : o.isElement(_))) || s ? _ : _.contextElement || (await (null == o.getDocumentElement ? void 0 : o.getDocumentElement(r.floating))),
                    boundary: c,
                    rootBoundary: h,
                    strategy: l,
                })
            ),
            f = "floating" === d ? { ...a.floating, x: i, y: n } : a.reference,
            b = await (null == o.getOffsetParent ? void 0 : o.getOffsetParent(r.floating)),
            v = ((await (null == o.isElement ? void 0 : o.isElement(b))) && (await (null == o.getScale ? void 0 : o.getScale(b)))) || { x: 1, y: 1 },
            y = at(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: f, offsetParent: b, strategy: l }) : f);
        return { top: (g.top - y.top + m.top) / v.y, bottom: (y.bottom - g.bottom + m.bottom) / v.y, left: (g.left - y.left + m.left) / v.x, right: (y.right - g.right + m.right) / v.x };
    }
    const lt = Math.min,
        ct = Math.max;
    function ht(t, e, s) {
        return ct(t, lt(e, s));
    }
    const dt = (t) => ({
            name: "arrow",
            options: t,
            async fn(e) {
                const { element: s, padding: i = 0 } = t || {},
                    { x: n, y: o, placement: a, rects: r, platform: l, elements: c } = e;
                if (null == s) return {};
                const h = ot(i),
                    d = { x: n, y: o },
                    u = st(a),
                    p = tt(u),
                    m = await l.getDimensions(s),
                    _ = "y" === u,
                    g = _ ? "top" : "left",
                    f = _ ? "bottom" : "right",
                    b = _ ? "clientHeight" : "clientWidth",
                    v = r.reference[p] + r.reference[u] - d[u] - r.floating[p],
                    y = d[u] - r.reference[u],
                    S = await (null == l.getOffsetParent ? void 0 : l.getOffsetParent(s));
                let w = S ? S[b] : 0;
                (w && (await (null == l.isElement ? void 0 : l.isElement(S)))) || (w = c.floating[b] || r.floating[p]);
                const C = v / 2 - y / 2,
                    k = h[g],
                    E = w - m[p] - h[f],
                    x = w / 2 - m[p] / 2 + C,
                    I = ht(k, x, E),
                    L = null != J(a) && x != I && r.reference[p] / 2 - (x < k ? h[g] : h[f]) - m[p] / 2 < 0;
                return { [u]: d[u] - (L ? (x < k ? k - x : E - x) : 0), data: { [u]: I, centerOffset: x - I } };
            },
        }),
        ut = { left: "right", right: "left", bottom: "top", top: "bottom" };
    function pt(t) {
        return t.replace(/left|right|bottom|top/g, (t) => ut[t]);
    }
    function mt(t, e, s) {
        void 0 === s && (s = !1);
        const i = J(t),
            n = st(t),
            o = tt(n);
        let a = "x" === n ? (i === (s ? "end" : "start") ? "right" : "left") : "start" === i ? "bottom" : "top";
        return e.reference[o] > e.floating[o] && (a = pt(a)), { main: a, cross: pt(a) };
    }
    const _t = { start: "end", end: "start" };
    function gt(t) {
        return t.replace(/start|end/g, (t) => _t[t]);
    }
    const ft = function (t) {
        return (
            void 0 === t && (t = {}),
            {
                name: "flip",
                options: t,
                async fn(e) {
                    var s;
                    const { placement: i, middlewareData: n, rects: o, initialPlacement: a, platform: r, elements: l } = e,
                        { mainAxis: c = !0, crossAxis: h = !0, fallbackPlacements: d, fallbackStrategy: u = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ..._ } = t,
                        g = et(i),
                        f = et(a) === a,
                        b = await (null == r.isRTL ? void 0 : r.isRTL(l.floating)),
                        v =
                            d ||
                            (f || !m
                                ? [pt(a)]
                                : (function (t) {
                                      const e = pt(t);
                                      return [gt(t), e, gt(e)];
                                  })(a));
                    d ||
                        "none" === p ||
                        v.push(
                            ...(function (t, e, s, i) {
                                const n = J(t);
                                let o = (function (t, e, s) {
                                    const i = ["left", "right"],
                                        n = ["right", "left"],
                                        o = ["top", "bottom"],
                                        a = ["bottom", "top"];
                                    switch (t) {
                                        case "top":
                                        case "bottom":
                                            return s ? (e ? n : i) : e ? i : n;
                                        case "left":
                                        case "right":
                                            return e ? o : a;
                                        default:
                                            return [];
                                    }
                                })(et(t), "start" === s, i);
                                return n && ((o = o.map((t) => t + "-" + n)), e && (o = o.concat(o.map(gt)))), o;
                            })(a, m, p, b)
                        );
                    const y = [a, ...v],
                        S = await rt(e, _),
                        w = [];
                    let C = (null == (s = n.flip) ? void 0 : s.overflows) || [];
                    if ((c && w.push(S[g]), h)) {
                        const { main: t, cross: e } = mt(i, o, b);
                        w.push(S[t], S[e]);
                    }
                    if (((C = [...C, { placement: i, overflows: w }]), !w.every((t) => t <= 0))) {
                        var k, E;
                        const t = ((null == (k = n.flip) ? void 0 : k.index) || 0) + 1,
                            e = y[t];
                        if (e) return { data: { index: t, overflows: C }, reset: { placement: e } };
                        let s = null == (E = C.filter((t) => t.overflows[0] <= 0).sort((t, e) => t.overflows[1] - e.overflows[1])[0]) ? void 0 : E.placement;
                        if (!s)
                            switch (u) {
                                case "bestFit": {
                                    var x;
                                    const t = null == (x = C.map((t) => [t.placement, t.overflows.filter((t) => t > 0).reduce((t, e) => t + e, 0)]).sort((t, e) => t[1] - e[1])[0]) ? void 0 : x[0];
                                    t && (s = t);
                                    break;
                                }
                                case "initialPlacement":
                                    s = a;
                            }
                        if (i !== s) return { reset: { placement: s } };
                    }
                    return {};
                },
            }
        );
    };
    const bt = function (t) {
        return (
            void 0 === t && (t = 0),
            {
                name: "offset",
                options: t,
                async fn(e) {
                    const { x: s, y: i } = e,
                        n = await (async function (t, e) {
                            const { placement: s, platform: i, elements: n } = t,
                                o = await (null == i.isRTL ? void 0 : i.isRTL(n.floating)),
                                a = et(s),
                                r = J(s),
                                l = "x" === st(s),
                                c = ["left", "top"].includes(a) ? -1 : 1,
                                h = o && l ? -1 : 1,
                                d = "function" == typeof e ? e(t) : e;
                            let { mainAxis: u, crossAxis: p, alignmentAxis: m } = "number" == typeof d ? { mainAxis: d, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...d };
                            return r && "number" == typeof m && (p = "end" === r ? -1 * m : m), l ? { x: p * h, y: u * c } : { x: u * c, y: p * h };
                        })(e, t);
                    return { x: s + n.x, y: i + n.y, data: n };
                },
            }
        );
    };
    function vt(t) {
        return "x" === t ? "y" : "x";
    }
    const yt = function (t) {
        return (
            void 0 === t && (t = {}),
            {
                name: "shift",
                options: t,
                async fn(e) {
                    const { x: s, y: i, placement: n } = e,
                        {
                            mainAxis: o = !0,
                            crossAxis: a = !1,
                            limiter: r = {
                                fn: (t) => {
                                    let { x: e, y: s } = t;
                                    return { x: e, y: s };
                                },
                            },
                            ...l
                        } = t,
                        c = { x: s, y: i },
                        h = await rt(e, l),
                        d = st(et(n)),
                        u = vt(d);
                    let p = c[d],
                        m = c[u];
                    if (o) {
                        const t = "y" === d ? "bottom" : "right";
                        p = ht(p + h["y" === d ? "top" : "left"], p, p - h[t]);
                    }
                    if (a) {
                        const t = "y" === u ? "bottom" : "right";
                        m = ht(m + h["y" === u ? "top" : "left"], m, m - h[t]);
                    }
                    const _ = r.fn({ ...e, [d]: p, [u]: m });
                    return { ..._, data: { x: _.x - s, y: _.y - i } };
                },
            }
        );
    };
    function St(t) {
        var e;
        return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
    }
    function wt(t) {
        return St(t).getComputedStyle(t);
    }
    function Ct(t) {
        return t instanceof St(t).Node;
    }
    function kt(t) {
        return Ct(t) ? (t.nodeName || "").toLowerCase() : "";
    }
    let Et;
    function xt() {
        if (Et) return Et;
        const t = navigator.userAgentData;
        return t && Array.isArray(t.brands) ? ((Et = t.brands.map((t) => t.brand + "/" + t.version).join(" ")), Et) : navigator.userAgent;
    }
    function It(t) {
        return t instanceof St(t).HTMLElement;
    }
    function Lt(t) {
        return t instanceof St(t).Element;
    }
    function Tt(t) {
        if ("undefined" == typeof ShadowRoot) return !1;
        return t instanceof St(t).ShadowRoot || t instanceof ShadowRoot;
    }
    function Mt(t) {
        const { overflow: e, overflowX: s, overflowY: i, display: n } = wt(t);
        return /auto|scroll|overlay|hidden|clip/.test(e + i + s) && !["inline", "contents"].includes(n);
    }
    function Bt(t) {
        return ["table", "td", "th"].includes(kt(t));
    }
    function At(t) {
        const e = /firefox/i.test(xt()),
            s = wt(t),
            i = s.backdropFilter || s.WebkitBackdropFilter;
        return (
            "none" !== s.transform ||
            "none" !== s.perspective ||
            (!!i && "none" !== i) ||
            (e && "filter" === s.willChange) ||
            (e && !!s.filter && "none" !== s.filter) ||
            ["transform", "perspective"].some((t) => s.willChange.includes(t)) ||
            ["paint", "layout", "strict", "content"].some((t) => {
                const e = s.contain;
                return null != e && e.includes(t);
            })
        );
    }
    function Pt() {
        return /^((?!chrome|android).)*safari/i.test(xt());
    }
    function Dt(t) {
        return ["html", "body", "#document"].includes(kt(t));
    }
    const qt = Math.min,
        Ot = Math.max,
        Rt = Math.round;
    function Ft(t) {
        const e = wt(t);
        let s = parseFloat(e.width),
            i = parseFloat(e.height);
        const n = It(t),
            o = n ? t.offsetWidth : s,
            a = n ? t.offsetHeight : i,
            r = Rt(s) !== o || Rt(i) !== a;
        return r && ((s = o), (i = a)), { width: s, height: i, fallback: r };
    }
    function Nt(t) {
        return Lt(t) ? t : t.contextElement;
    }
    const Ht = { x: 1, y: 1 };
    function Vt(t) {
        const e = Nt(t);
        if (!It(e)) return Ht;
        const s = e.getBoundingClientRect(),
            { width: i, height: n, fallback: o } = Ft(e);
        let a = (o ? Rt(s.width) : s.width) / i,
            r = (o ? Rt(s.height) : s.height) / n;
        return (a && Number.isFinite(a)) || (a = 1), (r && Number.isFinite(r)) || (r = 1), { x: a, y: r };
    }
    function zt(t, e, s, i) {
        var n, o;
        void 0 === e && (e = !1), void 0 === s && (s = !1);
        const a = t.getBoundingClientRect(),
            r = Nt(t);
        let l = Ht;
        e && (i ? Lt(i) && (l = Vt(i)) : (l = Vt(t)));
        const c = r ? St(r) : window,
            h = Pt() && s;
        let d = (a.left + ((h && (null == (n = c.visualViewport) ? void 0 : n.offsetLeft)) || 0)) / l.x,
            u = (a.top + ((h && (null == (o = c.visualViewport) ? void 0 : o.offsetTop)) || 0)) / l.y,
            p = a.width / l.x,
            m = a.height / l.y;
        if (r) {
            const t = St(r),
                e = i && Lt(i) ? St(i) : i;
            let s = t.frameElement;
            for (; s && i && e !== t; ) {
                const t = Vt(s),
                    e = s.getBoundingClientRect(),
                    i = getComputedStyle(s);
                (e.x += (s.clientLeft + parseFloat(i.paddingLeft)) * t.x), (e.y += (s.clientTop + parseFloat(i.paddingTop)) * t.y), (d *= t.x), (u *= t.y), (p *= t.x), (m *= t.y), (d += e.x), (u += e.y), (s = St(s).frameElement);
            }
        }
        return at({ width: p, height: m, x: d, y: u });
    }
    function $t(t) {
        return ((Ct(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function Kt(t) {
        return Lt(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
    }
    function Wt(t) {
        return zt($t(t)).left + Kt(t).scrollLeft;
    }
    function Ut(t) {
        if ("html" === kt(t)) return t;
        const e = t.assignedSlot || t.parentNode || (Tt(t) && t.host) || $t(t);
        return Tt(e) ? e.host : e;
    }
    function Yt(t) {
        const e = Ut(t);
        return Dt(e) ? e.ownerDocument.body : It(e) && Mt(e) ? e : Yt(e);
    }
    function Xt(t, e) {
        var s;
        void 0 === e && (e = []);
        const i = Yt(t),
            n = i === (null == (s = t.ownerDocument) ? void 0 : s.body),
            o = St(i);
        return n ? e.concat(o, o.visualViewport || [], Mt(i) ? i : []) : e.concat(i, Xt(i));
    }
    function Qt(t, e, s) {
        let i;
        if ("viewport" === e)
            i = (function (t, e) {
                const s = St(t),
                    i = $t(t),
                    n = s.visualViewport;
                let o = i.clientWidth,
                    a = i.clientHeight,
                    r = 0,
                    l = 0;
                if (n) {
                    (o = n.width), (a = n.height);
                    const t = Pt();
                    (!t || (t && "fixed" === e)) && ((r = n.offsetLeft), (l = n.offsetTop));
                }
                return { width: o, height: a, x: r, y: l };
            })(t, s);
        else if ("document" === e)
            i = (function (t) {
                const e = $t(t),
                    s = Kt(t),
                    i = t.ownerDocument.body,
                    n = Ot(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth),
                    o = Ot(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
                let a = -s.scrollLeft + Wt(t);
                const r = -s.scrollTop;
                return "rtl" === wt(i).direction && (a += Ot(e.clientWidth, i.clientWidth) - n), { width: n, height: o, x: a, y: r };
            })($t(t));
        else if (Lt(e))
            i = (function (t, e) {
                const s = zt(t, !0, "fixed" === e),
                    i = s.top + t.clientTop,
                    n = s.left + t.clientLeft,
                    o = It(t) ? Vt(t) : { x: 1, y: 1 };
                return { width: t.clientWidth * o.x, height: t.clientHeight * o.y, x: n * o.x, y: i * o.y };
            })(e, s);
        else {
            const s = { ...e };
            if (Pt()) {
                var n, o;
                const e = St(t);
                (s.x -= (null == (n = e.visualViewport) ? void 0 : n.offsetLeft) || 0), (s.y -= (null == (o = e.visualViewport) ? void 0 : o.offsetTop) || 0);
            }
            i = s;
        }
        return at(i);
    }
    function jt(t, e) {
        const s = Ut(t);
        return !(s === e || !Lt(s) || Dt(s)) && ("fixed" === wt(s).position || jt(s, e));
    }
    function Gt(t, e) {
        return It(t) && "fixed" !== wt(t).position ? (e ? e(t) : t.offsetParent) : null;
    }
    function Zt(t, e) {
        const s = St(t);
        if (!It(t)) return s;
        let i = Gt(t, e);
        for (; i && Bt(i) && "static" === wt(i).position; ) i = Gt(i, e);
        return i && ("html" === kt(i) || ("body" === kt(i) && "static" === wt(i).position && !At(i)))
            ? s
            : i ||
                  (function (t) {
                      let e = Ut(t);
                      for (; It(e) && !Dt(e); ) {
                          if (At(e)) return e;
                          e = Ut(e);
                      }
                      return null;
                  })(t) ||
                  s;
    }
    function Jt(t, e, s) {
        const i = It(e),
            n = $t(e),
            o = zt(t, !0, "fixed" === s, e);
        let a = { scrollLeft: 0, scrollTop: 0 };
        const r = { x: 0, y: 0 };
        if (i || (!i && "fixed" !== s))
            if ((("body" !== kt(e) || Mt(n)) && (a = Kt(e)), It(e))) {
                const t = zt(e, !0);
                (r.x = t.x + e.clientLeft), (r.y = t.y + e.clientTop);
            } else n && (r.x = Wt(n));
        return { x: o.left + a.scrollLeft - r.x, y: o.top + a.scrollTop - r.y, width: o.width, height: o.height };
    }
    const te = {
        getClippingRect: function (t) {
            let { element: e, boundary: s, rootBoundary: i, strategy: n } = t;
            const o = [
                    ...("clippingAncestors" === s
                        ? (function (t, e) {
                              const s = e.get(t);
                              if (s) return s;
                              let i = Xt(t).filter((t) => Lt(t) && "body" !== kt(t)),
                                  n = null;
                              const o = "fixed" === wt(t).position;
                              let a = o ? Ut(t) : t;
                              for (; Lt(a) && !Dt(a); ) {
                                  const e = wt(a),
                                      s = At(a);
                                  s || "fixed" !== e.position || (n = null),
                                      (o ? !s && !n : (!s && "static" === e.position && n && ["absolute", "fixed"].includes(n.position)) || (Mt(a) && !s && jt(t, a))) ? (i = i.filter((t) => t !== a)) : (n = e),
                                      (a = Ut(a));
                              }
                              return e.set(t, i), i;
                          })(e, this._c)
                        : [].concat(s)),
                    i,
                ],
                a = o[0],
                r = o.reduce((t, s) => {
                    const i = Qt(e, s, n);
                    return (t.top = Ot(i.top, t.top)), (t.right = qt(i.right, t.right)), (t.bottom = qt(i.bottom, t.bottom)), (t.left = Ot(i.left, t.left)), t;
                }, Qt(e, a, n));
            return { width: r.right - r.left, height: r.bottom - r.top, x: r.left, y: r.top };
        },
        convertOffsetParentRelativeRectToViewportRelativeRect: function (t) {
            let { rect: e, offsetParent: s, strategy: i } = t;
            const n = It(s),
                o = $t(s);
            if (s === o) return e;
            let a = { scrollLeft: 0, scrollTop: 0 },
                r = { x: 1, y: 1 };
            const l = { x: 0, y: 0 };
            if ((n || (!n && "fixed" !== i)) && (("body" !== kt(s) || Mt(o)) && (a = Kt(s)), It(s))) {
                const t = zt(s);
                (r = Vt(s)), (l.x = t.x + s.clientLeft), (l.y = t.y + s.clientTop);
            }
            return { width: e.width * r.x, height: e.height * r.y, x: e.x * r.x - a.scrollLeft * r.x + l.x, y: e.y * r.y - a.scrollTop * r.y + l.y };
        },
        isElement: Lt,
        getDimensions: function (t) {
            return Ft(t);
        },
        getOffsetParent: Zt,
        getDocumentElement: $t,
        getScale: Vt,
        async getElementRects(t) {
            let { reference: e, floating: s, strategy: i } = t;
            const n = this.getOffsetParent || Zt,
                o = this.getDimensions;
            return { reference: Jt(e, await n(s), i), floating: { x: 0, y: 0, ...(await o(s)) } };
        },
        getClientRects: (t) => Array.from(t.getClientRects()),
        isRTL: (t) => "rtl" === wt(t).direction,
    };
    const ee = (t, e, s) => {
        const i = new Map(),
            n = { platform: te, ...s },
            o = { ...n.platform, _c: i };
        return nt(t, e, { ...n, platform: o });
    };
    var se = class extends M {
        constructor() {
            super(), (this._withOverlay = this.hasAttribute("data-with-overlay"));
            const t = this.querySelector("template");
            (this.element = Y(t)), (this._arrow = this.element.querySelector("[data-float-element-arrow]"));
        }
        connectedCallback() {
            this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect));
        }
        disconnectedCallback() {
            this._unmount(), this._isEditorMode && this._editor.destroy(), v(window, "wheel", this._handleScroll);
        }
        _handleScroll = () => {
            "tooltip" === this._type && (this.hide(), v(window, "wheel", this._handleScroll));
        };
        _handleBlockSelect = (t) => {
            if (this.dataset.sectionId === t.detail.sectionId) {
                this.element.querySelector(`[block-id="${t.detail.blockId}"]`) && this._btn ? this._btn.trigger() : this.hide();
            }
        };
        _handleBlockDeselect = (t) => {
            if (this.dataset.sectionId === t.detail.sectionId) {
                if (!this.element.querySelector(`[block-id="${t.detail.blockId}"]`)) return;
                this.hide();
            }
        };
        update = () => {
            const t = document.querySelector(`#${this.dataset.floatingElementId}`) || this._btn;
            t &&
                ee(t, this, this._getOptions()).then((t) => {
                    this._updatePosition(t), this._arrow && this._updateArrow(t);
                });
        };
        _updatePosition({ x: t, y: e }) {
            Object.assign(this.style, { left: `${t}px`, top: `${e}px` });
        }
        _getOptions() {
            return { placement: this._placement, middleware: this._getMiddleware(), strategy: this._strategy };
        }
        _getMiddleware() {
            const t = this.dataset.alignmentAxisOffset || 0,
                e = this.dataset.mainAxisOffset || 0,
                s = [bt({ alignmentAxis: +t, mainAxis: +e }), ft(), yt()];
            return this._arrow && s.push(dt({ element: this._arrow })), s;
        }
        checkCursorOutside(t, e) {
            const s = +(this.dataset.mainAxisOffset || 0),
                i = this.getBoundingClientRect(),
                n = i.top - (e + s) > 2,
                o = e - i.bottom - s > 2,
                a = i.left - (t + s) > 2,
                r = t - i.right - s > 2;
            return n || o || a || r;
        }
        _updateArrow({ placement: t, middlewareData: e }) {
            if (!this._arrow) return;
            const { x: s, y: i } = e.arrow,
                n = { top: "bottom", right: "left", bottom: "top", left: "right" }[t.split("-")[0]];
            Object.assign(this._arrow.style, { left: null != s ? `${s}px` : "", top: null != i ? `${i}px` : "", right: "", bottom: "", [n]: "-5px" });
        }
        _mount() {
            this.contains(this.element) || this.appendChild(this.element);
        }
        _unmount() {
            this.isOpen && this._withOverlay && u.hideOverlay(this.id), this.element && this.element.remove();
        }
        playVideos() {
            [...this.element.querySelectorAll("video")].forEach((t) => {
                t.play();
            });
        }
        pauseVideos() {
            [...this.element.querySelectorAll("video")].forEach((t) => {
                t.pause();
            });
        }
        show = () => {
            ("tooltip" === this._type && u.isScrolling) || (this._mount(), this.playVideos(), this._setVisible(!0), this.update(), this.emit("show", {}), b(window, "wheel", this._handleScroll));
        };
        hide = () => {
            this._setVisible(!1), this.pauseVideos(), this._unmount(), this.emit("hide", {});
        };
        _setVisible(t) {
            if ((this.setAttribute("aria-hidden", t ? "false" : "true"), this._btn && this._btn.setExpand(t), this._withOverlay)) {
                const t = { backdropFilter: this.hasAttribute("data-overlay-with-blur") ? "blur(16.5px)" : "none" };
                this.isOpen ? u.showOverlay(this.id, t) : u.hideOverlay(this.id);
            }
        }
        get _btn() {
            return document.querySelector(`[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`);
        }
        get isOpen() {
            return "false" === this.getAttribute("aria-hidden");
        }
        get _strategy() {
            return this.dataset.strategy || "absolute";
        }
        get _type() {
            return this.dataset.type;
        }
        get _placement() {
            return this.dataset.placement || "bottom-end";
        }
    };
    const ie = "http://www.w3.org/2000/svg",
        ne = (t, e) => !(!t || !e) && t.contains(e),
        oe = (t, e) => {
            const s = /apple/i.test(navigator.vendor),
                i = document.defaultView || window,
                n = document.createElementNS(ie, "svg");
            Object.assign(n.style, { position: "fixed", left: `${(s && i.visualViewport?.offsetLeft) || 0}px`, top: `${(s && i.visualViewport?.offsetTop) || 0}px`, width: "100%", height: "100%", pointerEvents: "none", zIndex: 2147483647 }),
                n.setAttribute("data-type", e ? "rect" : "triangle");
            const o = document.createElementNS(ie, "polygon");
            return o.setAttribute("points", t.map(([t, e]) => `${t},${e}`).join(" ")), Object.assign(o.style, { pointerEvents: "auto", fill: "transparent", opacity: 0 }), n.appendChild(o), n;
        },
        ae = (t) => {
            t.current && (t.current.remove(), (t.current = null));
        },
        re = ({ restMs: t = 0, buffer: e = 0.5, blockPointerEvents: s = !0 } = {}) => {
            let i,
                n = !1,
                o = !1;
            return ({ x: a, y: r, placement: l, elements: c, onClose: h, polygonRef: d }) => (u) => {
                const p = () => {
                    ae(d), clearTimeout(i), h();
                };
                if ((clearTimeout(i), !c.domReference || !c.floating || null == l || null == a || null == r)) return;
                const { clientX: m, clientY: _ } = u,
                    g = u.target,
                    f = "mouseleave" === u.type,
                    b = ne(c.domReference, g),
                    v = ne(c.floating, g);
                if (!f && b) return void ae(d);
                if (!f && (b || (n && ne(d.current, g)))) return;
                if (f && (y = u.relatedTarget) && y instanceof (document.defaultView || window).Element && ne(c.floating, u.relatedTarget)) return;
                var y;
                if (c.floating.querySelector('float-element[aria-hidden="false"]')) return;
                if ((v && (o = !0), v && !f && "rect" !== d.current?.dataset.type)) return void ae(d);
                const S = c.domReference.getBoundingClientRect(),
                    w = c.floating.getBoundingClientRect(),
                    C = l.split("-")[0],
                    k = a > w.right - w.width / 2,
                    E = r > w.bottom - w.height / 2;
                if (("top" === C && r >= S.bottom - 1) || ("bottom" === C && r <= S.top + 1) || ("left" === C && a >= S.right - 1) || ("right" === C && a <= S.left + 1)) return p();
                let x = [];
                switch (C) {
                    case "top":
                        (x = [
                            [w.left, S.top + 1],
                            [w.left, w.bottom - 1],
                            [w.right, w.bottom - 1],
                            [w.right, S.top + 1],
                        ]),
                            (n = m >= w.left && m <= w.right && _ >= w.top && _ <= S.top + 1);
                        break;
                    case "bottom":
                        (x = [
                            [w.left, w.top + 1],
                            [w.left, S.bottom - 1],
                            [w.right, S.bottom - 1],
                            [w.right, w.top + 1],
                        ]),
                            (n = m >= w.left && m <= w.right && _ >= S.bottom - 1 && _ <= w.bottom);
                        break;
                    case "left":
                        (x = [
                            [w.right - 1, w.bottom],
                            [w.right - 1, w.top],
                            [S.left + 1, w.top],
                            [S.left + 1, w.bottom],
                        ]),
                            (n = m >= w.left && m <= S.left + 1 && _ >= w.top && _ <= w.bottom);
                        break;
                    case "right":
                        (x = [
                            [S.right - 1, w.bottom],
                            [S.right - 1, w.top],
                            [w.left + 1, w.top],
                            [w.left + 1, w.bottom],
                        ]),
                            (n = m >= S.right - 1 && m <= w.right && _ >= w.top && _ <= w.bottom);
                }
                const I = n
                    ? x
                    : (([t, s]) => {
                          const i = w.width > S.width,
                              n = w.height > S.height;
                          switch (C) {
                              case "top":
                                  return [
                                      [i ? t + e / 2 : k ? t + 4 * e : t - 4 * e, s + e + 1],
                                      [i ? t - e / 2 : k ? t + 4 * e : t - 4 * e, s + e + 1],
                                      ...[
                                          [w.left, k || i ? w.bottom - e : w.top],
                                          [w.right, k ? (i ? w.bottom - e : w.top) : w.bottom - e],
                                      ],
                                  ];
                              case "bottom":
                                  return [
                                      [i ? t + e / 2 : k ? t + 4 * e : t - 4 * e, s - e],
                                      [i ? t - e / 2 : k ? t + 4 * e : t - 4 * e, s - e],
                                      ...[
                                          [w.left, k || i ? w.top + e : w.bottom],
                                          [w.right, k ? (i ? w.top + e : w.bottom) : w.top + e],
                                      ],
                                  ];
                              case "left": {
                                  const i = [t + e + 1, n ? s + e / 2 : E ? s + 4 * e : s - 4 * e],
                                      o = [t + e + 1, n ? s - e / 2 : E ? s + 4 * e : s - 4 * e];
                                  return [
                                      ...[
                                          [E || n ? w.right - e : w.left, w.top],
                                          [E ? (n ? w.right - e : w.left) : w.right - e, w.bottom],
                                      ],
                                      i,
                                      o,
                                  ];
                              }
                              case "right":
                                  return [
                                      [t - e, n ? s + e / 2 : E ? s + 4 * e : s - 4 * e],
                                      [t - e, n ? s - e / 2 : E ? s + 4 * e : s - 4 * e],
                                      ...[
                                          [E || n ? w.left + e : w.right, w.top],
                                          [E ? (n ? w.left + e : w.right) : w.left + e, w.bottom],
                                      ],
                                  ];
                          }
                      })([a, r]);
                !d.current && s && f && ((d.current = oe(I, n)), document.body.appendChild(d.current)),
                    n ||
                        (((t, e) => {
                            const [s, i] = t;
                            let n = !1;
                            const o = e.length;
                            for (let t = 0, a = o - 1; t < o; a = t++) {
                                const [o, r] = e[t] || [0, 0],
                                    [l, c] = e[a] || [0, 0];
                                r >= i != c >= i && s <= ((l - o) * (i - r)) / (c - r) + o && (n = !n);
                            }
                            return n;
                        })([m, _], I)
                            ? t && !o && (i = setTimeout(h, t))
                            : p());
            };
        };
    var le = class extends M {
        constructor() {
            super(), (this._trigger = "click" === this.dataset.trigger ? "click" : "mouseenter"), (this.element = this.getElement()), (this.polygonRef = { current: null });
        }
        connectedCallback() {
            b(this.element, "focus", this._handleFocus),
                b(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                    ? (b(window, "click", this._handleWindowClick), b(this.element, "click", this._handleElementClick))
                    : (b(this.element, "mouseleave", this._handleMouseLeave), b(this.element, "mouseenter", this._handleMouseEnter));
        }
        disconnectedCallback() {
            v(this.element, "focus", this._handleFocus),
                v(this.element, "blur", this._handleBlur),
                "click" === this.dataset.trigger
                    ? (v(window, "click", this._handleWindowClick), v(this.element, "click", this._handleElementClick))
                    : (v(this.element, "mouseleave", this._handleMouseLeave), v(this.element, "mouseenter", this._handleMouseEnter));
        }
        _handleBlur = () => {
            this.blurElementTimeoutId = setTimeout(() => {
                this._floatElement && this._floatElement.hide();
            }, 0);
        };
        _handleFocus = () => {
            this._floatElement.show(), this.setTargetListeners("add");
        };
        _handleFirstTargetFocus = () => {
            clearTimeout(this.blurElementTimeoutId);
        };
        _handleTargetFocus = () => {
            clearTimeout(this.blurLastTargetTimeoutId);
        };
        _handleLastTargetBlur = () => {
            this.blurLastTargetTimeoutId = setTimeout(() => {
                this.setTargetListeners("remove"), this._floatElement.hide();
            }, 0);
        };
        _handleMouseEnter = () => {
            this.mouseenterTimeout = setTimeout(() => {
                this.trigger();
            }, 0);
        };
        _handleElementClick = () => {
            this.trigger();
        };
        _handleWindowClick = (t) => {
            const e = this._floatElement.checkCursorOutside(t.clientX, t.clientX),
                s = this._isTargetOutsideFloatElements(t.target);
            e && s && (v(window, "click", this._handleWindowClick), this._floatElement.hide());
        };
        _handleMouseLeave = (t) => {
            clearTimeout(this.mouseenterTimeout),
                this.safePolygonFn && window.removeEventListener("mousemove", this._handleMouseMove),
                (this.safePolygonFn = re()({
                    x: t.clientX,
                    y: t.clientY,
                    placement: this._floatElement.dataset.placement,
                    onClose: () => {
                        window.removeEventListener("mousemove", this._handleMouseMove), this._floatElement && this._floatElement.hide(), ae(this.polygonRef);
                    },
                    elements: { domReference: this.element, floating: this._floatElement },
                    polygonRef: this.polygonRef,
                })),
                this.safePolygonFn(t),
                window.addEventListener("mousemove", this._handleMouseMove);
        };
        _handleMouseMove = (t) => {
            this.safePolygonFn(t);
        };
        setTargetListeners(t) {
            const { targets: e, firstTarget: s, lastTarget: i } = this.getTargets(),
                n = "add" === t ? b : v;
            n(s, "focus", this._handleFirstTargetFocus),
                e.forEach((t) => {
                    n(t, "focus", this._handleTargetFocus);
                }),
                n(i, "blur", this._handleLastTargetBlur),
                n(window, "click", this._handleWindowClick);
        }
        getElement() {
            const t = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
            return this.querySelector(t) || this;
        }
        getTargets() {
            const t = [...this._floatElement.element.querySelectorAll(S())];
            return { targets: t, firstTarget: t[0], lastTarget: t[t.length - 1] };
        }
        _isTargetOutsideFloatElements(t) {
            const e = this._floatElement.contains(t),
                s = this.contains(t);
            return !e && !s;
        }
        trigger = () => {
            "click" === this._trigger
                ? (this._floatElement.isOpen ? this._floatElement.hide() : this._floatElement.show(), b(window, "click", this._handleWindowClick))
                : (this._floatElement.show(), b(this.element, "mouseleave", this._handleMouseLeave));
        };
        setExpand(t) {
            this.setAttribute("data-aria-expanded", t);
        }
        get _floatElement() {
            if (this.dataset.floatElementId) return document.getElementById(this.dataset.floatElementId);
        }
        get isOpen() {
            return this._floatElement.isOpen;
        }
    };
    var ce = class extends M {
        constructor() {
            super(), (this.element = this.getElement());
        }
        connectedCallback() {
            this._floatElement && (customElements.upgrade(this._floatElement), this._floatElement.subscribe("show", this._handleDropdownShow), this._floatElement.subscribe("hide", this._handleDropdownHide)),
                b(this.element, "blur", this._handleBlur),
                b(this.element, "keyup", this._handleKeyUp),
                b(this.element, "mousedown", this._handleTrigger);
        }
        disconnectedCallback() {
            this._floatElement && (this._floatElement.unsubscribe("show", this._handleDropdownShow), this._floatElement.unsubscribe("hide", this._handleDropdownHide)),
                v(this.element, "blur", this._handleBlur),
                v(this.element, "keyup", this._handleKeyUp),
                v(this.element, "mousedown", this._handleTrigger),
                v(window, "click", this._handleUntrigger);
        }
        _handleBlur = () => {
            const { targets: t } = this.getTargets();
            this.blurElementTimeoutId = setTimeout(() => {
                if (!t.includes(document.activeElement)) {
                    if (!this._floatElement) return;
                    this.setTargetListeners("remove"), this._floatElement.hide();
                }
            }, 0);
        };
        _handleDropdownShow = () => {
            b(window, "keydown", this._handleDropdownKeyDown);
        };
        _handleDropdownHide = () => {
            v(window, "keydown", this._handleDropdownKeyDown);
        };
        _handleKeyUp = (t) => {
            if (!this._floatElement) return;
            const e = t.key || t.keyCode;
            k(e) && (this._floatElement.isOpen || (this._floatElement.show(), this.setTargetListeners("add")));
        };
        _handleDropdownKeyDown = (t) => {
            if (!this._floatElement) return;
            const e = t.key || t.keyCode,
                s = e === m.ESCAPE_STRING_KEY || e === m.ESCAPE_NUMBER_KEY;
            this._floatElement.isOpen && s && (this.element.focus(), this.setTargetListeners("remove"), this._floatElement.hide());
        };
        _handleFirstTargetFocus = () => {
            clearTimeout(this.blurElementTimeoutId);
        };
        _handleTargetFocus = () => {
            clearTimeout(this.blurLastTargetTimeoutId);
        };
        _handleLastTargetBlur = () => {
            this.blurLastTargetTimeoutId = setTimeout(() => {
                this._floatElement && (this.setTargetListeners("remove"), this._floatElement.hide());
            }, 0);
        };
        _handleTrigger = () => {
            this.trigger();
        };
        _handleUntrigger = ({ clientX: t, clientY: e, target: s }) => {
            if (!this._floatElement) return;
            const i = this._floatElement.checkCursorOutside(t, e),
                n = this._isTargetOutsideFloatElements(s);
            i && n && (this._floatElement.hide(), v(window, "click", this._handleUntrigger));
        };
        setTargetListeners(t) {
            const { targets: e, firstTarget: s, lastTarget: i } = this.getTargets(),
                n = "add" === t ? b : v;
            n(s, "focus", this._handleFirstTargetFocus),
                e.forEach((t) => {
                    n(t, "focus", this._handleTargetFocus);
                }),
                n(i, "blur", this._handleLastTargetBlur),
                n(window, "click", this._handleUntrigger);
        }
        getTargets() {
            if (!this._floatElement) return;
            const t = [...this._floatElement.element.querySelectorAll(S())];
            return { targets: t, firstTarget: t[0], lastTarget: t[t.length - 1] };
        }
        _isTargetOutsideFloatElements(t) {
            if (!this._floatElement) return;
            const e = this._floatElement.contains(t),
                s = this.contains(t);
            return !e && !s;
        }
        getElement() {
            const t = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
            return this.querySelector(t) || this;
        }
        trigger = () => {
            this._floatElement && (this._floatElement.isOpen ? this._floatElement.hide() : this._floatElement.show(), b(window, "click", this._handleUntrigger));
        };
        setExpand(t) {
            this.setAttribute("data-aria-expanded", t);
        }
        get _floatElement() {
            return document.querySelector(`#${this.dataset.floatElementId}`);
        }
    };
    var he = class extends M {
        connectedCallback() {
            b(this, "mouseenter", this._handleMouseEnter), b(this, "mouseleave", this._handleMouseLeave);
        }
        disconnectedCallback() {
            v(this, "mouseenter", this._handleMouseEnter), v(this, "mouseleave", this._handleMouseLeave);
        }
        _handleMouseEnter = () => {
            this._floatElement && this._floatElement.show();
        };
        _handleMouseLeave = () => {
            this._floatElement && this._floatElement.hide();
        };
        setExpand(t) {
            this.setAttribute("data-aria-expanded", t ? "true" : "false");
        }
        get _floatElement() {
            return this.dataset.floatElementId ? document.querySelector(`#${this.dataset.floatElementId}`) : null;
        }
    };
    var de = class extends M {
        constructor() {
            super(),
                (this._contentSelector = "[data-accordeon-content]"),
                (this._contentWrapperSelector = "[data-accordeon-content-wrapper]"),
                (this._content = this.querySelector(this._contentSelector)),
                (this._resizeObserver = new ResizeObserver(this._handleContentResize)),
                (this._transitionDuration = K(this));
        }
        connectedCallback() {
            this.updateMaxHeight(),
                this._content && this._resizeObserver.observe(this._content),
                this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect));
        }
        disconnectedCallback() {
            this._resizeObserver.disconnect(), this._isEditorMode && this._editor.destroy();
        }
        _handleContentResize = () => {
            this.updateMaxHeight();
        };
        _handleBlockSelect = ({ detail: { sectionId: t, blockId: e, load: s } }) => {
            const i = this.querySelector(this._contentWrapperSelector),
                n = this.dataset.sectionId === t,
                o = this.dataset.blockId === e;
            n &&
                o &&
                !this.isExpanded &&
                (X(i, s),
                X(this, s),
                this.show().then(() => {
                    X(i, !1), X(this, !1);
                }));
        };
        _handleBlockDeselect = ({ detail: { sectionId: t, blockId: e } }) => {
            this.dataset.sectionId === t && this.dataset.blockId === e && this.isExpanded && this.hide();
        };
        hide() {
            return this._setExpand(!1), g(this._transitionDuration);
        }
        show() {
            return this._setExpand(!0), g(this._transitionDuration);
        }
        toggle() {
            this._setExpand(!this.isExpanded);
        }
        updateMaxHeight() {
            const t = this.closest("accordeon-component"),
                e = this.querySelector(this._contentSelector),
                s = this.querySelector(this._contentWrapperSelector);
            if (t && e && s) {
                const i = t.isExpanded ? e.offsetHeight : 0;
                s.style.maxHeight = `${i}px`;
            }
        }
        _setExpand(t) {
            this.setAttribute("data-aria-expanded", t ? "true" : "false"), this.updateMaxHeight();
        }
        get isExpanded() {
            return "true" === this.getAttribute("data-aria-expanded");
        }
        get _contentWrapper() {
            return this.querySelector(this._contentWrapperSelector);
        }
    };
    var ue = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = (t) => {
            t.preventDefault(), this.update();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.update());
        };
        update() {
            const t = this.closest("accordeon-component");
            t && t.toggle();
        }
    };
    var pe = class extends M {
        constructor() {
            super(), (this._productCard = this.closest("product-card")), (this._productCardInner = this.closest(".product-card__inner")), (this._tabs = [...this.querySelectorAll("product-media-tab")]), (this._selected = null);
        }
        connectedCallback() {
            this.update(), b(this._productCard, "mouseenter", this._handleMouseEnter), b(this._productCard, "mouseleave", this._handleMouseLeave);
        }
        disconnectedCallback() {
            v(this._productCard, "mouseenter", this._handleMouseEnter), v(this._productCard, "mouseleave", this._handleMouseLeave);
        }
        _handleMouseEnter = () => {
            b(this._productCardInner, "mousemove", this._handleMouseMove);
        };
        _handleMouseLeave = () => {
            if (!this._productCard) return;
            const t = this._productCard.querySelector("[data-main-media]");
            t && (this._selected && this._reset(), this._setImageVisible(t, !0), v(this._productCardInner, "mousemove", this._handleMouseMove));
        };
        _handleMouseMove = (t) => {
            const e = this._getTabByCoords(t.clientX, t.clientY);
            if (this._productCard && e) {
                const t = this._productCard.querySelector("[data-main-media]"),
                    s = this._productCard.querySelector(`[data-id="${e.dataset.id}"]`);
                if (!s || !t) return;
                this._selected && this._reset(), this._setTabSelect(e, !0), this._setImageVisible(s, !0), this._setImageVisible(t, !1), (this._selected = { tab: e, img: s });
            }
        };
        _getTabByCoords(t, e) {
            return this._tabs.find((s) => {
                const i = s.getBoundingClientRect(),
                    n = e < i.y,
                    o = t - i.x < i.width;
                return n && o;
            });
        }
        update() {
            this._tabs.forEach((t, e) => {
                t.style.display = e + 1 > 5 ? "none" : "flex";
            });
        }
        _setTabSelect(t, e) {
            t.classList.toggle("selected", e);
        }
        _setImageVisible(t, e) {
            t.classList.toggle("product-card__img--visible", e);
        }
        _reset() {
            this._selected && (this._selected.img.classList.remove("product-card__img--visible"), this._selected.tab.classList.remove("selected"), (this._selected = null));
        }
    };
    var me = class {
        constructor(t) {
            this.element = t;
        }
        update(t) {
            this.element.innerText = t ? _(t) : "";
        }
    };
    var _e = class extends M {
        constructor() {
            super(),
                (this.hiddenCountSelector = "[data-color-swatches-hidden-count]"),
                (this.labelSelector = "[data-color-swatches-label]"),
                (this.itemSelector = "[data-color-swatches-item]"),
                (this._hiddenCount = this.querySelector(this.hiddenCountSelector)),
                (this._label = this.querySelector(this.labelSelector)),
                (this._items = [...this.querySelectorAll(this.itemSelector)]),
                (this._productCard = this.closest("product-card")),
                this._productCard && (this.mainImage = this._productCard.querySelector("[data-main-media]")),
                this._label && (this._labelComponent = new me(this._label));
        }
        connectedCallback() {
            this.update(),
                this._items.forEach((t) => {
                    t.addEventListener("mouseenter", this.handleSwatchEnter), t.addEventListener("mouseleave", this.handleSwatchLeave);
                });
        }
        disconnectedCallback() {
            this._items.forEach((t) => {
                t.removeEventListener("mouseenter", this.handleSwatchEnter), t.removeEventListener("mouseleave", this.handleSwatchLeave);
            });
        }
        handleSwatchEnter = (t) => {
            if (!this._productCard) return;
            const e = t.target,
                s = e.dataset.variantId,
                i = this._productCard.querySelector(`[data-variant-id="${s}"]`),
                n = e.dataset.color;
            i && this.mainImage && n && (this.updateLabel(n), this._setImageVisible(i, !0), this._setImageVisible(this.mainImage, !1), (this.currentVisibleImage = i));
        };
        handleSwatchLeave = () => {
            this.updateLabel(""), this.currentVisibleImage && this._setImageVisible(this.currentVisibleImage, !1), this.mainImage && this._setImageVisible(this.mainImage, !0);
        };
        update() {
            this._setSwatchesOffset(), this._setSwatches(), this._updateCount();
        }
        _setImageVisible(t, e) {
            t.classList.toggle("product-card__img--visible", e);
        }
        _setSwatchesOffset() {
            this._items.forEach((t) => {
                this._setVisible(t, !0), (t.dataset.x = `${t.offsetLeft + t.offsetWidth}`);
            });
        }
        _setSwatches() {
            const t = parseInt($(this._hiddenCount, "width"));
            this._items.forEach((e, s) => {
                const i = +(e.dataset.x || 0) > this.offsetWidth - t,
                    n = s + 1 > +(this.dataset.limit || 0);
                this._setVisible(e, !(i || n));
            });
        }
        _updateCount() {
            if (!this._hiddenCount) return;
            const t = this._items.filter((t) => !t.classList.contains("hide")),
                e = +(this.dataset.count || 0) - t.length;
            e > 0 ? (V(this._hiddenCount), (this._hiddenCount.innerText = `${e}`)) : z(this._hiddenCount);
        }
        updateLabel(t) {
            this._labelComponent && this._labelComponent.update(t);
        }
        _setVisible(t, e) {
            t.classList.toggle("hide", !e);
        }
    };
    var ge = class extends M {
        constructor() {
            super(), (this._template = this.querySelector("template")), (this.element = Y(this._template));
        }
        _handleKeydown = (t) => {
            const e = t.key || t.keyCode;
            (e === m.ESCAPE_STRING_KEY || e === m.ESCAPE_NUMBER_KEY) && this.hide();
        };
        _handleOutsideClick = (t) => {
            const e = document.getElementById("BodyOverlay"),
                s = parseFloat($(e, "zIndex")),
                i = parseFloat($(this, "zIndex")) - 1;
            t.target === e && s <= i && this.isOpen && this.hide();
        };
        show() {
            this._mount(),
                this.focus(),
                setTimeout(() => {
                    this._setOpenState(!0);
                }, 0),
                (this.isOpen = !0);
        }
        hide() {
            return (
                this._setOpenState(!1),
                g(this._transitionDuration).then(() => {
                    this._unmount(), (this.isOpen = !1);
                })
            );
        }
        toggle() {
            this.isOpen ? this.hide() : this.show();
        }
        _mount() {
            this.element && !this.contains(this.element) && this.appendChild(this.element);
        }
        _unmount() {
            this.element && this.element.remove();
        }
        _setOpenState(t) {
            const e = this.hasAttribute("data-overlay-important"),
                s = this.getAttribute("data-overlay-opacity") || 50,
                i = { zIndex: e ? parseFloat($(this, "zIndex")) - 1 : 3, backgroundColor: `var(--gsc-black-color-${s})` };
            t
                ? u.showOverlay(this.id, i)
                : g(this._transitionDuration).then(() => {
                      u.hideOverlay(this.id);
                  }),
                this._setVisible(t),
                this._setListeners(t ? "add" : "remove"),
                this.emit(t ? "show" : "hide", {});
        }
        _setVisible(t) {
            this.toggleAttribute("open", t);
        }
        _setListeners(t) {
            const e = `${t}EventListener`;
            this.hasAttribute("data-with-close-on-outside") && window[e]("click", this._handleOutsideClick), window[e]("keydown", this._handleKeydown);
        }
        get _transitionDuration() {
            return K(this) + W(this);
        }
    };
    var fe = class extends ge {
        constructor() {
            super(), (this.passwordInput = this.querySelector("[password-modal-input]"));
        }
        show() {
            super.show(), this.passwordInput && this.passwordInput.focus();
        }
    };
    var be = class extends ge {
        showProductFromParsedState(t, e) {
            const s = t.sections["cart-notification-popup-content"],
                i = Q(s);
            if (this.element) {
                const s = i.querySelector(`#CartNotificationPopupItem-${e}`),
                    n = this.element.querySelector("[data-cart-notification-popup]");
                n && s && ((n.innerHTML = ""), n.appendChild(s)), this._updateCartCountInHeader(t), this.show();
            }
        }
        _updateCartCountInHeader(t) {
            const e = t.sections["cart-count"],
                s = Q(e),
                i = document.getElementById("CartCount"),
                n = document.getElementById("StickyCartCount"),
                o = s.getElementById("CartCount");
            n && o && (n.innerHTML = o.innerHTML), i && o && (i.innerHTML = o.innerHTML);
        }
    };
    var ve = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.showModal(), this.emit("click", {});
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            if (k(t.key || t.keyCode) && this.dataset.modal) {
                t.preventDefault();
                const e = document.querySelector(this.dataset.modal);
                e && e.toggle();
            }
        };
        showModal() {
            if (this.dataset.modal) {
                const t = document.querySelector(this.dataset.modal);
                t && t.show();
            }
        }
    };
    var ye = class extends ve {
        connectedCallback() {
            super.connectedCallback(), this.focus();
        }
    };
    var Se = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.hide();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.hide());
        };
        hide() {
            if (this.dataset.modal) {
                const t = document.querySelector(this.dataset.modal);
                t && t.hide();
            }
        }
    };
    var we = class extends M {
        constructor() {
            super(), (this.buttonSelector = "[data-sidebar-button]"), (this.button = this.querySelector(this.buttonSelector));
        }
        connectedCallback() {
            this.button &&
                (this.button.addEventListener("click", this._handleButtonClick),
                this.button.addEventListener("focus", this._handleButtonFocus),
                this.button.addEventListener("blur", this._handleButtonBlur),
                this.button.addEventListener("mousedown", this.handleButtonMouseDown),
                this.button.addEventListener("mousemove", this.handleButtonMouseMove),
                this.button.addEventListener("mouseup", this.handleButtonMouseUp));
        }
        disconnectedCallback() {
            this.button &&
                (this.button.removeEventListener("click", this._handleButtonClick),
                this.button.removeEventListener("focus", this._handleButtonFocus),
                this.button.removeEventListener("blur", this._handleButtonBlur),
                this.button.removeEventListener("mousedown", this.handleButtonMouseDown),
                this.button.removeEventListener("mousemove", this.handleButtonMouseMove),
                this.button.removeEventListener("mouseup", this.handleButtonMouseUp));
        }
        _handleButtonClick = (t) => {
            t.preventDefault();
        };
        handleButtonMouseDown = (t) => {
            t.preventDefault();
            const e = this.closest("carousel-component"),
                s = this.closest("carousel-dots");
            (this.isDraggingInCarousel = !(!e && !s)), this.isDraggingInCarousel ? (this.setMoveStartPoint(t.clientX, t.clientY), (this.toggleAfterDraggingInCarousel = !0)) : this.toggle();
        };
        handleButtonMouseMove = (t) => {
            if (this.isDraggingInCarousel) {
                const e = 24,
                    s = Math.abs(this.startPointX - t.clientX),
                    i = Math.abs(this.startPointY - t.clientY);
                (s > e || i > e) && (this.toggleAfterDraggingInCarousel = !1);
            }
        };
        handleButtonMouseUp = () => {
            this.isDraggingInCarousel && (this.toggleAfterDraggingInCarousel && this.toggle(), (this.isDraggingInCarousel = !1), (this.toggleAfterDraggingInCarousel = !1), this.setMoveStartPoint(0, 0));
        };
        _handleButtonFocus = () => {
            this.button && this.button.addEventListener("keydown", this.handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.button && this.button.removeEventListener("keydown", this.handleKeyDown);
        };
        handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.toggle());
        };
        setMoveStartPoint(t, e) {
            (this.startPointX = t), (this.startPointY = e);
        }
        toggle() {
            if (this.button) {
                const t = this.button.dataset.sidebarId || "",
                    e = document.querySelector(`#${t}`);
                e && (e.toggle(), this.update());
            }
        }
        update() {
            if (this.button) {
                const t = this.button.dataset.sidebarId || "",
                    e = document.querySelector(`#${t}`);
                e && this.button.setAttribute("data-aria-expanded", e.isOpen ? "true" : "false");
            }
        }
    };
    var Ce = class extends M {
        constructor() {
            super(), (this._template = this.querySelector("template")), (this.element = Y(this._template)), (this.buttonSelector = `[data-sidebar-button][data-sidebar-id="${this.id}"]`), this.withOpenOnInit && this.open();
        }
        connectedCallback() {
            this.addEventListener("touchstart", this._handleTouchStart),
                this.addEventListener("touchmove", this._handleTouchMove),
                this.addEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode &&
                    (this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad), this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect), this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect));
        }
        disconnectedCallback() {
            this.removeEventListener("touchstart", this._handleTouchStart),
                this.removeEventListener("touchmove", this._handleTouchMove),
                this.removeEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode && this._editor.destroy();
        }
        _handleSectionLoad = () => {
            this._isSection || this.withOpenOnInit || this.hide();
        };
        _handleSectionSelect = ({ detail: { sectionId: t } }) => {
            this._isSection && this.dataset.sectionId === t && this.open();
        };
        _handleSectionDeselect = ({ detail: { sectionId: t } }) => {
            this._isSection && this.dataset.sectionId === t && this.hide();
        };
        _handleOutsideClick = (t) => {
            const e = document.getElementById("BodyOverlay"),
                s = parseFloat($(e, "zIndex")),
                i = parseFloat($(this, "zIndex")) - 1;
            t.target === e && s <= i && this.isOpen && this.hide();
        };
        _handleTouchStart = (t) => {
            (this._touchStartX = t.targetTouches[0].clientX), (this._touchStartY = t.targetTouches[0].clientY);
        };
        _handleTouchMove = (t) => {
            (this._touchEndX = t.targetTouches[0].clientX), (this._touchEndY = t.targetTouches[0].clientY);
        };
        _handleTouchEnd = (t) => {
            const e = Math.abs(this._touchStartX - this._touchEndX),
                s = Math.abs(this._touchStartY - this._touchEndY);
            if (t.target.closest("[data-carousel-viewport]")) return;
            if (0 === this._touchEndX) return;
            if (s > 48) return;
            const i = "right" === this.dataset.openDirection ? this._touchStartX < this._touchEndX : this._touchStartX > this._touchEndX;
            this.isOpen && e > 96 && i && this.hide(), this.cleanTouchPoints();
        };
        _handleKeydown = (t) => {
            const e = t.key || t.keyCode;
            this.hasAttribute("data-with-close-on-escape") && (e === m.ESCAPE_STRING_KEY || e === m.ESCAPE_NUMBER_KEY) && this.hide();
        };
        cleanTouchPoints() {
            (this._touchStartX = 0), (this._touchEndX = 0), (this._touchStartY = 0), (this._touchEndY = 0);
        }
        open() {
            return (
                this.mount(),
                this.setAttribute("tabindex", "-1"),
                this.focus(),
                setTimeout(() => {
                    this._setOpenState(!0);
                }, 0),
                g(this._transitionDuration)
            );
        }
        hide(t) {
            if ((this._setOpenState(!1), !t))
                return g(this._transitionDuration).then(() => {
                    this.unmount();
                });
            this.unmount();
        }
        toggle() {
            this.isOpen ? this.hide() : this.open();
        }
        mount() {
            this.contains(this.element) || this.appendChild(this.element);
        }
        unmount() {
            this.element && this.element.remove();
        }
        updateTemplate(t) {
            this.element.remove(), (this.element = Y(t)), this.appendChild(this.element);
        }
        _setOpenState(t) {
            const e = this.hasAttribute("data-with-overlay"),
                s = document.querySelectorAll(this.buttonSelector);
            if ((this._setVisible(t), this._setListeners(t ? "add" : "remove"), localStorage.setItem(`sidebar-${this.id}`, `${t}`), e)) {
                const e = this.hasAttribute("data-overlay-important"),
                    s = this.hasAttribute("data-overlay-with-blur"),
                    i = +(this.getAttribute("data-overlay-opacity") || 50),
                    n = { zIndex: e ? parseFloat($(this, "zIndex")) - 1 : 3, backdropFilter: s ? "blur(16.5px)" : "none", backgroundColor: `var(--gsc-black-color-${i})` };
                t
                    ? u.showOverlay(this.id, n)
                    : g(this._transitionDuration).then(() => {
                          u.hideOverlay(this.id);
                      });
            }
            s.forEach((e) => {
                e.setAttribute("data-aria-expanded", t ? "true" : "false");
            });
        }
        _setVisible(t) {
            this.setAttribute("data-aria-expanded", t ? "true" : "false");
        }
        _setListeners(t) {
            const e = `${t}EventListener`;
            this.hasAttribute("data-with-close-on-outside") && window[e]("click", this._handleOutsideClick), window[e]("keydown", this._handleKeydown);
        }
        get _isSection() {
            return this.hasAttribute("data-sidebar-section");
        }
        get isOpen() {
            return "true" === this.getAttribute("data-aria-expanded");
        }
        get withOpenOnInit() {
            return this.hasAttribute("data-with-open-on-init");
        }
        get isOpenBeforeSectionChange() {
            return "true" === localStorage.getItem(`sidebar-${this.id}`);
        }
        get _transitionDuration() {
            return K(this) + W(this);
        }
    };
    const ke = () => matchMedia("(max-width: 768px)").matches,
        Ee = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
    var xe = class extends Ce {
        constructor() {
            super(),
                (this.searchInputSelector = "[data-sidebar-search-input]"),
                (this.searchInputComponentSelector = "[data-sidebar-search-input-component]"),
                (this.contentSelector = "[data-sidebar-search-content]"),
                (this.contentResultsSelector = "[data-sidebar-search-content-results]"),
                (this.content = this.element.querySelector(this.contentSelector)),
                (this.contentResults = this.element.querySelector(this.contentResultsSelector)),
                (this._searchInputComponent = this.element.querySelector(this.searchInputComponentSelector)),
                (this._searchInput = this.element.querySelector(this.searchInputSelector)),
                (this._resizeObserver = new ResizeObserver(this._handleContentResultsResize)),
                (this.defaultStateElement = document);
        }
        connectedCallback() {
            super.connectedCallback(),
                this.content && this.content.addEventListener("scroll", this._handleContentScroll),
                this.addEventListener("click", this._handleClick),
                this.addEventListener("touchend", this._handleSearchSidebarTouchEnd),
                this._searchInput && (this._searchInput.addEventListener("focus", this._handleInputFocus), this._searchInput.addEventListener("keydown", this._handleInputKeydown)),
                this.contentResults && this._resizeObserver.observe(this.contentResults);
        }
        disconnectedCallback() {
            super.disconnectedCallback(),
                this.content && this.content.removeEventListener("scroll", this._handleContentScroll),
                this.removeEventListener("click", this._handleClick),
                this.removeEventListener("touchend", this._handleSearchSidebarTouchEnd),
                this._searchInput && (this._searchInput.removeEventListener("focus", this._handleInputFocus), this._searchInput.removeEventListener("keydown", this._handleInputKeydown)),
                this._resizeObserver.disconnect();
        }
        _handleInputKeydown = (t) => {
            k(t.key || t.keyCode) && t.preventDefault();
        };
        _handleClick = (t) => {
            const e = t.target,
                s = ke(),
                i = e === this._searchInput,
                n = "A" === e.tagName,
                o = e.closest("[data-sidebar-search-query]");
            if (this._searchInput && o) {
                const t = new Event("input", { bubbles: !0 });
                (this._searchInput.value = `${o.getAttribute("data-sidebar-search-query")}`), this._searchInput.dispatchEvent(t), this._searchInput.focus();
            }
            s && i && (this.isInputFocused = !0), !i && this.isInputFocused && (n && t.preventDefault(), (this.isInputFocused = !1));
        };
        _handleInputFocus = () => {
            ke() && (this.isInputFocused = !0);
        };
        _handleSearchSidebarTouchEnd = (t) => {
            const e = t.target,
                s = Math.abs(this._touchStartX - this._touchEndX),
                i = Math.abs(this._touchStartY - this._touchEndY),
                n = s > 12 || i > 12,
                o = "A" === e.tagName;
            this.isInputFocused && n && this._searchInput && (o && t.preventDefault(), this._searchInput.blur(), (this.isInputFocused = !1)), this.cleanTouchPoints();
        };
        _handleContentResultsResize = () => {
            this.updateViewport();
        };
        _handleContentScroll = () => {
            if (this.content) {
                const t = this.checkContentOverflow(),
                    e = this.content.scrollTop > 0;
                this.toggleAttribute("header-shadow-visible", t && e);
            }
        };
        updateViewport() {
            const t = this.checkContentOverflow();
            this.toggleAttribute("footer-shadow-visible", t);
        }
        open() {
            return super.open().then(() => {
                this._searchInput && !this._isEditorMode && this._searchInput.focus();
            });
        }
        checkContentOverflow() {
            return !(!this.contentResults || !this.content) && this.contentResults.offsetHeight > this.content.offsetHeight;
        }
    };
    const { Shopify: Ie } = window;
    var Le = class extends Ce {
        constructor() {
            super(), (this._cache = {});
        }
        requestProductFromUrl(t, e) {
            this._resetProduct(),
                this._cache[t] ||
                    ((this.onThisPageRenderedQuickView = document.querySelector(`.shopify-section [data-quick-view-product-id="${e}"]`)),
                    this.onThisPageRenderedQuickView && this.onThisPageRenderedQuickView.dataset.quickViewProductUrl === t
                        ? (this._cache[t] = g(0).then(() => this.onThisPageRenderedQuickView))
                        : (this._cache[t] = fetch(t)
                              .then((t) => t.text())
                              .then((t) => Q(t))));
        }
        _handleContentScroll = () => {
            const t = !!this.content && this.content.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", t);
        };
        open() {}
        openAndRenderProductByUrl = (t) => {
            this._cache[t] &&
                this._cache[t].then((t) => {
                    this._setProductFromHTML(t), this.onThisPageRenderedQuickView && (this.onThisPageRenderedQuickView.innerHTML = ""), this.isOpen || super.open(), Ie?.PaymentButton?.init();
                });
        };
        _setProductFromHTML(t) {
            if (this.dataset.targetId) {
                const e = t.getElementById(this.dataset.targetId);
                if (e) {
                    const t = e.getAttribute("class") || "";
                    this.element.setAttribute("class", t),
                        (this.element.innerHTML = e.innerHTML),
                        (this.content = this.element.querySelector("[data-quick-view-content]")),
                        this.content && this.content.addEventListener("scroll", this._handleContentScroll);
                }
            }
        }
        _resetProduct() {
            this.content && (this.content.removeEventListener("scroll", this._handleContentScroll), this.onThisPageRenderedQuickView && (this.onThisPageRenderedQuickView.innerHTML = this.content.innerHTML), (this.content = null)),
                (this.element.innerHTML = "");
        }
    };
    function Te(t) {
        return "number" == typeof t;
    }
    function Me(t) {
        return "string" == typeof t;
    }
    function Be(t) {
        return "[object Object]" === Object.prototype.toString.call(t);
    }
    function Ae(t) {
        return (
            Be(t) ||
            (function (t) {
                return Array.isArray(t);
            })(t)
        );
    }
    function Pe(t) {
        return Math.abs(t);
    }
    function De(t) {
        return t ? t / Pe(t) : 0;
    }
    function qe(t, e) {
        return Pe(t - e);
    }
    function Oe(t) {
        return Ne(t).map(Number);
    }
    function Re(t) {
        return t[Fe(t)];
    }
    function Fe(t) {
        return Math.max(0, t.length - 1);
    }
    function Ne(t) {
        return Object.keys(t);
    }
    function He(t, e) {
        return [t, e].reduce(function (t, e) {
            return (
                Ne(e).forEach(function (s) {
                    var i = t[s],
                        n = e[s],
                        o = Be(i) && Be(n);
                    t[s] = o ? He(i, n) : n;
                }),
                t
            );
        }, {});
    }
    function Ve(t, e) {
        var s = Ne(t),
            i = Ne(e);
        return (
            s.length === i.length &&
            s.every(function (s) {
                var i = t[s],
                    n = e[s];
                return "function" == typeof i ? "".concat(i) === "".concat(n) : Ae(i) && Ae(n) ? Ve(i, n) : i === n;
            })
        );
    }
    function ze(t, e) {
        var s = {
            start: function () {
                return 0;
            },
            center: function (t) {
                return i(t) / 2;
            },
            end: i,
        };
        function i(t) {
            return e - t;
        }
        return {
            measure: function (i) {
                return Te(t) ? e * Number(t) : s[t](i);
            },
        };
    }
    function $e(t, e) {
        var s = Pe(t - e);
        function i(e) {
            return e < t;
        }
        function n(t) {
            return t > e;
        }
        function o(t) {
            return i(t) || n(t);
        }
        return {
            length: s,
            max: e,
            min: t,
            constrain: function (s) {
                return o(s) ? (i(s) ? t : e) : s;
            },
            reachedAny: o,
            reachedMax: n,
            reachedMin: i,
            removeOffset: function (t) {
                return s ? t - s * Math.ceil((t - e) / s) : t;
            },
        };
    }
    function Ke(t, e, s) {
        var i = $e(0, t),
            n = i.min,
            o = i.constrain,
            a = t + 1,
            r = l(e);
        function l(t) {
            return s ? Pe((a + t) % a) : o(t);
        }
        function c() {
            return r;
        }
        function h(t) {
            return (r = l(t)), d;
        }
        var d = {
            add: function (t) {
                return h(c() + t);
            },
            clone: function () {
                return Ke(t, c(), s);
            },
            get: c,
            set: h,
            min: n,
            max: t,
        };
        return d;
    }
    function We() {
        var t = [];
        var e = {
            add: function (s, i, n, o) {
                return (
                    void 0 === o && (o = { passive: !0 }),
                    s.addEventListener(i, n, o),
                    t.push(function () {
                        return s.removeEventListener(i, n, o);
                    }),
                    e
                );
            },
            removeAll: function () {
                return (
                    (t = t.filter(function (t) {
                        return t();
                    })),
                    e
                );
            },
        };
        return e;
    }
    function Ue(t) {
        var e = t;
        function s(t) {
            return (e /= t), n;
        }
        function i(t) {
            return Te(t) ? t : t.get();
        }
        var n = {
            add: function (t) {
                return (e += i(t)), n;
            },
            divide: s,
            get: function () {
                return e;
            },
            multiply: function (t) {
                return (e *= t), n;
            },
            normalize: function () {
                return 0 !== e && s(e), n;
            },
            set: function (t) {
                return (e = i(t)), n;
            },
            subtract: function (t) {
                return (e -= i(t)), n;
            },
        };
        return n;
    }
    function Ye(t, e, s, i, n, o, a, r, l, c, h, d, u, p, m, _) {
        var g = t.cross,
            f = ["INPUT", "SELECT", "TEXTAREA"],
            b = { passive: !1 },
            v = Ue(0),
            y = We(),
            S = We(),
            w = u.measure(20),
            C = { mouse: 300, touch: 400 },
            k = { mouse: 500, touch: 600 },
            E = m ? 5 : 16,
            x = 1,
            I = 0,
            L = 0,
            T = !1,
            M = !1,
            B = !1,
            A = !1;
        function P(t) {
            if (!(((A = !n.isTouchEvent(t)) && 0 !== t.button) || ((e = t.target), (a = e.nodeName || ""), f.indexOf(a) > -1))) {
                var e,
                    a,
                    r = qe(i.get(), o.get()) >= 2,
                    c = A || !r;
                (T = !0),
                    n.pointerDown(t),
                    v.set(i),
                    i.set(o),
                    l.useBaseMass().useSpeed(80),
                    (function () {
                        var t = A ? document : s;
                        S.add(t, "touchmove", D, b).add(t, "touchend", q).add(t, "mousemove", D, b).add(t, "mouseup", q);
                    })(),
                    (I = n.readPoint(t)),
                    (L = n.readPoint(t, g)),
                    d.emit("pointerDown"),
                    c && (B = !1);
            }
        }
        function D(t) {
            if (!M && !A) {
                if (!t.cancelable) return q(t);
                var s = n.readPoint(t),
                    o = n.readPoint(t, g),
                    r = qe(s, I),
                    l = qe(o, L);
                if (!(M = r > l) && !B) return q(t);
            }
            var c = n.pointerMove(t);
            !B && c && (B = !0), a.start(), i.add(e.apply(c)), t.preventDefault();
        }
        function q(t) {
            var s = c.byDistance(0, !1).index !== h.get(),
                o = n.pointerUp(t) * (m ? k : C)[A ? "mouse" : "touch"],
                a = (function (t, e) {
                    var s = h.clone().add(-1 * De(t)),
                        i = s.get() === h.min || s.get() === h.max,
                        n = c.byDistance(t, !m).distance;
                    return m || Pe(t) < w ? n : !p && i ? 0.4 * n : _ && e ? 0.5 * n : c.byIndex(s.get(), 0).distance;
                })(e.apply(o), s),
                u = (function (t, e) {
                    if (0 === t || 0 === e) return 0;
                    if (Pe(t) <= Pe(e)) return 0;
                    var s = qe(Pe(t), Pe(e));
                    return Pe(s / t);
                })(o, a),
                g = qe(i.get(), v.get()) >= 0.5,
                f = s && u > 0.75,
                b = Pe(o) < w,
                y = f ? 10 : E,
                I = f ? x + 2.5 * u : x;
            g && !A && (B = !0), (M = !1), (T = !1), S.removeAll(), l.useSpeed(b ? 9 : y).useMass(I), r.distance(a, !m), (A = !1), d.emit("pointerUp");
        }
        function O(t) {
            B && (t.stopPropagation(), t.preventDefault());
        }
        return {
            addActivationEvents: function () {
                var t = s;
                y.add(
                    t,
                    "dragstart",
                    function (t) {
                        return t.preventDefault();
                    },
                    b
                )
                    .add(t, "touchmove", function () {}, b)
                    .add(t, "touchend", function () {})
                    .add(t, "touchstart", P)
                    .add(t, "mousedown", P)
                    .add(t, "touchcancel", q)
                    .add(t, "contextmenu", q)
                    .add(t, "click", O, !0);
            },
            clickAllowed: function () {
                return !B;
            },
            pointerDown: function () {
                return T;
            },
            removeAllEvents: function () {
                y.removeAll(), S.removeAll();
            },
        };
    }
    function Xe(t, e, s) {
        var i,
            n,
            o =
                ((i = 2),
                (n = Math.pow(10, i)),
                function (t) {
                    return Math.round(t * n) / n;
                }),
            a = Ue(0),
            r = Ue(0),
            l = Ue(0),
            c = 0,
            h = e,
            d = s;
        function u(t) {
            return (h = t), m;
        }
        function p(t) {
            return (d = t), m;
        }
        var m = {
            direction: function () {
                return c;
            },
            seek: function (e) {
                l.set(e).subtract(t);
                var s,
                    i,
                    n,
                    o,
                    u = ((s = l.get()), (n = 0) + ((s - (i = 0)) / (100 - i)) * (h - n));
                return (c = De(l.get())), l.normalize().multiply(u).subtract(a), (o = l).divide(d), r.add(o), m;
            },
            settle: function (e) {
                var s = e.get() - t.get(),
                    i = !o(s);
                return i && t.set(e), i;
            },
            update: function () {
                a.add(r), t.add(a), r.multiply(0);
            },
            useBaseMass: function () {
                return p(s);
            },
            useBaseSpeed: function () {
                return u(e);
            },
            useMass: p,
            useSpeed: u,
        };
        return m;
    }
    function Qe(t, e, s, i, n) {
        var o = n.measure(10),
            a = n.measure(50),
            r = !1;
        return {
            constrain: function (n) {
                if (!r && t.reachedAny(s.get()) && t.reachedAny(e.get())) {
                    var l = t.reachedMin(e.get()) ? "min" : "max",
                        c = Pe(t[l] - e.get()),
                        h = s.get() - e.get(),
                        d = Math.min(c / a, 0.85);
                    s.subtract(h * d), !n && Pe(h) < o && (s.set(t.constrain(s.get())), i.useSpeed(10).useMass(3));
                }
            },
            toggleActive: function (t) {
                r = !t;
            },
        };
    }
    function je(t, e, s, i) {
        var n = $e(-e + t, s[0]),
            o = s.map(n.constrain);
        return {
            snapsContained: (function () {
                if (e <= t) return [n.max];
                if ("keepSnaps" === i) return o;
                var s = (function () {
                        var t = o[0],
                            e = Re(o),
                            s = o.lastIndexOf(t),
                            i = o.indexOf(e) + 1;
                        return $e(s, i);
                    })(),
                    a = s.min,
                    r = s.max;
                return o.slice(a, r);
            })(),
        };
    }
    function Ge(t, e, s, i) {
        var n = $e(e.min + 0.1, e.max + 0.1),
            o = n.reachedMin,
            a = n.reachedMax;
        return {
            loop: function (e) {
                if (
                    (function (t) {
                        return 1 === t ? a(s.get()) : -1 === t && o(s.get());
                    })(e)
                ) {
                    var n = t * (-1 * e);
                    i.forEach(function (t) {
                        return t.add(n);
                    });
                }
            },
        };
    }
    function Ze(t) {
        var e = t.max,
            s = t.length;
        return {
            get: function (t) {
                return (t - e) / -s;
            },
        };
    }
    function Je(t, e, s, i, n) {
        var o = i.reachedAny,
            a = i.removeOffset,
            r = i.constrain;
        function l(t) {
            return t.concat().sort(function (t, e) {
                return Pe(t) - Pe(e);
            })[0];
        }
        function c(e, i) {
            var n = [e, e + s, e - s];
            return t
                ? l(
                      i
                          ? n.filter(function (t) {
                                return De(t) === i;
                            })
                          : n
                  )
                : n[0];
        }
        return {
            byDistance: function (s, i) {
                var l = n.get() + s,
                    h = (function (s) {
                        var i = t ? a(s) : r(s);
                        return {
                            index: e
                                .map(function (t) {
                                    return t - i;
                                })
                                .map(function (t) {
                                    return c(t, 0);
                                })
                                .map(function (t, e) {
                                    return { diff: t, index: e };
                                })
                                .sort(function (t, e) {
                                    return Pe(t.diff) - Pe(e.diff);
                                })[0].index,
                            distance: i,
                        };
                    })(l),
                    d = h.index,
                    u = h.distance,
                    p = !t && o(l);
                return !i || p ? { index: d, distance: s } : { index: d, distance: s + c(e[d] - u, 0) };
            },
            byIndex: function (t, s) {
                return { index: t, distance: c(e[t] - n.get(), s) };
            },
            shortcut: c,
        };
    }
    function ts(t, e, s) {
        var i =
                "x" === t.scroll
                    ? function (t) {
                          return "translate3d(".concat(t, "px,0px,0px)");
                      }
                    : function (t) {
                          return "translate3d(0px,".concat(t, "px,0px)");
                      },
            n = s.style,
            o = !1;
        return {
            clear: function () {
                o || ((n.transform = ""), s.getAttribute("style") || s.removeAttribute("style"));
            },
            to: function (t) {
                o || (n.transform = i(e.apply(t.get())));
            },
            toggleActive: function (t) {
                o = !t;
            },
        };
    }
    function es(t, e, s, i, n, o, a, r, l) {
        var c,
            h = Oe(n),
            d = Oe(n).reverse(),
            u = ((c = o[0] - 1), _(m(d, c), "end")).concat(
                (function () {
                    var t = s - o[0] - 1,
                        e = m(h, t);
                    return _(e, "start");
                })()
            );
        function p(t, e) {
            return t.reduce(function (t, e) {
                return t - n[e];
            }, e);
        }
        function m(t, e) {
            return t.reduce(function (t, s) {
                return p(t, e) > 0 ? t.concat([s]) : t;
            }, []);
        }
        function _(s, n) {
            var o = "start" === n,
                c = o ? -i : i,
                h = a.findSlideBounds([c]);
            return s.map(function (s) {
                var n = o ? 0 : -i,
                    a = o ? i : 0,
                    c = h.filter(function (t) {
                        return t.index === s;
                    })[0][o ? "end" : "start"],
                    d = Ue(-1),
                    u = Ue(-1),
                    p = ts(t, e, l[s]);
                return {
                    index: s,
                    location: u,
                    translate: p,
                    target: function () {
                        return d.set(r.get() > c ? n : a);
                    },
                };
            });
        }
        return {
            canLoop: function () {
                return u.every(function (t) {
                    var e = t.index;
                    return (
                        p(
                            h.filter(function (t) {
                                return t !== e;
                            }),
                            s
                        ) <= 0.1
                    );
                });
            },
            clear: function () {
                u.forEach(function (t) {
                    return t.translate.clear();
                });
            },
            loop: function () {
                u.forEach(function (t) {
                    var e = t.target,
                        s = t.translate,
                        i = t.location,
                        n = e();
                    n.get() !== i.get() && (0 === n.get() ? s.clear() : s.to(n), i.set(n));
                });
            },
            loopPoints: u,
        };
    }
    function ss(t, e, s, i, n, o, a) {
        var r = n.removeOffset,
            l = n.constrain,
            c = 0.5,
            h = o ? [0, e, -e] : [0],
            d = u(h, a);
        function u(e, n) {
            var o = e || h,
                a = (function (t) {
                    var e = t || 0;
                    return s.map(function (t) {
                        return $e(c, t - c).constrain(t * e);
                    });
                })(n);
            return o.reduce(function (e, n) {
                var o = i.map(function (e, i) {
                    return { start: e - s[i] + a[i] + n, end: e + t - a[i] + n, index: i };
                });
                return e.concat(o);
            }, []);
        }
        return {
            check: function (t, e) {
                var s = o ? r(t) : l(t);
                return (e || d).reduce(function (t, e) {
                    var i = e.index,
                        n = e.start,
                        o = e.end;
                    return !(-1 !== t.indexOf(i)) && n < s && o > s ? t.concat([i]) : t;
                }, []);
            },
            findSlideBounds: u,
        };
    }
    function is(t, e, s) {
        var i = Te(s);
        return {
            groupSlides: function (n) {
                return i
                    ? (function (t, e) {
                          return Oe(t)
                              .filter(function (t) {
                                  return t % e == 0;
                              })
                              .map(function (s) {
                                  return t.slice(s, s + e);
                              });
                      })(n, s)
                    : (function (s) {
                          return Oe(s)
                              .reduce(function (s, i) {
                                  var n = e.slice(Re(s), i + 1).reduce(function (t, e) {
                                      return t + e;
                                  }, 0);
                                  return !i || n > t ? s.concat(i) : s;
                              }, [])
                              .map(function (t, e, i) {
                                  return s.slice(t, i[e + 1]);
                              });
                      })(n);
            },
        };
    }
    function ns(t, e, s, i, n) {
        var o = i.align,
            a = i.axis,
            r = i.direction,
            l = i.startIndex,
            c = i.inViewThreshold,
            h = i.loop,
            d = i.speed,
            u = i.dragFree,
            p = i.slidesToScroll,
            m = i.skipSnaps,
            _ = i.containScroll,
            g = e.getBoundingClientRect(),
            f = s.map(function (t) {
                return t.getBoundingClientRect();
            }),
            b = (function (t) {
                var e = "rtl" === t ? -1 : 1;
                return {
                    apply: function (t) {
                        return t * e;
                    },
                };
            })(r),
            v = (function (t, e) {
                var s = "y" === t ? "y" : "x";
                return {
                    scroll: s,
                    cross: "y" === t ? "x" : "y",
                    startEdge: "y" === s ? "top" : "rtl" === e ? "right" : "left",
                    endEdge: "y" === s ? "bottom" : "rtl" === e ? "left" : "right",
                    measureSize: function (t) {
                        var e = t.width,
                            i = t.height;
                        return "x" === s ? e : i;
                    },
                };
            })(a, r),
            y = v.measureSize(g),
            S = (function (t) {
                return {
                    measure: function (e) {
                        return t * (e / 100);
                    },
                };
            })(y),
            w = ze(o, y),
            C = !h && "" !== _,
            k = (function (t, e, s, i, n) {
                var o = t.measureSize,
                    a = t.startEdge,
                    r = t.endEdge,
                    l = s[0] && n,
                    c = (function () {
                        if (!l) return 0;
                        var t = s[0];
                        return Pe(e[a] - t[a]);
                    })(),
                    h = (function () {
                        if (!l) return 0;
                        var t = window.getComputedStyle(Re(i));
                        return parseFloat(t.getPropertyValue("margin-".concat(r)));
                    })(),
                    d = s.map(o),
                    u = s
                        .map(function (t, e, s) {
                            var i = !e,
                                n = e === Fe(s);
                            return i ? d[e] + c : n ? d[e] + h : s[e + 1][a] - t[a];
                        })
                        .map(Pe);
                return { slideSizes: d, slideSizesWithGaps: u };
            })(v, g, f, s, h || "" !== _),
            E = k.slideSizes,
            x = k.slideSizesWithGaps,
            I = is(y, x, p),
            L = (function (t, e, s, i, n, o, a) {
                var r,
                    l = t.startEdge,
                    c = t.endEdge,
                    h = o.groupSlides,
                    d = h(i)
                        .map(function (t) {
                            return Re(t)[c] - t[0][l];
                        })
                        .map(Pe)
                        .map(e.measure),
                    u = i
                        .map(function (t) {
                            return s[l] - t[l];
                        })
                        .map(function (t) {
                            return -Pe(t);
                        }),
                    p =
                        ((r = Re(u) - Re(n)),
                        h(u)
                            .map(function (t) {
                                return t[0];
                            })
                            .map(function (t, e, s) {
                                var i = !e,
                                    n = e === Fe(s);
                                return a && i ? 0 : a && n ? r : t + d[e];
                            }));
                return { snaps: u, snapsAligned: p };
            })(v, w, g, f, x, I, C),
            T = L.snaps,
            M = L.snapsAligned,
            B = -Re(T) + Re(x),
            A = je(y, B, M, _).snapsContained,
            P = C ? A : M,
            D = (function (t, e, s) {
                var i, n;
                return { limit: ((i = e[0]), (n = Re(e)), $e(s ? i - t : n, i)) };
            })(B, P, h).limit,
            q = Ke(Fe(P), l, h),
            O = q.clone(),
            R = Oe(s),
            F = (function (t) {
                var e = 0;
                function s(t, s) {
                    return function () {
                        t === !!e && s();
                    };
                }
                function i() {
                    e = window.requestAnimationFrame(t);
                }
                return {
                    proceed: s(!0, i),
                    start: s(!1, i),
                    stop: s(!0, function () {
                        window.cancelAnimationFrame(e), (e = 0);
                    }),
                };
            })(function () {
                h || Y.scrollBounds.constrain(Y.dragHandler.pointerDown()), Y.scrollBody.seek(V).update();
                var t = Y.scrollBody.settle(V);
                t && !Y.dragHandler.pointerDown() && (Y.animation.stop(), n.emit("settle")), t || n.emit("scroll"), h && (Y.scrollLooper.loop(Y.scrollBody.direction()), Y.slideLooper.loop()), Y.translate.to(H), Y.animation.proceed();
            }),
            N = P[q.get()],
            H = Ue(N),
            V = Ue(N),
            z = Xe(H, d, 1),
            $ = Je(h, P, B, D, V),
            K = (function (t, e, s, i, n, o) {
                function a(i) {
                    var a = i.distance,
                        r = i.index !== e.get();
                    a && (t.start(), n.add(a)), r && (s.set(e.get()), e.set(i.index), o.emit("select"));
                }
                return {
                    distance: function (t, e) {
                        a(i.byDistance(t, e));
                    },
                    index: function (t, s) {
                        var n = e.clone().set(t);
                        a(i.byIndex(n.get(), s));
                    },
                };
            })(F, q, O, $, V, n),
            W = ss(y, B, E, T, D, h, c),
            U = Ye(
                v,
                b,
                t,
                V,
                (function (t) {
                    var e, s;
                    function i(t) {
                        return "undefined" != typeof TouchEvent && t instanceof TouchEvent;
                    }
                    function n(t) {
                        return t.timeStamp;
                    }
                    function o(e, s) {
                        var n = s || t.scroll,
                            o = "client".concat("x" === n ? "X" : "Y");
                        return (i(e) ? e.touches[0] : e)[o];
                    }
                    return {
                        isTouchEvent: i,
                        pointerDown: function (t) {
                            return (e = t), (s = t), o(t);
                        },
                        pointerMove: function (t) {
                            var i = o(t) - o(s),
                                a = n(t) - n(e) > 170;
                            return (s = t), a && (e = t), i;
                        },
                        pointerUp: function (t) {
                            if (!e || !s) return 0;
                            var i = o(s) - o(e),
                                a = n(t) - n(e),
                                r = n(t) - n(s) > 170,
                                l = i / a;
                            return a && !r && Pe(l) > 0.1 ? l : 0;
                        },
                        readPoint: o,
                    };
                })(v),
                H,
                F,
                K,
                z,
                $,
                q,
                n,
                S,
                h,
                u,
                m
            ),
            Y = {
                containerRect: g,
                slideRects: f,
                animation: F,
                axis: v,
                direction: b,
                dragHandler: U,
                eventStore: We(),
                percentOfView: S,
                index: q,
                indexPrevious: O,
                limit: D,
                location: H,
                options: i,
                scrollBody: z,
                scrollBounds: Qe(D, H, V, z, S),
                scrollLooper: Ge(B, D, H, [H, V]),
                scrollProgress: Ze(D),
                scrollSnaps: P,
                scrollTarget: $,
                scrollTo: K,
                slideLooper: es(v, b, y, B, x, P, W, H, s),
                slidesToScroll: I,
                slidesInView: W,
                slideIndexes: R,
                target: V,
                translate: ts(v, b, e),
            };
        return Y;
    }
    var os = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: "",
        direction: "ltr",
        slidesToScroll: 1,
        breakpoints: {},
        dragFree: !1,
        draggable: !0,
        inViewThreshold: 0,
        loop: !1,
        skipSnaps: !1,
        speed: 10,
        startIndex: 0,
        active: !0,
    };
    function as() {
        function t(t, e) {
            return He(t, e || {});
        }
        return {
            merge: t,
            areEqual: function (t, e) {
                return JSON.stringify(Ne(t.breakpoints || {})) === JSON.stringify(Ne(e.breakpoints || {})) && Ve(t, e);
            },
            atMedia: function (e) {
                var s = e.breakpoints || {},
                    i = Ne(s)
                        .filter(function (t) {
                            return window.matchMedia(t).matches;
                        })
                        .map(function (t) {
                            return s[t];
                        })
                        .reduce(function (e, s) {
                            return t(e, s);
                        }, {});
                return t(e, i);
            },
        };
    }
    function rs(t, e, s) {
        var i,
            n,
            o,
            a,
            r = We(),
            l = as(),
            c = (function () {
                var t = as(),
                    e = t.atMedia,
                    s = t.areEqual,
                    i = [],
                    n = [];
                function o(t) {
                    var i = e(t.options);
                    return function () {
                        return !s(i, e(t.options));
                    };
                }
                var a = {
                    init: function (t, s) {
                        return (
                            (n = t.map(o)),
                            (i = t.filter(function (t) {
                                return e(t.options).active;
                            })).forEach(function (t) {
                                return t.init(s);
                            }),
                            t.reduce(function (t, e) {
                                var s;
                                return Object.assign(t, (((s = {})[e.name] = e), s));
                            }, {})
                        );
                    },
                    destroy: function () {
                        i = i.filter(function (t) {
                            return t.destroy();
                        });
                    },
                    haveChanged: function () {
                        return n.some(function (t) {
                            return t();
                        });
                    },
                };
                return a;
            })(),
            h = (function () {
                var t = {};
                function e(e) {
                    return t[e] || [];
                }
                var s = {
                    emit: function (t) {
                        return (
                            e(t).forEach(function (e) {
                                return e(t);
                            }),
                            s
                        );
                    },
                    off: function (i, n) {
                        return (
                            (t[i] = e(i).filter(function (t) {
                                return t !== n;
                            })),
                            s
                        );
                    },
                    on: function (i, n) {
                        return (t[i] = e(i).concat([n])), s;
                    },
                };
                return s;
            })(),
            d = h.on,
            u = h.off,
            p = y,
            m = !1,
            _ = l.merge(os, rs.globalOptions),
            g = l.merge(_),
            f = [],
            b = 0;
        function v(e, s) {
            if (!m) {
                if (
                    ((_ = l.merge(_, e)),
                    (g = l.atMedia(_)),
                    (function () {
                        var e = g.container,
                            s = g.slides,
                            i = Me(e) ? t.querySelector(e) : e;
                        o = i || t.children[0];
                        var n = Me(s) ? o.querySelectorAll(s) : s;
                        a = [].slice.call(n || o.children);
                    })(),
                    (i = ns(t, o, a, g, h)),
                    (b = i.axis.measureSize(t.getBoundingClientRect())),
                    !g.active)
                )
                    return S();
                if ((i.translate.to(i.location), (f = s || f), (n = c.init(f, E)), g.loop)) {
                    if (!i.slideLooper.canLoop()) return S(), v({ loop: !1 }, s), void (_ = l.merge(_, { loop: !0 }));
                    i.slideLooper.loop();
                }
                g.draggable && o.offsetParent && a.length && i.dragHandler.addActivationEvents();
            }
        }
        function y(t, e) {
            var s = k();
            S(), v(l.merge({ startIndex: s }, t), e), h.emit("reInit");
        }
        function S() {
            i.dragHandler.removeAllEvents(), i.animation.stop(), i.eventStore.removeAll(), i.translate.clear(), i.slideLooper.clear(), c.destroy();
        }
        function w(t) {
            var e = i[t ? "target" : "location"].get(),
                s = g.loop ? "removeOffset" : "constrain";
            return i.slidesInView.check(i.limit[s](e));
        }
        function C(t, e, s) {
            g.active && !m && (i.scrollBody.useBaseMass().useSpeed(e ? 100 : g.speed), i.scrollTo.index(t, s || 0));
        }
        function k() {
            return i.index.get();
        }
        var E = {
            canScrollNext: function () {
                return i.index.clone().add(1).get() !== k();
            },
            canScrollPrev: function () {
                return i.index.clone().add(-1).get() !== k();
            },
            clickAllowed: function () {
                return i.dragHandler.clickAllowed();
            },
            containerNode: function () {
                return o;
            },
            internalEngine: function () {
                return i;
            },
            destroy: function () {
                m || ((m = !0), r.removeAll(), S(), h.emit("destroy"));
            },
            off: u,
            on: d,
            plugins: function () {
                return n;
            },
            previousScrollSnap: function () {
                return i.indexPrevious.get();
            },
            reInit: p,
            rootNode: function () {
                return t;
            },
            scrollNext: function (t) {
                C(i.index.clone().add(1).get(), !0 === t, -1);
            },
            scrollPrev: function (t) {
                C(i.index.clone().add(-1).get(), !0 === t, 1);
            },
            scrollProgress: function () {
                return i.scrollProgress.get(i.location.get());
            },
            scrollSnapList: function () {
                return i.scrollSnaps.map(i.scrollProgress.get);
            },
            scrollTo: C,
            selectedScrollSnap: k,
            slideNodes: function () {
                return a;
            },
            slidesInView: w,
            slidesNotInView: function (t) {
                var e = w(t);
                return i.slideIndexes.filter(function (t) {
                    return -1 === e.indexOf(t);
                });
            },
        };
        return (
            v(e, s),
            r.add(window, "resize", function () {
                var e = l.atMedia(_),
                    s = !l.areEqual(e, g),
                    n = i.axis.measureSize(t.getBoundingClientRect()),
                    o = b !== n,
                    a = c.haveChanged();
                (o || s || a) && y(), h.emit("resize");
            }),
            setTimeout(function () {
                return h.emit("init");
            }, 0),
            E
        );
    }
    (rs.globalOptions = void 0), (rs.optionsHandler = as);
    var ls = { active: !0, breakpoints: {}, selected: "is-selected", draggable: "is-draggable", dragging: "is-dragging" };
    function cs(t, e) {
        var s = t.classList;
        e && s.contains(e) && s.remove(e);
    }
    function hs(t, e) {
        var s = t.classList;
        e && !s.contains(e) && s.add(e);
    }
    function ds(t) {
        var e,
            s,
            i,
            n,
            o = rs.optionsHandler(),
            a = o.merge(ls, ds.globalOptions),
            r = ["select", "pointerUp"],
            l = ["pointerDown", "pointerUp"];
        function c(t) {
            "pointerDown" === t ? hs(i, e.dragging) : cs(i, e.dragging);
        }
        function h() {
            var t = s.slidesInView(!0);
            s.slidesNotInView(!0).forEach(function (t) {
                return cs(n[t], e.selected);
            }),
                t.forEach(function (t) {
                    return hs(n[t], e.selected);
                });
        }
        var d = {
            name: "classNames",
            options: o.merge(a, t),
            init: function (t) {
                (s = t),
                    (e = o.atMedia(d.options)),
                    (i = s.rootNode()),
                    (n = s.slideNodes()),
                    s.internalEngine().options.draggable && hs(i, e.draggable),
                    e.dragging &&
                        l.forEach(function (t) {
                            return s.on(t, c);
                        }),
                    e.selected &&
                        (r.forEach(function (t) {
                            return s.on(t, h);
                        }),
                        h());
            },
            destroy: function () {
                cs(i, e.draggable),
                    l.forEach(function (t) {
                        return s.off(t, c);
                    }),
                    r.forEach(function (t) {
                        return s.off(t, h);
                    }),
                    n.forEach(function (t) {
                        return cs(t, e.selected);
                    });
            },
        };
        return d;
    }
    ds.globalOptions = void 0;
    const us = "idle",
        ps = "running",
        ms = "paused",
        _s = "resumed";
    var gs = class {
        constructor(t, e) {
            (this.interval = e), (this.callback = t), (this.state = us), (this.pausedTime = 0), (this.remainingTime = 0);
        }
        proxyCallback() {
            (this.lastFireTime = new Date()), this.callback();
        }
        start() {
            (this.timerId = setInterval(() => this.proxyCallback(), this.interval)), (this.lastFireTime = new Date()), (this.state = ps);
        }
        pause() {
            (this.state !== ps && this.state !== _s) ||
                ((this.remainingTime = this.interval - (new Date() - this.lastFireTime) + this.pausedTime), (this.lastPauseTime = new Date()), clearInterval(this.timerId), clearTimeout(this.resumeId), (this.state = ms));
        }
        resume() {
            this.state === ms && ((this.pausedTime += new Date() - this.lastPauseTime), (this.state = _s), (this.resumeId = setTimeout(() => this.timeoutCallback(), this.remainingTime)));
        }
        timeoutCallback() {
            this.state === _s && ((this.pausedTime = 0), this.proxyCallback(), this.start());
        }
        stop() {
            this.state !== us && (clearInterval(this.timerId), clearTimeout(this.resumeId), (this.state = us));
        }
        setInterval(t) {
            this.state === ps ? (this.pause(), (this.interval = t), this.resume()) : (this.interval = t);
        }
    };
    var fs,
        bs,
        vs,
        ys,
        Ss = (t, e) => {
            const s = new gs(() => {
                const e = t.scrollSnapList().length - 1;
                t.selectedScrollSnap() === e ? t.scrollTo(0) : t.scrollNext();
            }, e);
            return {
                play: () => {
                    s.resume();
                },
                stop: () => {
                    s.stop();
                },
                start: () => {
                    s.start();
                },
                pause: () => {
                    s.pause();
                },
            };
        },
        ws = {};
    (fs = ws),
        (bs = "debounce"),
        (vs = function () {
            return Cs;
        }),
        (ys = function (t) {
            return (Cs = t);
        }),
        Object.defineProperty(fs, bs, { get: vs, set: ys, enumerable: !0, configurable: !0 });
    const Cs = (t, e) => {
        let s;
        return (...i) => {
            clearTimeout(s), (s = setTimeout(() => t.apply(void 0, i), e));
        };
    };
    var ks = class extends M {
        constructor() {
            super();
            const t = +(this.dataset.autoplayInterval || 0);
            (this.withAutoplay = t > 0), (this.isPlay = t > 0), (this.forceStopped = !1), (this._resizeObserver = new ResizeObserver(this._handleCarouselResize));
        }
        connectedCallback() {
            (this.focusableTargets = [...this.querySelectorAll(S())]),
                this._setCarousel(),
                this.focusableTargets.forEach((t) => {
                    t.addEventListener("keydown", this._handleCarouselTargetKeyDown);
                }),
                b(this, "mouseenter", this._handleCarouselEnter),
                b(this, "mouseleave", this._handleCarouselLeave),
                b(this, "keydown", this._handleKeydown),
                this.embla.on("select", this._handleCarouselSelect),
                this.embla.on("pointerUp", this._handleCarouselPointerUp),
                this.embla.on("pointerDown", this._handleCarouselPointerDown),
                this._resizeObserver.observe(this),
                this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad));
        }
        disconnectedCallback() {
            this.focusableTargets.forEach((t) => {
                t.removeEventListener("keydown", this._handleCarouselTargetKeyDown);
            }),
                v(this, "mouseenter", this._handleCarouselEnter),
                v(this, "mouseleave", this._handleCarouselLeave),
                v(this, "keydown", this._handleKeydown),
                this.embla.off("select", this._handleCarouselSelect),
                this.embla.off("pointerUp", this._handleCarouselPointerUp),
                this.embla.off("pointerDown", this._handleCarouselPointerDown),
                this._resizeObserver.disconnect(),
                this._isEditorMode && this._editor.destroy(),
                this.embla.destroy();
        }
        attributeChangedCallback = (t, e, s) => {
            e !== s && this.reInit();
        };
        _handleFontsReady = () => {
            this.reInit();
        };
        _handleCarouselTargetKeyDown = (t) => {
            t.preventDefault();
            const e = this.focusableTargets.findIndex((e) => e === t.target),
                s = this.focusableTargets[e],
                i = this.focusableTargets[e + 1],
                n = this.focusableTargets[e - 1];
            9 === t.keyCode &&
                (t.preventDefault(), document.activeElement === s && this.focusScroll(s), t.shiftKey || (i ? this.focusScroll(i) : document.activeElement.blur()), t.shiftKey && (n ? this.focusScroll(n) : document.activeElement.blur()));
        };
        _handleCarouselResize = (0, ws.debounce)(() => {
            if (this._isEditorMode) {
                const t = ke() ? "mobile" : "desktop";
                this.lastViewModeIsMobile !== t && this.forceStopped && (this.forcePlay(), this.changePlayState(!0)), (this.lastViewModeIsMobile = t);
            }
            this.reInit();
        }, 100);
        focusScroll = (t) => {
            const e = this.slides.findIndex((e) => e.contains(t));
            -1 !== e && (this.embla.scrollTo(e, !0), this.forceStop()), t.focus();
        };
        _handleCarouselEnter = () => {
            ke() || this.changePlayState(!1);
        };
        _handleCarouselSelect = () => {
            this.isTouchOnCarousel && this.forceStop();
        };
        _handleCarouselPointerUp = () => {
            this.isTouchOnCarousel = !1;
        };
        _handleCarouselPointerDown = () => {
            this.isTouchOnCarousel = !0;
        };
        _handleCarouselLeave = () => {
            ke() || this.changePlayState(!0);
        };
        _handleKeydown = (t) => {
            const e = t.key || t.keyCode,
                s = x(e),
                i = E(e);
            s && this.embla.scrollPrev(), i && this.embla.scrollNext();
        };
        _handleBlockSelect = ({ detail: { sectionId: t, blockId: e, load: s } }) => {
            if (this.dataset.sectionId === t) {
                const t = this.embla.slideNodes().findIndex(({ attributes: t }) => t["block-id"]?.value === e);
                -1 !== t && (this.embla.scrollTo(t, s), this.forceStop());
            }
        };
        _handleSectionLoad = ({ detail: { sectionId: t } }) => {
            this.dataset.sectionId === t && this.reInit();
        };
        _getOptions = () => ({
            loop: "infinite" === this.dataset.loop,
            dragFree: this.dataset.dragFree,
            draggable: !this.hasAttribute("data-draggable") || "true" === this.dataset.draggable,
            skipSnaps: this.dataset.skipSnaps || !0,
            align: this.dataset.align || "start",
            inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.75,
            containScroll: this.hasAttribute("data-contain-scroll") ? this.dataset.containScroll : "trimSnaps",
            axis: "vertical" === this.dataset.axis ? "y" : "x",
            speed: this._getSpeed(),
        });
        _getPlugins = () => [this._getClassNamesPlugin()];
        _setCarousel() {
            const t = this.querySelector("[data-carousel-viewport]");
            t && ((this.embla = rs(t, this._getOptions(), this._getPlugins())), this.withAutoplay && ((this.autoplay = Ss(this.embla, 1e3 * this.autoplayInterval)), this.autoplay.start()));
        }
        _getClassNamesPlugin() {
            return ds();
        }
        _getSpeed() {
            return Ee() || "fade" === this.dataset.animation ? 100 : 10;
        }
        changePlayState = (t) => {
            this.withAutoplay && (this.forceStopped || ((this.isPlay = t), t ? this.autoplay.play() : this.autoplay.pause(), this.emit("changePlayState", {})));
        };
        forceStop() {
            this.withAutoplay && (this.autoplay.stop(), (this.isPlay = !1), (this.forceStopped = !0), this.emit("forceChangePlayState", {}));
        }
        forcePlay() {
            this.withAutoplay && ((this.forceStopped = !1), (this.isPlay = !0), this.autoplay.start(), this.changePlayState(!1), this.emit("forceChangePlayState", {}));
        }
        reInit = (t = {}) => {
            const e = { ...this._getOptions(), ...t },
                s = this._getPlugins();
            this.embla.reInit(e, s);
        };
        scrollNext = () => {
            this.embla.scrollNext();
        };
        scrollPrev = () => {
            this.embla.scrollPrev();
        };
        canScrollNext = () => this.embla.canScrollNext();
        canScrollPrev = () => this.embla.canScrollPrev();
        get autoplayInterval() {
            return +(this.dataset.autoplayInterval || 0);
        }
        get slides() {
            return [...this.embla.slideNodes()];
        }
    };
    var Es = class extends M {
        constructor() {
            super(), (this.button = this.querySelector("[data-carousel-play-button]"));
        }
        connectedCallback() {
            this.updatePlayState(),
                this.button && this.button.addEventListener("click", this._handleButtonClick),
                this._carousel && (customElements.upgrade(this._carousel), this._carousel.subscribe("forceChangePlayState", this._handleCarouselChangePlayState));
        }
        disconnectedCallback() {
            this.button && this.button.removeEventListener("click", this._handleButtonClick), this._carousel && this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselChangePlayState);
        }
        _handleCarouselChangePlayState = () => {
            this.updatePlayState();
        };
        _handleButtonClick = (t) => {
            if ((t.stopPropagation(), !this._carousel)) return;
            this._carousel.forceStopped ? this._carousel.forcePlay() : this._carousel.forceStop();
        };
        updatePlayState() {
            if (!this._carousel || !this.button) return;
            const t = this._carousel.forceStopped;
            this.button.setAttribute("data-autoplay-stopped", t ? "true" : "false");
        }
        get _carousel() {
            return this.closest("carousel-component");
        }
    };
    function xs() {
        return (
            (xs =
                Object.assign ||
                function (t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var s = arguments[e];
                        for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && (t[i] = s[i]);
                    }
                    return t;
                }),
            xs.apply(this, arguments)
        );
    }
    function Is(t, e) {
        if (t.length !== e.length) throw new Error("vectors must be same length");
        return t.map(function (t, s) {
            return t + e[s];
        });
    }
    function Ls(t) {
        return Math.max.apply(Math, t.map(Math.abs));
    }
    function Ts(t) {
        return (
            Object.freeze(t),
            Object.values(t).forEach(function (t) {
                null === t || "object" != typeof t || Object.isFrozen(t) || Ts(t);
            }),
            t
        );
    }
    var Ms = [1, 18, ("undefined" != typeof window && window.innerHeight) || 800];
    var Bs = [-1, -1, -1];
    var As = function (t) {
            return xs({}, t, {
                axisDelta: t.axisDelta.map(function (t) {
                    return (e = t), (s = -700), (i = 700), Math.min(Math.max(s, e), i);
                    var e, s, i;
                }),
            });
        },
        Ps = Ts({ preventWheelAction: !0, reverseSign: [!0, !0, !1] }),
        Ds = 400;
    function qs() {
        return {
            isStarted: !1,
            isStartPublished: !1,
            isMomentum: !1,
            startTime: 0,
            lastAbsDelta: 1 / 0,
            axisMovement: [0, 0, 0],
            axisVelocity: [0, 0, 0],
            accelerationFactors: [],
            scrollPoints: [],
            scrollPointsToMerge: [],
            willEndTimeout: Ds,
        };
    }
    var Os = function (t) {
            void 0 === t && (t = {});
            var e,
                s,
                i,
                n = (function () {
                    var t = {};
                    function e(e, s) {
                        t[e] = (t[e] || []).filter(function (t) {
                            return t !== s;
                        });
                    }
                    return Ts({
                        on: function (s, i) {
                            return (
                                (t[s] = (t[s] || []).concat(i)),
                                function () {
                                    return e(s, i);
                                }
                            );
                        },
                        off: e,
                        dispatch: function (e, s) {
                            e in t &&
                                t[e].forEach(function (t) {
                                    return t(s);
                                });
                        },
                    });
                })(),
                o = n.on,
                a = n.off,
                r = n.dispatch,
                l = Ps,
                c = qs(),
                h = !1,
                d = function (t) {
                    Array.isArray(t)
                        ? t.forEach(function (t) {
                              return m(t);
                          })
                        : m(t);
                },
                u = function (t) {
                    return (
                        void 0 === t && (t = {}),
                        Object.values(t).some(function (t) {
                            return null == t;
                        })
                            ? l
                            : (l = Ts(xs({}, Ps, l, t)))
                    );
                },
                p = function (t) {
                    var i = xs(
                        {
                            event: e,
                            isStart: !1,
                            isEnding: !1,
                            isMomentumCancel: !1,
                            isMomentum: c.isMomentum,
                            axisDelta: [0, 0, 0],
                            axisVelocity: c.axisVelocity,
                            axisMovement: c.axisMovement,
                            get axisMovementProjection() {
                                return Is(
                                    i.axisMovement,
                                    i.axisVelocity.map(function (t) {
                                        return void 0 === e && (e = 0.996), (t * e) / (1 - e);
                                        var e;
                                    })
                                );
                            },
                        },
                        t
                    );
                    r("wheel", xs({}, i, { previous: s })), (s = i);
                },
                m = function (t) {
                    var s = As(
                            (function (t, e) {
                                if (!e) return t;
                                var s =
                                    !0 === e
                                        ? Bs
                                        : e.map(function (t) {
                                              return t ? -1 : 1;
                                          });
                                return xs({}, t, {
                                    axisDelta: t.axisDelta.map(function (t, e) {
                                        return t * s[e];
                                    }),
                                });
                            })(
                                (function (t) {
                                    var e = t.deltaX * Ms[t.deltaMode],
                                        s = t.deltaY * Ms[t.deltaMode],
                                        i = (t.deltaZ || 0) * Ms[t.deltaMode];
                                    return { timeStamp: t.timeStamp, axisDelta: [e, s, i] };
                                })(t),
                                l.reverseSign
                            )
                        ),
                        i = s.axisDelta,
                        n = s.timeStamp,
                        o = Ls(i);
                    t.preventDefault &&
                        (function (t, e) {
                            var s = l.preventWheelAction,
                                i = e[0],
                                n = e[1],
                                o = e[2];
                            if ("boolean" == typeof s) return s;
                            switch (s) {
                                case "x":
                                    return Math.abs(i) >= t;
                                case "y":
                                    return Math.abs(n) >= t;
                                case "z":
                                    return Math.abs(o) >= t;
                                default:
                                    return !1;
                            }
                        })(o, i) &&
                        t.preventDefault(),
                        c.isStarted ? c.isMomentum && o > Math.max(2, 2 * c.lastAbsDelta) && (k(!0), w()) : w(),
                        0 === o && Object.is && Object.is(t.deltaX, -0)
                            ? (h = !0)
                            : ((e = t),
                              (c.axisMovement = Is(c.axisMovement, i)),
                              (c.lastAbsDelta = o),
                              c.scrollPointsToMerge.push({ axisDelta: i, timeStamp: n }),
                              _(),
                              p({ axisDelta: i, isStart: !c.isStartPublished }),
                              (c.isStartPublished = !0),
                              C());
                },
                _ = function () {
                    var t;
                    2 === c.scrollPointsToMerge.length
                        ? (c.scrollPoints.unshift({
                              axisDeltaSum: c.scrollPointsToMerge
                                  .map(function (t) {
                                      return t.axisDelta;
                                  })
                                  .reduce(Is),
                              timeStamp:
                                  ((t = c.scrollPointsToMerge.map(function (t) {
                                      return t.timeStamp;
                                  })),
                                  t.reduce(function (t, e) {
                                      return t + e;
                                  }) / t.length),
                          }),
                          f(),
                          (c.scrollPointsToMerge.length = 0),
                          (c.scrollPoints.length = 1),
                          c.isMomentum || y())
                        : c.isStartPublished || g();
                },
                g = function () {
                    var t;
                    c.axisVelocity = ((t = c.scrollPointsToMerge), t[t.length - 1]).axisDelta.map(function (t) {
                        return t / c.willEndTimeout;
                    });
                },
                f = function () {
                    var t = c.scrollPoints,
                        e = t[0],
                        s = t[1];
                    if (s && e) {
                        var i = e.timeStamp - s.timeStamp;
                        if (!(i <= 0)) {
                            var n = e.axisDeltaSum.map(function (t) {
                                    return t / i;
                                }),
                                o = n.map(function (t, e) {
                                    return t / (c.axisVelocity[e] || 1);
                                });
                            (c.axisVelocity = n), c.accelerationFactors.push(o), b(i);
                        }
                    }
                },
                b = function (t) {
                    var e = 12 * Math.ceil(t / 10);
                    c.isMomentum || (e = Math.max(100, 2 * e)), (c.willEndTimeout = Math.min(1e3, Math.round(e)));
                },
                v = function (t) {
                    return 0 === t || (t <= 0.96 && t >= 0.6);
                },
                y = function () {
                    if (c.accelerationFactors.length >= 5) {
                        if (h && ((h = !1), Ls(c.axisVelocity) >= 0.2)) return void S();
                        var t = c.accelerationFactors.slice(-5);
                        t.every(function (t) {
                            var e = !!t.reduce(function (t, e) {
                                    return t && t < 1 && t === e ? 1 : 0;
                                }),
                                s = t.filter(v).length === t.length;
                            return e || s;
                        }) && S(),
                            (c.accelerationFactors = t);
                    }
                },
                S = function () {
                    c.isMomentum = !0;
                },
                w = function () {
                    ((c = qs()).isStarted = !0), (c.startTime = Date.now()), (s = void 0), (h = !1);
                },
                C = function () {
                    clearTimeout(i), (i = setTimeout(k, c.willEndTimeout));
                },
                k = function (t) {
                    void 0 === t && (t = !1), c.isStarted && (c.isMomentum && t ? p({ isEnding: !0, isMomentumCancel: !0 }) : p({ isEnding: !0 }), (c.isMomentum = !1), (c.isStarted = !1));
                },
                E = (function (t) {
                    var e = [],
                        s = function (s) {
                            s.removeEventListener("wheel", t),
                                (e = e.filter(function (t) {
                                    return t !== s;
                                }));
                        };
                    return Ts({
                        observe: function (i) {
                            return (
                                i.addEventListener("wheel", t, { passive: !1 }),
                                e.push(i),
                                function () {
                                    return s(i);
                                }
                            );
                        },
                        unobserve: s,
                        disconnect: function () {
                            e.forEach(s);
                        },
                    });
                })(d),
                x = E.observe,
                I = E.unobserve,
                L = E.disconnect;
            return u(t), Ts({ on: o, off: a, observe: x, unobserve: I, disconnect: L, feedWheel: d, updateOptions: u });
        },
        Rs = { active: !0, breakpoints: {}, wheelDraggingClass: "is-wheel-dragging", forceWheelAxis: void 0, target: void 0 };
    Ns.globalOptions = void 0;
    var Fs = !1;
    function Ns(t) {
        var e,
            s = rs.optionsHandler(),
            i = s.merge(Rs, Ns.globalOptions),
            n = function () {};
        var o = {
            name: "wheelGestures",
            options: s.merge(i, t),
            init: function (t) {
                var i, a;
                e = s.atMedia(o.options);
                var r,
                    l = t.internalEngine(),
                    c = null != (i = e.target) ? i : t.containerNode().parentNode,
                    h = null != (a = e.forceWheelAxis) ? a : l.options.axis,
                    d = Os({ preventWheelAction: h, reverseSign: [!0, !0, !1] }),
                    u = d.observe(c),
                    p = d.on("wheel", function (t) {
                        var s = t.axisDelta,
                            i = s[0],
                            o = s[1],
                            a = "x" === h ? i : o,
                            l = "x" === h ? o : i,
                            d = t.isMomentum && t.previous && !t.previous.isMomentum,
                            u = (t.isEnding && !t.isMomentum) || d;
                        Math.abs(a) > Math.abs(l) &&
                            !m &&
                            !t.isMomentum &&
                            (function (t) {
                                try {
                                    b((r = new MouseEvent("mousedown", t.event)));
                                } catch (t) {
                                    return Fs && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
                                }
                                (m = !0),
                                    document.documentElement.addEventListener("mousemove", g, !0),
                                    document.documentElement.addEventListener("mouseup", g, !0),
                                    void document.documentElement.addEventListener("mousedown", g, !0),
                                    e.wheelDraggingClass && c.classList.add(e.wheelDraggingClass);
                            })(t);
                        if (!m) return;
                        u
                            ? (function (t) {
                                  (m = !1), b(f("mouseup", t)), _(), e.wheelDraggingClass && c.classList.remove(e.wheelDraggingClass);
                              })(t)
                            : b(f("mousemove", t));
                    }),
                    m = !1;
                function _() {
                    document.documentElement.removeEventListener("mousemove", g, !0), document.documentElement.removeEventListener("mouseup", g, !0), document.documentElement.removeEventListener("mousedown", g, !0);
                }
                function g(t) {
                    m && t.isTrusted && t.stopImmediatePropagation();
                }
                function f(t, e) {
                    var s, i;
                    if (h === l.options.axis) {
                        var n = e.axisMovement;
                        (s = n[0]), (i = n[1]);
                    } else {
                        var o = e.axisMovement;
                        (i = o[0]), (s = o[1]);
                    }
                    return new MouseEvent(t, { clientX: r.clientX + s, clientY: r.clientY + i, screenX: r.screenX + s, screenY: r.screenY + i, movementX: s, movementY: i, button: 0, bubbles: !0, cancelable: !0, composed: !0 });
                }
                function b(e) {
                    t.containerNode().dispatchEvent(e);
                }
                n = function () {
                    u(), p(), _();
                };
            },
            destroy: function () {
                return n();
            },
        };
        return o;
    }
    var Hs = class extends M {
        connectedCallback() {
            this._init(), this._carousel && this._carousel.embla.on("reInit", this._handleCarouselReInit), this.embla.on("resize", this._handleCarouselResize);
        }
        disconnectedCallback() {
            this._carousel && this._carousel.embla.off("reInit", this._handleCarouselReInit), this.embla.off("resize", this._handleCarouselResize), this.embla.destroy();
        }
        _handleCarouselReInit = () => {
            this.embla.reInit(this._getOptions(), this._getPlugins());
        };
        _handleCarouselResize = () => {
            this.embla.reInit(this._getOptions(), this._getPlugins());
        };
        _getOptions = () => ({
            inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.5,
            containScroll: this.hasAttribute("data-contain-scroll") ? this.dataset.containScroll : "keepSnaps",
            align: this.dataset.align || "center",
            speed: this._getSpeed(),
            skipSnaps: this.hasAttribute("data-skip-snaps"),
            draggable: this.hasAttribute("is-draggable"),
            axis: this._axis,
        });
        _getPlugins = () => {
            const t = [],
                e = ds();
            if ((t.push(e), this.hasAttribute("data-with-wheel-gestures"))) {
                const e = Ns({ forceWheelAxis: this._axis });
                t.push(e);
            }
            return t;
        };
        _getSpeed() {
            return Ee() ? 100 : 80;
        }
        _init() {
            const t = this.querySelector("[data-carousel-viewport]");
            t && (this.embla = rs(t, this._getOptions(), this._getPlugins()));
        }
        scrollNext = () => {
            this._carousel && this._carousel.embla.scrollNext();
        };
        scrollPrev = () => {
            this._carousel && this._carousel.embla.scrollPrev();
        };
        canScrollNext = () => !!this._carousel && this._carousel.embla.canScrollNext();
        canScrollPrev = () => !!this._carousel && this._carousel.embla.canScrollPrev();
        get _carousel() {
            return this.closest("carousel-component");
        }
        get _axis() {
            return "vertical" === this.dataset.axis ? "y" : "x";
        }
    };
    var Vs = class extends M {
        constructor() {
            super(), (this._autoplayLoader = this.querySelector("[data-autoplay-indicator]")), (this._dotsCarousel = this.closest("carousel-dots"));
        }
        connectedCallback() {
            this._updateAutoplayIndicator(),
                this._carousel &&
                    (customElements.upgrade(this._carousel),
                    this._carousel.subscribe("changePlayState", this._handleCarouselChangePlayState),
                    this._carousel.subscribe("forceChangePlayState", this._handleCarouselForceChangePlayState),
                    this._carousel.embla.on("select", this._handleCarouselSelect)),
                this._updateDot(),
                this._dotsCarousel &&
                    (this._dotsCarousel.embla.on("settle", this._handleDotCarouselSettle), this._dotsCarousel.embla.on("reInit", this._handleCarouselSelect), this._dotsCarousel.embla.on("resize", this._handleDotCarouselResize)),
                b(this, "focus", this._handleFocus),
                b(this, "blur", this._handleBlur),
                b(this, "click", this._handleDotClick);
        }
        disconnectedCallback() {
            this._carousel &&
                (this._carousel.unsubscribe("changePlayState", this._handleCarouselChangePlayState),
                this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselForceChangePlayState),
                this._carousel.embla.off("select", this._handleCarouselSelect)),
                this._dotsCarousel &&
                    (this._dotsCarousel.embla.off("settle", this._handleDotCarouselSettle),
                    this._dotsCarousel.embla.off("reInit", this._handleCarouselSelect),
                    this._dotsCarousel.embla.off("resize", this._handleDotCarouselResize),
                    this._dotsCarousel.embla.destroy()),
                v(this, "focus", this._handleFocus),
                v(this, "blur", this._handleBlur),
                v(this, "click", this._handleDotClick);
        }
        _handleCarouselForceChangePlayState = () => {
            if (!this._autoplayLoader || !this._carousel) return;
            const t = this._carousel.forceStopped;
            this._autoplayLoader.setAttribute("data-autoplay-stopped", t ? "true" : "false");
        };
        _handleCarouselChangePlayState = () => {
            this._updateAutoplayIndicator();
        };
        _handleDotClick = () => {
            this.trigger();
        };
        _handleCarouselSelect = () => {
            if (!this._carousel || !this._dotsCarousel) return;
            const t = this._carousel.embla.selectedScrollSnap();
            t === this._currentDotIndex ? (this._dotsCarousel.embla.scrollTo(t), this.classList.add("is-primary")) : this.classList.remove("is-primary");
        };
        _handleDotCarouselSettle = () => {
            this._updateDot();
        };
        _handleDotCarouselResize = () => {
            this._updateDot();
        };
        _handleFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.trigger());
        };
        _updateDot() {
            if (!this._dotsCarousel) return;
            this.classList.remove("is-prev-prev");
            const t = this._dotsCarousel.embla.slideNodes().map((t, e) => e),
                e = this._dotsCarousel.embla.slidesInView(),
                s = t[0],
                i = e[0],
                n = t[t.length - 1],
                o = e[e.length - 1],
                a = this._currentDotIndex === n,
                r = this._currentDotIndex === o,
                l = this._currentDotIndex === s;
            (!(this._currentDotIndex === i) && !r) || a || l || this.classList.add("is-prev-prev");
        }
        _updateAutoplayIndicator() {
            if (!this._carousel) return;
            const t = this._carousel.isPlay;
            this._autoplayLoader && this._autoplayLoader.setAttribute("data-play-state", t ? "true" : "false");
        }
        trigger() {
            this._carousel && (this._carousel.embla.scrollTo(this._currentDotIndex), this._carousel.forceStop());
        }
        get _currentDotIndex() {
            return this._dotsCarousel ? [...this._dotsCarousel.embla.slideNodes()].indexOf(this) : -1;
        }
        get _carousel() {
            return this.closest("carousel-component");
        }
    };
    var zs = class extends M {
        connectedCallback() {
            this._update(),
                this._carousel && (this._carousel.embla.on("reInit", this._handleCarouselReInit), this._carousel.embla.on("select", this._handleCarouselSelect), this._carousel.embla.on("scroll", this._handleCarouselScroll)),
                b(this, "focus", this._handleButtonFocus),
                b(this, "blur", this._handleButtonBlur),
                b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            this._carousel && (this._carousel.embla.off("reInit", this._handleCarouselReInit), this._carousel.embla.off("select", this._handleCarouselSelect), this._carousel.embla.off("scroll", this._handleCarouselScroll)),
                v(this, "focus", this._handleButtonFocus),
                v(this, "blur", this._handleButtonBlur),
                v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.trigger();
        };
        _handleCarouselReInit = () => {
            this._update();
        };
        _handleCarouselSelect = () => {
            this._update();
        };
        _handleCarouselScroll = (0, ws.debounce)(() => {
            this._update();
        }, 50);
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.trigger());
        };
        _update() {
            this._updateDisabled(), this._updateVisible();
        }
        _updateDisabled = () => {
            this.toggleAttribute("disabled", !this._canScroll());
        };
        _updateVisible() {
            if (!this._carousel) return;
            const t = [...Array(this._carousel.embla.slideNodes().length).keys()].length - 1,
                e = this._carousel.embla.slidesInView(),
                s = "next" === this.dataset.scrollDirection ? e.includes(t) : e.includes(0);
            this.toggleAttribute("has-not-slides-not-in-view", s);
        }
        _canScroll() {
            if (!this._carousel) return !1;
            return "next" === this.dataset.scrollDirection ? this._carousel.canScrollNext() : this._carousel.canScrollPrev();
        }
        trigger() {
            if (!this._carousel) return;
            const { scrollNext: t, scrollPrev: e } = this._carousel;
            "next" === this.dataset.scrollDirection ? t() : e();
        }
        get _carousel() {
            const t = this.closest("carousel-dots"),
                e = this.closest("carousel-component");
            return t || e;
        }
    };
    var $s = class extends M {
        constructor() {
            super(), (this._eventSetProgress = "scroll" === this.dataset.target ? "scroll" : "settle");
        }
        connectedCallback() {
            this.updateProgressBar(), this._carousel && (this._carousel.embla.on(this._eventSetProgress, this._handleProgress), this._carousel.embla.on("reInit", this._handleCarouselReInit));
        }
        disconnectedCallback() {
            this._carousel && (this._carousel.embla.off(this._eventSetProgress, this._handleProgress), this._carousel.embla.off("reInit", this._handleCarouselReInit));
        }
        _handleProgress = () => {
            this.updateProgressBar();
        };
        _handleCarouselReInit = () => {
            this.updateProgressBar();
        };
        updateProgressBar() {
            const t = this.querySelector("[data-carousel-progress-indicator]");
            if (!t) return;
            const e = this.getProgress(),
                s = "vertical" === this.dataset.axis;
            t.style.transform = s ? `translate3d(0, ${e}%, 0)` : `translate3d(${e}%, 0, 0)`;
        }
        getProgress() {
            return "scroll" === this.dataset.target ? this.getProgressByScroll() : this.getProgressBySlideInView();
        }
        getProgressBySlideInView() {
            if (!this._carousel) return 0;
            const t = this._carousel.embla.slideNodes().length,
                e = this._carousel.embla.slidesInView(),
                s = e[e.length - 1] + 1,
                i = 100 / t;
            return Math.ceil(i * s);
        }
        getProgressByScroll() {
            if (!this._carousel) return 0;
            const t = this._carousel.embla.scrollProgress();
            return 100 * Math.max(0, Math.min(1, t));
        }
        get _carousel() {
            return this.closest("carousel-component");
        }
    };
    var Ks = class extends M {
        constructor() {
            super(), (this._lastScrollPosition = 0), (this._resizeObserver = new ResizeObserver(this._handleResize)), (this._dropdowns = [...this.querySelectorAll("[data-header-dropdown]")]);
        }
        connectedCallback() {
            this._setSticky(),
                this.updatePosition(),
                b(window, "scroll", this._handleScroll),
                this._dropdowns.forEach((t) => {
                    customElements.upgrade(t), t.subscribe("show", this._handleDropdownShow), t.subscribe("hide", this._handleDrodpownHide);
                }),
                this._resizeObserver.observe(this);
        }
        disconnectedCallback() {
            v(window, "scroll", this._handleScroll),
                this._dropdowns.forEach((t) => {
                    t.unsubscribe("show", this._handleDropdownShow), t.unsubscribe("hide", this._handleDrodpownHide);
                }),
                this._resizeObserver.disconnect();
        }
        _handleResize = (0, ws.debounce)(() => {
            this._setHidden(!1), this.updatePosition(), this.updateDropdowns();
        }, 100);
        _handleScroll = () => {
            ke() && this._updateVisibleAfterScroll(), this._setScrollStatus();
        };
        _handleDrodpownHide = () => {
            this.classList.remove("header--light-bordered");
        };
        _handleDropdownShow = () => {
            this.classList.add("header--light-bordered");
        };
        _setScrollStatus() {
            if (!this._headerSection) return;
            const t = this._announcementBar ? this._scrollPosition >= this._announcementBar.offsetHeight : this._scrollPosition >= 0;
            this._headerSection.toggleAttribute("scrolled", t);
        }
        updateDropdowns() {
            this._dropdowns.forEach((t) => {
                t.update();
            });
        }
        _updateVisibleAfterScroll() {
            const t = window.scrollY,
                e = this._lastScrollPosition < t,
                s = this._announcementBar ? this._announcementBar.offsetHeight : 0,
                i = this._headerSection ? this._headerSection.offsetHeight : 0,
                n = e && t > s + i;
            this._headerSection && this._setHidden(n), (this._lastScrollPosition = t);
        }
        _setHidden(t) {
            this._headerSection && this._headerSection.setAttribute("aria-hidden", t ? "true" : "false");
        }
        _setSticky() {
            this._headerSection && (this._headerSection.setAttribute("mobile-sticky", ""), this._headerSection.toggleAttribute("desktop-sticky", this._isSticky));
        }
        updatePosition() {
            if (!this._headerSection) return;
            const t = this.getBoundingClientRect();
            var e, s;
            (e = "header-bottom-side"), (s = `${t.bottom}px`), document.documentElement.style.setProperty(`--gsc-${e}`, s);
        }
        get _scrollPosition() {
            return window.scrollY || Math.abs(parseInt(document.body.style.top || "0"));
        }
        get _isSticky() {
            return this.hasAttribute("is-sticky");
        }
        get _headerSection() {
            return document.querySelector(".shopify-section-header");
        }
        get _announcementBar() {
            return document.querySelector(".shopify-section-announcement-bar");
        }
    };
    var Ws = class extends Ce {
        constructor() {
            super(),
                (this.header = document.querySelector("header-component")),
                (this.pages = [...this.element.querySelectorAll("drawer-menu-page")]),
                (this.pageMap = this.generatePageMap()),
                (this.homePage = this.pageMap.Menu),
                (this.toggler = document.getElementById("DrawerMenuToggler"));
        }
        connectedCallback() {
            super.connectedCallback(),
                this.mountBlocks(),
                this.pages.forEach((t) => {
                    t.addEventListener("keydown", this.handlePageKeydown);
                }),
                this._isEditorMode &&
                    (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect),
                    this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect),
                    this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect),
                    this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect));
        }
        disconnectedCallback() {
            super.disconnectedCallback(),
                this.pages.forEach((t) => {
                    t.removeEventListener("keydown", this.handlePageKeydown);
                }),
                this._isEditorMode && this._editor.destroy();
        }
        _handleSectionLoad = () => {};
        _handleSectionSelect = ({ detail: { sectionId: t } }) => {
            this.isVisible && this.dataset.sectionId === t && (this.mount(), this.reset());
        };
        _handleSectionDeselect = ({ detail: { sectionId: t } }) => {
            this.isVisible && this.dataset.sectionId === t && (this.reset(), this.hide(!0));
        };
        _handleBlockSelect = ({ detail: { blockId: t, sectionId: e } }) => {
            if (this.dataset.sectionId === e) {
                const e = this.pages.find((e) => e.getAttribute("block-id") === t);
                if (!e) return;
                this.open(), this.setPage(e);
            }
        };
        _handleBlockDeselect = ({ detail: { blockId: t, sectionId: e } }) => {
            if (this.dataset.sectionId === e) {
                if (!this.pages.find((e) => e.getAttribute("block-id") === t)) return;
                this.hide(!0);
            }
        };
        handlePageKeydown = (t) => {
            const e = t.target,
                s = e.closest("drawer-menu-page");
            if (!s) return;
            const i = s.querySelectorAll(S()),
                n = e === i[i.length - 1],
                o = e === i[0],
                a = t.shiftKey;
            9 === t.keyCode && ((a && o) || (!a && n)) && (t.preventDefault(), this.focusOnToggler());
        };
        focusOnToggler() {
            this.toggler && (this.toggler.focus(), this.hide());
        }
        generatePageMap() {
            return this.pages.reduce((t, e) => {
                const s = e.dataset.pageId;
                return s ? { ...t, [s]: e } : t;
            }, {});
        }
        setPage(t) {
            const e = t.dataset.pageId,
                s = this.openedPage?.dataset.prevPageId,
                i = e === s,
                n = t.hasAttribute("data-empty-menu");
            this.openedPage && (i || n) && this.setPageVisible(this.openedPage, !1);
            const o = t.querySelector(S());
            o && o.focus(), this.setPageVisible(t, !0), (this.openedPage = t);
        }
        reset() {
            this.pages.forEach((t) => {
                this.setPageVisible(t, !1);
            }),
                this.setPageVisible(this.homePage, !0),
                (this.openedPage = this.homePage);
        }
        setPageVisible(t, e) {
            t.setAttribute("aria-hidden", e ? "false" : "true");
        }
        open() {
            return this.header && this.header.updatePosition(), super.open();
        }
        hide(t) {
            return this.reset(), super.hide(t);
        }
        mountBlocks() {
            const t = this.element.querySelectorAll("[data-drawer-menu-target-block-id]"),
                e = this.element.querySelector("#drawer-menu-blocks-template"),
                s = U(e);
            t.forEach((t) => {
                const e = t.getAttribute("data-drawer-menu-target-block-id"),
                    i = s.querySelector(`[data-drawer-menu-block-id="${e}"]`);
                i && ((t.className = `${t.className} ${i.className}`), (t.innerHTML = i.innerHTML));
            });
        }
        getPage(t) {
            return this.pageMap[t];
        }
        get isVisible() {
            const t = matchMedia("(max-width: 1016px)").matches;
            return this.hasAttribute("data-drawer-menu-is-section") || t;
        }
    };
    var Us = class extends M {
        constructor() {
            super(), (this.block = this.querySelector("[data-drawer-menu-content]"));
        }
        connectedCallback() {
            this.block && this.block.addEventListener("scroll", this._handleBlockScroll);
        }
        disconnectedCallback() {
            this.block && this.block.removeEventListener("scroll", this._handleBlockScroll);
        }
        _handleBlockScroll = () => {
            if (!this.block) return;
            const t = this.block.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", t);
        };
    };
    var Ys = class extends M {
        connectedCallback() {
            b(this, "click", this._handlePageLinkClick), b(this, "keyup", this._handleKeyUp);
        }
        disconnectedCallback() {
            v(this, "click", this._handlePageLinkClick), v(this, "keyup", this._handleKeyUp);
        }
        _handlePageLinkClick = (t) => {
            t.preventDefault(), this.setPage();
        };
        _handleKeyUp = (t) => {
            t.preventDefault();
            const e = t.key || t.keyCode;
            k(e) && this.setPage();
        };
        setPage() {
            const t = this.closest("drawer-menu"),
                e = this.dataset.pageId;
            if (!e || !t) return;
            const s = t.getPage(e);
            s && t.setPage(s);
        }
    };
    var Xs = class {
        constructor(t) {
            this._element = t;
        }
        show() {
            this._element.classList.remove("hidden");
        }
        hide() {
            this._element.classList.add("hidden");
        }
    };
    var Qs = class extends M {
        constructor() {
            super(), (this.cache = {});
        }
        updateTargetsFromHTML(t) {
            if (!this.dataset.containerId) return;
            const e = t.getElementById(this.dataset.containerId),
                s = document.getElementById(this.dataset.containerId);
            if (e && s) {
                e.querySelectorAll(`.${this.dataset.target}`).forEach((t) => s.appendChild(t));
            }
        }
        updateResultsFromHTML(t) {
            if (!this.dataset.containerId) return;
            const e = t.getElementById(this.dataset.containerId),
                s = document.getElementById(this.dataset.containerId);
            e && s && ((s.innerHTML = e.innerHTML), s.scrollIntoView({ behavior: "smooth" }));
        }
        updateFromHTML(t) {
            const e = t.querySelector("pagination-component");
            e && (this.innerHTML = e.innerHTML);
        }
        get loadingOverlay() {
            const t = document.getElementById(this.dataset.overlayId || "");
            return new Xs(t);
        }
    };
    var js = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this._fetchResults();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this._fetchResults());
        };
        _fetchResults() {
            const t = this.dataset.url;
            t &&
                (this._setLoadingStatus(!0),
                fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = Q(t);
                        this._setLoadingStatus(!1), this._updateFromHTML(e), this._updatePaginationFromHTML(e);
                    })
                    .catch(() => {
                        u.notification && u.notification.show("Error in pagination load button component", "warning");
                    }));
        }
        _updatePaginationFromHTML(t) {
            const e = this.closest("pagination-component");
            e && (e.updateTargetsFromHTML(t), e.updateFromHTML(t));
        }
        _setPaginationUrl(t) {
            this.dataset.url = t.dataset.url;
        }
        _removePagination() {
            const t = this.closest("pagination-component");
            t && t.remove();
        }
        _updateFromHTML(t) {
            const e = t.querySelector("pagination-load-button");
            e ? this._setPaginationUrl(e) : this._removePagination();
        }
        _setLoadingStatus(t) {
            this.toggleAttribute("disabled", t), this.classList.toggle("loading", t);
        }
    };
    var Gs = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleLinkFocus), b(this, "blur", this._handleLinkBlur), b(this, "click", this._handleLinkClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleLinkFocus), v(this, "blur", this._handleLinkBlur), v(this, "click", this._handleLinkClick);
        }
        _handleLinkClick = () => {
            this._fetchResults();
        };
        _handleLinkFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleLinkBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this._fetchResults());
        };
        _fetchResults() {
            const t = this.closest("pagination-component"),
                e = this.dataset.url;
            t && e && (t.cache[e] ? this._updatePaginationFromHTML(t.cache[e]) : this._getFromUrl(e));
        }
        _getFromUrl(t) {
            const e = this.closest("pagination-component");
            e &&
                (e.loadingOverlay.show(),
                fetch(t)
                    .then((t) => t.text())
                    .then((s) => {
                        const i = Q(s);
                        e.loadingOverlay.hide(), (e.cache[t] = i), this._updatePaginationFromHTML(i);
                    })
                    .catch(() => {
                        u.notification && u.notification.show("Error in pagination link component", "warning");
                    }));
        }
        _updatePaginationFromHTML(t) {
            const e = this.closest("pagination-component");
            e && (e.updateResultsFromHTML(t), e.updateFromHTML(t));
        }
    };
    var Zs = class extends M {
        constructor() {
            super(),
                (this._observerOptions = { root: null, rootMargin: "-35% 0px -35% 0px" }),
                (this._preloaderSelector = ".loading-spinner"),
                (this._preloader = this.querySelector(this._preloaderSelector)),
                (this._preloaderComponent = new Xs(this._preloader));
        }
        connectedCallback() {
            (this._intersectionObserver = new IntersectionObserver(this._handleIntersectionObserve, this._observerOptions)), this._intersectionObserver.observe(this);
        }
        disconnectedCallback() {
            this._intersectionObserver.disconnect();
        }
        _handleIntersectionObserve = (t) => {
            const e = this.dataset.url;
            if (e) {
                if (!t[0].isIntersecting) return;
                this._preloaderComponent.show(),
                    fetch(e)
                        .then((t) => t.text())
                        .then((t) => {
                            const e = Q(t),
                                s = this.closest("pagination-component");
                            this._preloaderComponent.hide(), this._updateFromHTML(e), s && s.updateTargetsFromHTML(e);
                        })
                        .catch(() => {
                            u.notification && u.notification.show("Error in infinite scroll component", "warning");
                        });
            }
        };
        _updateFromHTML(t) {
            const e = t.querySelector("pagination-infinite-scroll");
            if (e) {
                const t = e.dataset.url;
                t ? this._setPaginationUrl(t) : this._intersectionObserver.unobserve(this);
            }
        }
        _setPaginationUrl(t) {
            this.dataset.url = t;
        }
    };
    var Js = class extends M {
        constructor() {
            super(), (this._poster = this.querySelector('[id^="Deferred-Poster-"]')), (this._carousel = this.closest("carousel-component"));
        }
        connectedCallback() {
            this.hasAttribute("data-autoplay") && this.loadContent(), b(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.on("select", this._handleCarouselSelect);
        }
        disconnectedCallback() {
            v(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.off("select", this._handleCarouselSelect);
        }
        _handleCarouselSelect = () => {
            this._removeVideo();
        };
        _handlePosterClick = () => {
            this.loadContent();
        };
        loadContent() {
            this.getAttribute("loaded") || (this._addVideo(), this.setAttribute("loaded", "true"));
        }
        _removeVideo() {
            const t = this.querySelector("video,  iframe");
            t && (t.remove(), this.removeAttribute("loaded"));
        }
        _addVideo() {
            const t = document.createElement("div"),
                e = this.querySelector("template"),
                s = e?.content;
            if (!s || !s.firstElementChild) return;
            const i = s.firstElementChild.cloneNode(!0);
            t.appendChild(i);
            const n = t.querySelector("video, model-viewer, iframe");
            n && (this.appendChild(n), "VIDEO" === n.tagName && n.play());
        }
    };
    var ti = class extends M {
        connectedCallback() {
            this.fetchAvailability();
        }
        fetchAvailability() {
            const t = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`;
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const e = Q(t).querySelector(".shopify-section");
                    this.updateSidebarFromHTML(e), this.updateContentFromHTML(e);
                })
                .catch(() => {
                    u.notification && u.notification.show("Error in pickup availability component", "warning");
                });
        }
        updateVariantId(t) {
            this.dataset.variantId = t;
        }
        updateContentFromHTML(t) {
            const e = this.querySelector("pickup-availability-content"),
                s = t.querySelector("pickup-availability-content");
            e && s && (e.innerHTML = s.innerHTML);
        }
        updateSidebarFromHTML(t) {
            const e = document.querySelector("#pickup-availability-sidebar"),
                s = t.querySelector("#pickup-availability-sidebar template");
            e && s && e.updateTemplate(s);
        }
    };
    var ei = class {
        constructor(t) {
            (this._element = t), (this._text = this._element.querySelector("[data-button-text]"));
        }
        setDisable(t) {
            this._element.toggleAttribute("disabled", t);
        }
        setLoading(t) {
            this._element.classList.toggle("loading", t);
        }
        setText(t) {
            this._text && (this._text.textContent = t);
        }
    };
    const { routes: si } = window;
    var ii = class {
        change(t) {
            return fetch(si.cart_change_url, t).then((t) => t.text());
        }
        add(t) {
            return fetch(si.cart_add_url, t).then((t) => t.text());
        }
        update(t) {
            return fetch(`${si.cart_update_url}`, t);
        }
        get() {
            return fetch(si.cart_url).then((t) => t.text());
        }
    };
    const ni = (t = "json") => ({ method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${t}` } }),
        oi = (t) => {
            const e = {},
                s = new FormData(t);
            for (const t of s.keys()) {
                const i = /(?:^(properties\[))(.*?)(?:\]$)/;
                i.test(t) ? ((e.properties = e.properties || {}), (e.properties[i.exec(t)[2]] = s.get(t))) : (e[t] = s.get(t));
            }
            return JSON.stringify(e);
        };
    const ai = new (class {
        constructor(t) {
            this._element = document.querySelector(`#${t}`);
        }
        requestProductFromUrl = (t, e) => {
            this._element && this._element.requestProductFromUrl(t, e);
        };
        openAndRenderProductByUrl = (t) => {
            this._element && this._element.openAndRenderProductByUrl(t);
        };
        hide() {
            return this._element ? this._element.hide() : g();
        }
        get isOpen() {
            return !!this._element && this._element.isOpen;
        }
    })("Quick-view");
    var ri = class extends M {
        constructor() {
            super(),
                (this.sidebar = document.querySelector("#sidebar-component-for-cart")),
                (this.cart = document.querySelector("#cart-page-component")),
                (this.cartNotificationPopup = document.querySelector("#CartNotificationPopup")),
                (this.formSelector = "form"),
                (this.variantInputSelector = "[data-product-form-variant]"),
                (this.form = this.querySelector(this.formSelector)),
                this.form && (this.variantInput = this.form.querySelector(this.variantInputSelector)),
                (this._cartApi = new ii());
        }
        connectedCallback() {
            b(this.form, "submit", this._handleFormSubmit);
        }
        disconnectedCallback() {
            v(this.form, "submit", this._handleFormSubmit);
        }
        _handleFormSubmit = (t) => {
            t.preventDefault();
            const e = this._getQueryConfig();
            this.setDisable(!0),
                this.setLoading(!0),
                this._cartApi
                    .add(e)
                    .then((t) => {
                        const e = JSON.parse(t);
                        if ((this.setDisable(!1), this.setLoading(!1), e.description)) {
                            if (!u.notification) return;
                            u.notification.show(e.description, "warning");
                        } else {
                            if (this.cart) return this._cartApi.get();
                            this.sidebar ? this.updateSidebarCartByParsedState(e) : this.updatePopupByParsedState(e);
                        }
                    })
                    .then((t) => {
                        if (this.cart && t) {
                            const e = Q(t);
                            this.updateCartByHTML(e);
                        }
                    })
                    .catch(() => {
                        u.notification && u.notification.show("Error in product form component", "warning");
                    });
        };
        updateCartByHTML(t) {
            this.cart && (this.cart.updateByHTML(t), this.cart.updateEmptyStatus(!1), this.showCallbackAfterCloseDialogWindow(() => {}));
        }
        updateSidebarCartByParsedState(t) {
            if (!this.sidebar) return;
            this.sidebar.updateEmptyStatus(!1);
            this.showCallbackAfterCloseDialogWindow(() => {
                this.sidebar && this.sidebar.purchaseHandler(t);
            });
        }
        updatePopupByParsedState(t) {
            this.showCallbackAfterCloseDialogWindow(() => {
                this.cartNotificationPopup && this.cartNotificationPopup.showProductFromParsedState(t, t.id);
            });
        }
        showCallbackAfterCloseDialogWindow(t) {
            return g(0).then(() => {
                ai.isOpen || t(), ai.isOpen && ai.hide().then(t);
            });
        }
        _getFormData() {
            return JSON.parse(oi(this.form));
        }
        _getQueryConfig() {
            const t = ni("javascript"),
                e = ["cart-count", this.sidebar ? this.sidebar.sectionId : "cart-drawer", "cart-notification-popup-content"];
            return (t.headers["X-Requested-With"] = "XMLHttpRequest"), (t.body = JSON.stringify({ ...this._getFormData(), sections: e, sections_url: window.location.pathname })), t;
        }
        setLoading(t) {
            this.querySelectorAll('button[type="submit"]').forEach((e) => {
                new ei(e).setLoading(t);
            });
        }
        setDisable(t) {
            this.querySelectorAll('button[type="submit"]').forEach((e) => {
                new ei(e).setDisable(t);
            });
        }
        setButtonText(t) {
            this.querySelectorAll('button[type="submit"]').forEach((e) => {
                new ei(e).setText(t);
            });
        }
    };
    var li = class extends M {
        constructor() {
            super(), (this.button = this.querySelector("[data-product-form-button]")), (this.footer = document.querySelector(".shopify-section.shopify-section-footer")), (this.form = this.closest("product-form"));
        }
        connectedCallback() {
            window.addEventListener("scroll", this._handleWindowScroll);
        }
        disconnectedCallback() {
            window.removeEventListener("scroll", this._handleWindowScroll);
        }
        _handleWindowScroll = () => {
            if (!this.button || !this.form) return;
            const t = window.scrollY,
                e = this.form.offsetTop + this.form.offsetHeight,
                s = this.footer ? this.footer.offsetTop : 0,
                i = window.innerHeight + t < s && t > e;
            this.toggleAttribute("visible", i), document.body.toggleAttribute("is-product-form-button-fixed", i);
        };
    };
    var ci = class extends M {
        constructor() {
            super(),
                (this.blockSelector = "[data-product-block-item]"),
                (this.containerSelector = "[data-product-block-container]"),
                (this.activeTemplate = this.querySelector(this.blockSelector)),
                (this.activeTemplateContainer = this.querySelector(this.containerSelector));
        }
        updateByVariantId(t) {
            const e = this.querySelector(`[data-product-block-template="${t}"]`);
            if (this.activeTemplate && this.activeTemplateContainer) {
                const t = Y(e);
                t && (this.activeTemplate.remove(), (this.activeTemplate = t), this.activeTemplateContainer.appendChild(t));
            }
        }
    };
    const { Shopify: hi } = window;
    var di = class extends M {
        constructor() {
            super(), (this._poster = this.querySelector('[id^="Deferred-Poster-"]'));
        }
        connectedCallback() {
            b(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.on("select", this._handleCarouselSelect);
        }
        disconnectedCallback() {
            v(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.off("select", this._handleCarouselSelect);
        }
        _handlePosterClick = () => {
            this._loadContent();
        };
        _handleCarouselSelect = () => {
            this._carousel && this._setCarouselDraggable(!0);
        };
        _loadContent() {
            this.getAttribute("loaded") || (this._addModel(), this.setAttribute("loaded", !0), this._carousel && this._setCarouselDraggable(!1)),
                hi.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }]);
        }
        _addModel() {
            const t = this.querySelector("template");
            if (!t || !t.content) return;
            const e = t.content,
                s = document.createElement("div");
            s.appendChild(e.firstElementChild.cloneNode(!0));
            const i = s.querySelector("model-viewer");
            this.appendChild(i);
        }
        setupModelViewerUI(t) {
            t || (this.modelViewerUI = new hi.ModelViewerUI(this.querySelector("model-viewer")));
        }
        _setCarouselDraggable(t) {
            const e = this.querySelector(".shopify-model-viewer-ui");
            (this._carousel.dataset.draggable = t ? "true" : "false"), this._carousel.reInit(), t && e && (e.remove(), this.removeAttribute("loaded"));
        }
        get _carousel() {
            return this.closest("carousel-component");
        }
    };
    (window.ProductModel = {
        loadShopifyXR() {
            hi.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(t) {
            t ||
                (window.ShopifyXR
                    ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((t) => {
                          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
        window.addEventListener("DOMContentLoaded", () => {
            hi.designMode && document.querySelectorAll("[data-shopify-xr-hidden]").forEach((t) => t.classList.add("hidden")), window.ProductModel && window.ProductModel.loadShopifyXR();
        });
    var ui = class {
        constructor(t) {
            this.element = t;
        }
        show() {
            this.element.classList.remove("hidden"),
                g(2500).then(() => {
                    this.element.classList.add("hidden");
                });
        }
    };
    var pi = class {
        constructor(t) {
            this.element = t;
        }
        setDisable(t) {
            this.element.setDisable(t);
        }
    };
    var mi = class {
        constructor(t) {
            this.element = t;
        }
        setLoading(t) {
            this.element.toggleAttribute("is-loading", t);
        }
    };
    var _i = class extends M {
        constructor() {
            super(),
                (this._checkmarkSelector = "[data-cart-item-checkmark]"),
                (this._bodySelector = "[data-cart-item-body]"),
                (this._totalsSelector = "[data-cart-item-totals]"),
                (this._quantitySelector = "[data-cart-item-quantity]"),
                (this._transitionDuration = K(this)),
                (this.resizeObserver = new ResizeObserver(this._handleCartItemResize));
        }
        connectedCallback() {
            const t = this.querySelector(this._bodySelector);
            t && this.resizeObserver.observe(t);
        }
        disconnectedCallback() {
            this.resizeObserver.disconnect();
        }
        removeFromCart = () => {
            this.expand()
                .then(() => this.collapse())
                .then(() => this.remove());
        };
        expand = () => (this._setMaxHeight(this.scrollHeight), g(this._transitionDuration));
        collapse = () => (this._setMaxHeight(0), g(this._transitionDuration));
        showCheckmark = () => {
            const t = this.querySelector(this._checkmarkSelector);
            if (t) {
                new ui(t).show();
            }
        };
        setLoading = (t) => {
            const e = this.querySelector(this._totalsSelector);
            if (e) {
                new mi(e).setLoading(t);
            }
        };
        _handleCartItemResize = () => {
            this._setMaxHeight(this.scrollHeight);
        };
        _setMaxHeight(t) {
            this.style.maxHeight = `${t}px`;
        }
        setQuantityDisabled(t) {
            const e = this.querySelector(this._quantitySelector);
            if (e) {
                new pi(e).setDisable(t);
            }
        }
    };
    var gi = class extends M {
        constructor() {
            super(), (this._cartApi = new ii());
        }
        connectedCallback() {
            b(this, "change", this._handleCartChange), b(this, "change", this._handleCartItemChange);
        }
        disconnectedCallback() {
            v(this, "change", this._handleCartChange), v(this, "change", this._handleCartItemChange);
        }
        _handleCartItemChange = (t) => {
            const e = this.querySelector("#CartItem-" + +t.target.dataset.index);
            e && e.setLoading(!0);
        };
        _handleCartChange = (0, ws.debounce)((t) => {
            this.updateItem(+t.target.dataset.index, t.target.value);
        }, 500);
        getConfigByItemIndexAndQuantity(t, e) {
            return { ...ni(), body: JSON.stringify({ line: t + 1, quantity: e }) };
        }
        updateItem(t, e) {
            const s = this.getConfigByItemIndexAndQuantity(t, e),
                i = this.querySelector(`#CartItem-${t}`);
            if (!i) return;
            const n = +e;
            +(i.dataset.quantity || 0) !== n
                ? (0 === n && (this.updateEmptyStatus(1 === this._cartItemCount), i.removeFromCart()),
                  this.setButtonLoading(!0),
                  i.setQuantityDisabled(!0),
                  this._cartApi
                      .change(s)
                      .then(() => this._cartApi.get())
                      .then((t) => {
                          const e = Q(t);
                          this.setButtonLoading(!1), i.setQuantityDisabled(!1), i.setLoading(!1), this.updateByHTML(e);
                      })
                      .catch(() => {
                          this._showError();
                      }))
                : i.setLoading(!1);
        }
        _showError() {
            if (!u.notification) return;
            const { cartStrings: t } = window;
            u.notification.show(t.error, "warning");
        }
        updateEmptyStatus(t) {
            this._updateCartEmptyStatus(t), this._updateSubtotalEmptyStatus(t);
        }
        _updateCartEmptyStatus(t) {
            this.classList.toggle("is-empty", t);
        }
        _updateSubtotalEmptyStatus(t) {
            const e = document.getElementById(this.sectionIds.local.subtotal);
            e && e.classList.toggle("is-empty", t);
        }
        updateByHTML(t) {
            this.updateFreeShippingBarByHTML(t);
            [`#${this.sectionIds.local.cartItems} [data-cart-page-items]`, "#CartCount", "#StickyCartCount", `#${this.sectionIds.local.subtotal} [data-cart-page-subtotal-price]`].forEach((e) => {
                const s = document.querySelector(e),
                    i = t.querySelector(e);
                s && i && (s.innerHTML = i.innerHTML);
            });
        }
        updateFreeShippingBarByHTML(t) {
            const e = `#${this.sectionIds.local.cartItems} [data-cart-page-free-shipping-bar] cart-free-shipping-bar`,
                s = document.querySelector(e),
                i = t.querySelector(e);
            if (s && i) {
                const t = w(i),
                    e = i.dataset.cartTotal || 0;
                s.updateProgressByCartTotal(+e), C(t);
            }
        }
        setButtonLoading(t) {
            const e = document.getElementById(this.sectionIds.local.subtotal);
            if (e) {
                const s = e.querySelector("[data-cart-page-checkout-button]");
                s && (s.toggleAttribute("disabled", t), s.classList.toggle("loading", t));
            }
        }
        get _cartItemCount() {
            return this.querySelectorAll("cart-item").length;
        }
        get sectionIds() {
            return { local: { subtotal: "CartPage-SubtotalSection", cartItems: "CartPage-CartItemsSection" } };
        }
    };
    var fi = class extends Ce {
        constructor() {
            super(),
                (this.sectionId = this.dataset.sectionId || "cart-drawer"),
                (this._sections = ["cart-count", this.sectionId]),
                (this.resultsSelector = "[data-sidebar-cart-results]"),
                (this.viewportSelector = "[data-sidebar-cart-viewport]"),
                (this.headerSelector = "[data-sidebar-cart-header]"),
                (this.footerSelector = "[data-sidebar-cart-footer]"),
                (this.viewport = this.element.querySelector(this.viewportSelector)),
                (this.results = this.element.querySelector(this.resultsSelector)),
                (this.header = this.element.querySelector(this.headerSelector)),
                (this.footer = this.element.querySelector(this.footerSelector)),
                (this._cartApi = new ii()),
                (this._resizeObserver = new ResizeObserver(this._handleContentResultsResize));
        }
        connectedCallback() {
            super.connectedCallback(),
                b(this, "change", this._handleCartChange),
                b(this, "change", this._handleCartItemChange),
                this.viewport && this.viewport.addEventListener("scroll", this._handleViewportScroll),
                this.results && this._resizeObserver.observe(this.results);
        }
        disconnectedCallback() {
            super.disconnectedCallback(),
                v(this, "change", this._handleCartChange),
                v(this, "change", this._handleCartItemChange),
                this.viewport && this.viewport.removeEventListener("scroll", this._handleViewportScroll),
                this._resizeObserver.disconnect();
        }
        _handleCartItemChange = (t) => {
            const e = this.querySelector("#CartItem-" + +t.target.dataset.index);
            e && e.setLoading(!0);
        };
        _handleCartChange = (0, ws.debounce)((t) => {
            this.updateItem(+t.target.dataset.index, t.target.value);
        }, 500);
        _handleViewportScroll = () => {
            if (!this.viewport) return;
            const t = this.checkContentOverflow(),
                e = this.viewport.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", t && e);
        };
        updateItem(t, e) {
            const s = this.querySelector(`#CartItem-${t}`),
                i = this.element.querySelector("[data-cart-checkout-button]");
            if (!s || !i) return;
            const n = this._getQueryConfig(t, e),
                o = new ei(i),
                a = +e;
            +(s.dataset.quantity || 0) !== a
                ? (o.setLoading(!0),
                  o.setDisable(!0),
                  s.setQuantityDisabled(!0),
                  0 === a && (this.updateEmptyStatus(1 === this._cartItemCount), s.removeFromCart()),
                  this._cartApi
                      .change(n)
                      .then((t) => {
                          const e = JSON.parse(t);
                          o.setLoading(!1), o.setDisable(!1), s.setLoading(!1), s.setQuantityDisabled(!1), this.updateByParsedState(e);
                      })
                      .catch(() => {
                          this._showError();
                      }))
                : s.setLoading(!1);
        }
        _handleContentResultsResize = () => {
            this.updateViewport();
        };
        updateViewport() {
            const t = this.checkContentOverflow();
            this.toggleAttribute("footer-shadow-visible", t);
        }
        checkContentOverflow() {
            return !(!this.results || !this.viewport) && this.results.offsetHeight > this.viewport.offsetHeight;
        }
        _showError() {
            const t = this.querySelector("#SidebarCartNotification");
            if (t) {
                const e = new d(t),
                    { cartStrings: s } = window;
                e.show(s.error, "warning");
            }
        }
        updateByParsedState(t) {
            const e = Q(t.sections[this.sectionId]).querySelector("#CartInSidebar"),
                s = Y(e),
                i = w(s);
            this.mount(), this.updateHeaderFromNode(s), this.updateFreeShippingBarFromNode(s), this.updateCartItemsFromNode(s), this.updateFooterFromNode(s), this._updateCartCountInHeader(t), C(i);
        }
        purchaseHandler(t) {
            const e = Q(t.sections[this.sectionId]).querySelector("#CartInSidebar"),
                s = Y(e),
                i = w(s);
            this.mount(), this.updateHeaderFromNode(s), this.updateCartItemsFromNode(s), this.updateFooterFromNode(s), this._updateCartCountInHeader(t), C(i);
            const n = this.element.querySelector(`cart-item[data-variant-id="${t.id}"]`);
            n &&
                (1 === t.quantity
                    ? n
                          .collapse()
                          .then(() => this.open())
                          .then(() => n.expand())
                          .then(() => {
                              this.updateFreeShippingBarFromNode(s), n.showCheckmark();
                          })
                    : this.open().then(() => {
                          this.updateFreeShippingBarFromNode(s), n.showCheckmark();
                      }));
        }
        updateHeaderFromNode(t) {
            this.updateElementBySelectorFromNode("[data-sidebar-cart-header]", t);
        }
        updateEmptyStatus(t) {
            this.toggleAttribute("is-empty", t);
        }
        updateFooterFromNode(t) {
            this.updateElementBySelectorFromNode("[data-sidebar-cart-footer]", t);
        }
        updateCartItemsFromNode(t) {
            this.updateElementBySelectorFromNode("[data-sidebar-cart-items]", t);
        }
        updateFreeShippingBarFromNode(t) {
            const e = "[data-sidebar-cart-free-shipping-bar] cart-free-shipping-bar",
                s = this.element.querySelector(e),
                i = t.querySelector(e);
            if (s && i) {
                const t = i.dataset.cartTotal || 0;
                s.updateProgressByCartTotal(+t);
            }
        }
        updateElementBySelectorFromNode(t, e) {
            const s = e.querySelector(t),
                i = this.element.querySelector(t);
            i && s && (i.innerHTML = s.innerHTML);
        }
        _updateCartCountInHeader(t) {
            const e = Q(t.sections["cart-count"]),
                s = document.getElementById("CartCount"),
                i = document.getElementById("StickyCartCount"),
                n = e.querySelector("#CartCount");
            i && n && (i.innerHTML = n.innerHTML), s && n && (s.innerHTML = n.innerHTML);
        }
        _getQueryConfig(t, e) {
            return { ...ni(), body: JSON.stringify({ line: t + 1, quantity: e, sections: this._sections, sections_url: window.location.pathname }) };
        }
        get _cartItemCount() {
            return this.element.querySelectorAll("cart-item").length;
        }
    };
    const { Shopify: bi } = window;
    var vi = class extends M {
        constructor() {
            super(), (this.messageNodeSelector = "[data-cart-free-shipping-bar-message]");
        }
        connectedCallback() {
            const t = this.dataset.cartTotal || 0;
            this.updateProgressByCartTotal(+t);
        }
        updateProgressByCartTotal(t) {
            const e = this.dataset.currencyFormat || "",
                s = +(this.dataset.threshold || 0),
                i = +bi.currency.rate,
                n = this.dataset.progressMessage || "",
                o = this.dataset.achievedMessage || "",
                a = s * i,
                r = +(a - t).toFixed(2),
                l = a / 100;
            if (r > 0) {
                const s = e.replace(/{{.+?}}/g, `${r}`);
                this.setMessage(n.replace("[value]", s)), this.setProgress(t / l);
            } else this.setMessage(o), this.setProgress(100);
        }
        setProgress = (t) => {
            this.style.setProperty("--gsc-free-shipping-progress", `${t}%`);
        };
        setMessage = (t) => {
            const e = this.querySelector(this.messageNodeSelector);
            e && (e.innerHTML = t);
        };
    };
    var yi = class extends M {
        connectedCallback() {
            this.setReady();
        }
        updateFirstMediaByVariant(t, e = !1) {
            if (t && t.featured_media) {
                const s = this.querySelector(`[data-media-id="${t.featured_media.id}"]`);
                s && s.scrollIntoView({ behavior: e ? "auto" : "smooth" });
            }
        }
        setReady() {
            this.setAttribute("ready", "");
        }
    };
    var Si = class extends M {
        constructor() {
            super(), (this.carouselSelector = "[data-product-media-carousel-component]");
        }
        connectedCallback() {
            this.setReady();
        }
        updateFirstMediaByVariant(t, e = !1) {
            const s = this.querySelector(this.carouselSelector);
            if (t && t.featured_media && s) {
                const i = s.embla.slideNodes().findIndex((e) => !!e.dataset.mediaId && +e.dataset.mediaId == +t.featured_media.id);
                s.embla.scrollTo(i, e);
            }
        }
        setReady() {
            this.setAttribute("ready", "");
        }
    };
    var wi = class extends M {
        constructor() {
            super(),
                (this._pickupAvailability = document.getElementById(`product-pickup-availability-${this.dataset.productId}-${this.dataset.section}`)),
                (this._elements = ["sticky-product-buy-btn", "product-buy-btn", "product-quantity"]);
        }
        connectedCallback() {
            this._updateVariant(),
                setTimeout(() => {
                    this._updateOptionsAvailable(), this.setFocusListeners();
                }, 100),
                this.dataset.selectedVariantId && this._updateFirstMediaByVariant(this.variant, !0),
                b(this, "change", this._handleVariantChange);
        }
        disconnectedCallback() {
            v(this, "change", this._handleVariantChange);
        }
        _handleVariantChange = () => {
            this._updateForm(),
                this._setInventoryStatusAvailable(this.variant),
                this.variant
                    ? (this._form.setDisable(!0),
                      this._form.setLoading(!0),
                      this._pickupAvailability && this._updatePickupAvailability(),
                      this._updateURL(),
                      this._updateVariantInput(),
                      this._updateProduct(),
                      this._updateFirstMediaByVariant(this.variant))
                    : this._setButtonsUnavailable();
        };
        _updateLabels() {
            const t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                e = this.querySelectorAll("[data-variant-picker-option-labels]");
            t.forEach((t, s) => {
                const i = [...e[s].querySelectorAll("label")],
                    n = [...t.querySelectorAll("input")],
                    o = this.getCheckedInput(n),
                    a = e[s].querySelector("[data-dropdown-variant-picker-label]");
                i.forEach((t) => {
                    const e = t.getAttribute("for") === o.id;
                    if (a && e) {
                        const e = a.closest("dropdown-opener");
                        (a.innerHTML = t.innerHTML), e.trigger();
                    }
                    t.classList.toggle("selected", e);
                });
            });
        }
        _setInventoryStatusAvailable(t) {
            const e = document.getElementById(`product-stock-inner-${this.dataset.productId}-${this.dataset.section}`);
            e && e.classList.toggle("hidden", !t);
        }
        _setButtonsUnavailable() {
            this._form.setDisable(!0), this._form.setText(window.variantStrings.unavailable);
        }
        _updateVariant() {
            const t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                e = this._getVariants(),
                s = [...t].map((t) => {
                    const e = [...t.querySelectorAll("input")];
                    return this.getCheckedInput(e).value;
                });
            this.variant = e.find(({ options: t }) => !t.map((t, e) => s[e] === t).includes(!1));
        }
        setFocusListeners() {
            if ("dropdown" === this.dataset.type) {
                const t = [...this.querySelectorAll("float-element")].map((t) => [...t.element.querySelectorAll("label")]).reduce((t, e) => [...t, ...e], []);
                this.setListenersForLabels(t);
            } else {
                const t = [...this.querySelectorAll("label")];
                this.setListenersForLabels(t);
            }
        }
        _handleLabelFocus = (t) => {
            const e = t.target.getAttribute("for");
            this.querySelector(`input[id="${e}"]`).dispatchEvent(new MouseEvent("click", { button: 0, which: 1 })), document.addEventListener("keydown", this._handleLabelKeydown);
        };
        setListenersForLabels(t) {
            t.forEach((t) => {
                t.addEventListener("focus", this._handleLabelFocus);
            });
        }
        removeListenersForLabels(t) {
            t.forEach((t) => {
                t.addEventListener("focus", this._handleLabelFocus);
            });
        }
        _handleLabelKeydown = (t) => {
            const e = t.target.closest("[data-variant-picker-option-labels]");
            if (!("ArrowLeft" === t.key || "ArrowRight" === t.key || "ArrowUp" === t.key || "ArrowDown" === t.key)) return;
            if (!e) return void document.removeEventListener("keydown", this._handleLabelKeydown);
            const s = [...e.querySelectorAll("label")],
                i = s.findIndex((e) => e === t.target),
                n = s[i],
                o = s[0],
                a = s[s.length - 1],
                r = s[i + 1],
                l = s[i - 1];
            1 !== s.length && t.preventDefault();
            const c = (t) => {
                    n.removeAttribute("tabindex"), t.setAttribute("tabindex", 0), t.focus();
                },
                h = () => {
                    c(r || o);
                },
                d = () => {
                    c(l || a);
                };
            (0, { ArrowLeft: d, ArrowRight: h, ArrowUp: d, ArrowDown: h }[t.key])();
        };
        _updateOptionsAvailable() {
            const t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                e = (e) => (t[e] ? [...t[e].querySelectorAll("input")] : null),
                s = e(0),
                i = e(1),
                n = e(2),
                o = this._getVariants(),
                a = (...t) =>
                    o.reduce((e, s) => {
                        const i = !t || t.every((t) => s.options.includes(t.value));
                        return s.available && i ? [...e, s.options] : e;
                    }, []),
                r = (t) => [...this.querySelectorAll("float-element")].find((e) => e.element.querySelector(t)).element.querySelector(t),
                l = (t, e) => {
                    for (const s of t) {
                        const t = s.value;
                        let i = !1;
                        e.forEach((e) => {
                            e.includes(t) && (i = !0);
                        });
                        const n = `label[for="${s.id}"]`;
                        (this.querySelector(n) ? this.querySelector(n) : r(n)).toggleAttribute("no-available", !i);
                    }
                };
            if ((l(s, a()), i)) {
                l(i, a(this.getCheckedInput(s)));
            }
            if (n) {
                l(n, a(this.getCheckedInput(s), this.getCheckedInput(i)));
            }
        }
        _getVariants() {
            const t = this.querySelector("[data-variant-picker-variants]");
            return JSON.parse(t.textContent);
        }
        _updateFirstMediaByVariant(t, e) {
            document.querySelectorAll(`#product-media-${this.dataset.productId}-${this.dataset.section}`).forEach((s) => s.updateFirstMediaByVariant(t, e));
        }
        _updateForm() {
            this._updateLabels(), this._updateVariant(), this._updateOptionsAvailable();
        }
        _updateURL() {
            if (this.variant && "true" === this.dataset.updateUrl) {
                const t = `${this.dataset.url}?variant=${this.variant.id}`;
                window.history.replaceState({}, "", t);
            }
        }
        _updateVariantInput() {
            const t = this._form.variantInput;
            (t.value = this.variant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        }
        _updatePickupAvailability() {
            this._pickupAvailability.updateVariantId(this.variant.id), this._pickupAvailability.fetchAvailability();
        }
        _updateProduct() {
            const t = `${this.dataset.url}?variant=${this.variant.id}&section_id=${this.dataset.sectionIdWithoutPrefix}`;
            this._updateBlocksByVariantId(this.variant.id),
                fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = Q(t),
                            s = this.variant.available;
                        this._form.setDisable(!s), this._form.setLoading(!1), this._updateElements(e);
                    })
                    .catch(() => {
                        u.notification && u.notification.show("Error in variant picker component", "warning");
                    });
        }
        _updateElements(t) {
            this._elements.forEach((e) => {
                const s = `${e}-${this.dataset.productId}-${this.dataset.section}`,
                    i = document.getElementById(s);
                i && (i.innerHTML = t.getElementById(s).innerHTML);
            });
        }
        _updateBlocksByVariantId(t) {
            ["product-price", "product-sku", "product-stock"].forEach((e) => {
                const s = document.getElementById(`${e}-${this.dataset.productId}-${this.dataset.section}`);
                s && s.updateByVariantId(t);
            });
        }
        getCheckedInput(t) {
            return t.find(({ checked: t }) => t);
        }
        get _form() {
            return document.getElementById(`product-form-component-${this.dataset.productId}-${this.dataset.section}`);
        }
    };
    var Ci = class extends M {
        constructor() {
            super(),
                (this.activeValueSelector = "[data-color-swatches-picker-active-value]"),
                (this.activeValue = this.querySelector(this.activeValueSelector)),
                (this.labelSelector = "[data-color-swatches-picker-label]"),
                (this.labels = [...this.querySelectorAll(this.labelSelector)]);
        }
        connectedCallback() {
            this.addEventListener("click", this._handleClick),
                this.labels.forEach((t) => {
                    t.addEventListener("mouseenter", this._handleMouseEnter), t.addEventListener("mouseleave", this._handleMouseLeave);
                });
        }
        disconnectedCallback() {
            this.removeEventListener("click", this._handleClick),
                this.labels.forEach((t) => {
                    t.removeEventListener("mouseenter", this._handleMouseEnter), t.removeEventListener("mouseleave", this._handleMouseLeave);
                });
        }
        _handleClick = () => {
            this.updateSelected();
        };
        _handleMouseEnter = (t) => {
            this.updateActiveValue(t.target.dataset.value);
        };
        _handleMouseLeave = () => {
            this.updateSelected();
        };
        updateSelected() {
            const t = this.querySelector(`${this.labelSelector}.selected`);
            if (t) {
                const e = t.getAttribute("data-value") || "";
                this.updateActiveValue(e);
            }
        }
        updateActiveValue(t) {
            this.activeValue && (this.activeValue.innerHTML = t);
        }
    };
    var ki = class extends ge {
        constructor() {
            super(),
                (this.selectors = {
                    carousel: "[data-product-modal-carousel]",
                    carouselButtons: "[data-product-modal-carousel-button]",
                    carouselSlide: "[data-product-modal-slide]",
                    carouselSelectedSlideNumber: "[data-product-modal-selected-slide-number]",
                    carouselSlideNumber: "[data-product-modal-slide-number]",
                    zoomCursor: "zoom-cursor",
                }),
                this.element &&
                    ((this.carousel = this.element.querySelector(this.selectors.carousel)),
                    (this._slides = [...this.element.querySelectorAll(this.selectors.carouselSlide)]),
                    (this._selectedSlideNumber = this.element.querySelector(this.selectors.carouselSelectedSlideNumber)),
                    (this._slideNumber = this.element.querySelector(this.selectors.carouselSlideNumber))),
                (this._zoomCursor = document.querySelector(this.selectors.zoomCursor)),
                (this.mediaIndexMap = this._createMediaIndexMap()),
                (this.isZoomed = !1);
        }
        _handleKeydown = (t) => {
            const e = t.key || t.keyCode;
            (e === m.ESCAPE_STRING_KEY || e === m.ESCAPE_NUMBER_KEY) && (this.isZoomed ? this.zoomedImage.reset() : this.hide());
        };
        _handleCarouselInit = () => {
            this._updateCarouselDraggableState();
        };
        _handleCarouselSelect = () => {
            this.updateSelectedSlideNumber();
        };
        openAndShowMediaById(t) {
            if ((this.show(), !this.carousel)) return;
            const e = this.mediaIndexMap[t];
            this.carousel.embla.scrollTo(e, !0), this.updateSelectedSlideNumber();
        }
        _initCarousel() {
            this.carousel && (this.carousel.embla.on("select", this._handleCarouselSelect), this.carousel.embla.on("init", this._handleCarouselInit));
        }
        _resetCarousel() {
            this.carousel && (this.carousel.embla.off("select", this._handleCarouselSelect), this.carousel.embla.off("init", this._handleCarouselInit));
        }
        hide() {
            this._resetCarousel(), super.hide(), (this.isZoomed = !1), this.updateModal(), this.emit("hide", {});
        }
        show() {
            super.show(), this._initCarousel();
        }
        updateSelectedSlideNumber() {
            if (!this._selectedSlideNumber || !this.carousel) return;
            const t = this.carousel.embla.selectedScrollSnap() + 1;
            this._selectedSlideNumber.innerHTML = `${t}`;
        }
        updateModal() {
            this._updateCarouselDraggableState(), this._updateZoomCursorState(), this._updateZoomState();
        }
        _createMediaIndexMap() {
            return this._slides.reduce((t, e, s) => (e.dataset.mediaId ? { ...t, [e.dataset.mediaId]: s } : t), {});
        }
        _updateCarouselDraggableState() {
            if (!this.carousel) return;
            ke() ? this.carousel.reInit({ draggable: !this.isZoomed }) : this.carousel.reInit({ draggable: !1 });
        }
        _updateZoomCursorState() {
            this._zoomCursor && this._zoomCursor.updateState(this.isZoomed);
        }
        _updateZoomState() {
            this.toggleAttribute("zoom-enabled", this.isZoomed);
        }
    };
    var Ei = class extends M {
        constructor() {
            super(),
                (this._image = this.querySelector("img")),
                (this._modal = this.closest("product-modal")),
                (this._carousel = this._modal.carousel),
                (this._preloader = this.querySelector("[data-product-modal-image-preloader]")),
                (this._currentScale = 1),
                (this._isDragging = !1),
                (this._offsetX = 0),
                (this._offsetY = 0),
                (this._startDragPoint = { x: 0, y: 0 }),
                (this._maxScale = 3),
                (this._minScale = 1),
                (this._isTapped = !1),
                (this._tapTimeout = 300),
                (this._lastGesture = null),
                this.setZoomCursorVisible(!0);
        }
        connectedCallback() {
            y.observe(this._preloader),
                this._image.addEventListener("mousedown", this._handleMouseDown),
                this._image.addEventListener("mouseup", this._handleMouseUp),
                this._image.addEventListener("mousemove", this._handleMouseMove),
                this._image.addEventListener("touchstart", this._handleTouchStart),
                this._image.addEventListener("touchend", this._handleTouchEnd),
                this._image.addEventListener("touchmove", this._handleTouchMove),
                this._image.addEventListener("load", this._handleImageLoad),
                customElements.upgrade(this._modal),
                this._modal.subscribe("hide", this._handleModalHide),
                this._carousel.embla.on("select", this._handleCarouselSelect);
        }
        disconnectedCallback() {
            y.unobserve(this._preloader),
                this._image.removeEventListener("mousedown", this._handleMouseDown),
                this._image.removeEventListener("mouseup", this._handleMouseUp),
                this._image.removeEventListener("mousemove", this._handleMouseMove),
                this._image.removeEventListener("touchstart", this._handleTouchStart),
                this._image.removeEventListener("touchend", this._handleTouchEnd),
                this._image.removeEventListener("touchmove", this._handleTouchMove),
                this._image.removeEventListener("load", this._handleImageLoad),
                this._modal.unsubscribe("hide", this._handleModalHide),
                this._carousel.embla.off("select", this._handleCarouselSelect);
        }
        _handleImageLoad = () => {
            this.setPreloaderVisible(!1);
        };
        _handleModalHide = () => {
            this.reset();
        };
        _handleCarouselSelect = () => {
            this.reset();
        };
        _handleTouchStart = (t) => {
            t.preventDefault(), (this.fingers = t.touches.length), (this.firstMove = !0), this.detectDoubleTap(t);
        };
        _handleTouchMove = (t) => {
            if ((t.preventDefault(), !this._isDoubleTapped)) {
                if (this.firstMove) this.updateGesture(t), (this.startMoveTouches = t.touches.length);
                else if (this._lastGesture)
                    switch (this._lastGesture) {
                        case "zoom":
                            2 === this.startMoveTouches && 2 === t.touches.length && this.pinch(t);
                            break;
                        case "drag":
                            if (1 === this.startMoveTouches && 1 === t.touches.length) {
                                const { clientX: e, clientY: s } = t.targetTouches[0];
                                this.drag(e, s);
                            }
                    }
                else this.setGesture("none", t);
                this.firstMove = !1;
            }
        };
        _handleTouchEnd = (t) => {
            t.preventDefault(), (this.fingers = t.touches.length), this.updateGesture(t);
        };
        _handleMouseDown = (t) => {
            t.preventDefault(), this.startDrag(t.clientX, t.clientY), this.setDragging(!0);
        };
        _handleMouseUp = (t) => {
            this.setDragging(!1);
            const e = this._modal.isZoomed ? 75 : 0;
            this.zoomTimeoutId = setTimeout(() => {
                this.touchZoom(t.clientX, t.clientY);
            }, e);
        };
        _handleMouseMove = (t) => {
            if ((t.preventDefault(), clearTimeout(this.zoomTimeoutId), this._isDragging && this._modal.isZoomed)) {
                const { clientX: e, clientY: s } = t;
                this.drag(e, s);
            }
        };
        detectDoubleTap(t) {
            if (this._isTappedTimeout && 1 === this.fingers)
                switch ((clearTimeout(this._isTappedTimeout), (this._isTappedTimeout = null), (this._isDoubleTapped = !0), this.touchZoom(t.changedTouches[0].clientX, t.changedTouches[0].clientY), this._lastGesture)) {
                    case "zoom":
                        this.setPinchScaling(!1);
                        break;
                    case "drag":
                        this.setDragging(!1);
                }
            else
                this._isTappedTimeout = setTimeout(() => {
                    (this._isTappedTimeout = null), (this._isDoubleTapped = !1);
                }, this._tapTimeout);
        }
        updateGesture(t) {
            2 === this.fingers ? this.setGesture("zoom") : 1 === this.fingers ? this.setGesture("drag", t) : this.setGesture("none", t);
        }
        setGesture(t, e) {
            if (this._lastGesture !== t) {
                if (this._lastGesture && !t)
                    switch (this._lastGesture) {
                        case "zoom":
                            this.setPinchScaling(!1);
                            break;
                        case "drag":
                            this.setDragging(!1);
                    }
                switch (t) {
                    case "zoom":
                        this.setPinchScaling(!0);
                        break;
                    case "drag":
                        this.startDrag(e.changedTouches[0].clientX, e.changedTouches[0].clientY), this.setDragging(!0);
                        break;
                    case "none":
                        this.setDragging(!1), this.setPinchScaling(!1);
                }
            }
            this._lastGesture = t;
        }
        pinch(t) {
            const e = this.getDistanceBetweenTouches(t),
                s = e > this.lastDistanceBetweenTouches,
                i = s ? 0.125 : -0.125,
                n = this.getNewScale(this.currentScale + i),
                o = this.getTouchCenter(t),
                a = (o.x - this._offsetX) / this.currentScale,
                r = (o.y - this._offsetY) / this.currentScale;
            (this.lastDistanceBetweenTouches = e), s || 1 !== n ? this.setTransform({ scale: n, offsetX: o.x - a * n, offsetY: o.y - r * n }) : this.reset();
        }
        getDistanceBetweenTouches(t) {
            return Math.hypot(t.touches[0].pageX - t.touches[1].pageX, t.touches[0].pageY - t.touches[1].pageY);
        }
        startDrag(t, e) {
            (this._startDragPoint = { x: t - this._offsetX, y: e - this._offsetY }), (this.dragStartPointX = t), (this.dragStartPointY = e);
        }
        drag(t, e) {
            const s = this.dragStartPointX > t,
                i = this.dragStartPointY > e,
                n = this.getNewScale(this.currentScale);
            let o = t - this._startDragPoint.x,
                a = e - this._startDragPoint.y;
            const r = this.getIntersectBounds({ isRightDrag: s, isBottomDrag: i });
            (r.right || r.left) && (o = this._offsetX), (r.bottom || r.top) && (a = this._offsetY), this.setTransform({ scale: n, offsetX: o, offsetY: a });
        }
        getIntersectBounds({ isRightDrag: t, isBottomDrag: e }) {
            const s = this._image.getBoundingClientRect(),
                i = t ? -8 : 8,
                n = e ? -8 : 8;
            return { right: t && s.right + i < window.innerWidth, left: !t && s.left + i > 0, bottom: e && s.bottom + n < window.innerHeight, top: !e && s.top + n > 0 };
        }
        getTouchCenter(t) {
            const e = (t, e) => t + e,
                s = [...t.touches],
                i = s.length;
            return { x: s.map((t) => t.pageX).reduce(e) / i, y: s.map((t) => t.pageY).reduce(e) / i };
        }
        setTransform({ offsetX: t, offsetY: e, scale: s }) {
            (this.style.transform = `translate3d(${t}px, ${e}px, 0) scale3d(${s}, ${s}, 1)`), (this._offsetX = t), (this._offsetY = e), (this.currentScale = s);
        }
        touchZoom(t, e) {
            const s = (t - this._offsetX) / this.currentScale,
                i = (e - this._offsetY) / this.currentScale;
            let n, o, a;
            this._modal.isZoomed ? ((n = this.getNewScale(1)), (o = 0), (a = 0)) : ((n = this.getNewScale(3)), (o = t - s * n), (a = e - i * n)),
                (this.style.cursor = this._modal.isZoomed ? "" : "grab"),
                this.setZoomCursorVisible(this._modal.isZoomed),
                this.setTransform({ scale: n, offsetX: o, offsetY: a });
        }
        reset() {
            this.setTransform({ scale: 1, offsetX: 0, offsetY: 0 });
        }
        getNewScale(t) {
            return Math.max(this._minScale, Math.min(this._maxScale, t));
        }
        setPinchScaling(t) {
            this.toggleAttribute("is-pinch-scaling", t), (this._isPinchScaling = t);
        }
        setDragging(t) {
            this.toggleAttribute("is-dragging", t), (this._isDragging = t);
        }
        setZoomCursorVisible(t) {
            this._image.toggleAttribute("data-zoom-cursor-target", t);
        }
        setModalZoom(t) {
            (this._modal.isZoomed = t), this._modal.isZoomed && (this._modal.zoomedImage = this), this._modal.updateModal();
        }
        setPreloaderVisible(t) {
            this._preloader.classList.toggle("hidden", !t), this._image.toggleAttribute("is-loaded", !t);
        }
        set currentScale(t) {
            this._currentScale !== t && (this.setModalZoom(t > 1), (this._currentScale = t));
        }
        get currentScale() {
            return this._currentScale;
        }
    };
    var xi = class extends ve {
        showModal() {
            if (!this.dataset.modal) return;
            const t = document.querySelector(this.dataset.modal);
            t && t.openAndShowMediaById(this.dataset.mediaId);
        }
    };
    var Ii = class extends M {
        constructor() {
            super(), (this._intersectionObserver = new IntersectionObserver(this._handleIntersectionObserve, { rootMargin: "0px 0px 200px 0px" }));
        }
        connectedCallback() {
            this._intersectionObserver.observe(this);
        }
        disconnectedCallback() {
            this._intersectionObserver.disconnect();
        }
        _handleIntersectionObserve = (t, e) => {
            if (!t[0].isIntersecting) return;
            e.unobserve(this);
            const s = this.dataset.url;
            s &&
                fetch(s)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = Q(t);
                        this._updateByHTML(e);
                    })
                    .catch(() => {
                        u.notification && u.notification.show("Error in product recommendations component", "warning");
                    });
        };
        _updateByHTML(t) {
            const e = t.querySelector("product-recommendations");
            e && (this.innerHTML = e.innerHTML);
        }
    };
    const { routes: Li } = window;
    var Ti = class {
        get(t) {
            const e = this._prepareQuery(t);
            return fetch(e).then((t) => t.text());
        }
        _prepareQuery(t) {
            const { searchQuery: e, sectionId: s } = t;
            return `${Li.predictive_search_url}?q=${e}&resources[limit]=999&${`section_id=${s}`}`;
        }
    };
    var Mi = class extends M {
        constructor() {
            super(),
                (this._cache = {}),
                (this.sidebar = this.closest("#SearchSidebar")),
                (this.inputComponentSelector = "[data-sidebar-search-input-component]"),
                (this.contentResults = "[data-sidebar-search-content-results]"),
                (this.footerSelector = "[data-sidebar-search-footer]"),
                (this.itemSelector = "[data-sidebar-search-item]"),
                this.sidebar && (this._results = this.sidebar.element.querySelector(this.contentResults)),
                (this._predictiveSearchAPI = new Ti());
        }
        connectedCallback() {
            b(this._inputComponent, "input", this._handleInputChange);
        }
        disconnectedCallback() {
            v(this._inputComponent, "input", this._handleInputChange);
        }
        _handleInputChange = (0, ws.debounce)(() => {
            this._searchQuery ? this._renderResults() : this._resetResults();
        }, 500);
        _renderResults() {
            this._cache[this._searchQuery] ? this._renderFromCache(this._searchQuery) : this._renderFromUrl(this._searchQuery);
        }
        _resetResults() {
            this.sidebar && this._updateResultsFromHTML(this.sidebar.defaultStateElement);
        }
        _renderFromCache(t) {
            try {
                this._updateResultsFromHTML(this._cache[t]);
            } catch (t) {
                if (!u.notification) return;
                u.notification.show("Error in search component when try update from cache", "warning");
            }
        }
        _renderFromUrl(t) {
            const e = this.sidebar?.dataset.sectionId || "search-sidebar";
            this._predictiveSearchAPI
                .get({ searchQuery: this._searchQuery, sectionId: e })
                .then((e) => {
                    const s = Q(e);
                    (this._cache[t] = s), this._updateResultsFromHTML(s);
                })
                .catch(() => {
                    u.notification && u.notification.show("Error in search component", "warning");
                });
        }
        _updateResultsFromHTML(t) {
            const e = t.getElementById("SearchSidebar");
            if (e) {
                const t = e.querySelector("template"),
                    s = Y(t).querySelector(this.contentResults);
                this.updateResultsHTML(s.innerHTML), this.updateFooterVisible();
            }
        }
        updateResultsHTML(t) {
            this._results && (this._results.innerHTML = t);
        }
        updateFooterVisible() {
            if (this.sidebar) {
                const t = this.sidebar.element.querySelector(this.footerSelector),
                    e = this.sidebar.element.querySelectorAll(this.itemSelector);
                t && t.classList.toggle("hidden", 0 === e.length);
            }
        }
        get _searchQuery() {
            return this._inputComponent ? this._inputComponent.value.trim() : "";
        }
        get _inputComponent() {
            return this.sidebar ? this.sidebar.querySelector(this.inputComponentSelector) : null;
        }
    };
    var Bi = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.update();
        };
        update() {
            const t = this.closest("cart-component, sidebar-cart"),
                e = this.dataset.index;
            t && e && t.updateItem(+e, 0);
        }
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.update());
        };
    };
    var Ai = class extends M {
        connectedCallback() {
            b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this._copy();
        };
        _copy = () => {
            const t = this.dataset.value;
            t &&
                navigator.clipboard &&
                navigator.clipboard.writeText(t).then(() => {
                    this._showTooltip();
                });
        };
        _showTooltip() {
            const t = this.dataset.tooltipId;
            if (!t) return;
            const e = document.querySelector(`#${t}`);
            e &&
                (e.show(),
                g(1e3).then(() => {
                    e.hide();
                }));
        }
    };
    var Pi = class extends M {
        constructor() {
            super();
            const t = this.querySelector("template");
            (this.element = Y(t)), (this._arrow = this.element.querySelector("[data-float-element-arrow]"));
        }
        disconnectedCallback() {
            this._unmount();
        }
        _update = () => {
            this._target &&
                ee(this._target, this, this._getOptions()).then((t) => {
                    this._updatePosition(t), this._updateArrow(t);
                });
        };
        _updatePosition({ x: t, y: e }) {
            Object.assign(this.style, { left: `${t}px`, top: `${e}px` });
        }
        _getOptions() {
            return { placement: this._placement, middleware: this._getMiddleware(), strategy: "absolute" };
        }
        _getMiddleware() {
            const t = this.dataset.alignmentAxisOffset || 0,
                e = this.dataset.mainAxisOffset || 0,
                s = [bt({ alignmentAxis: +t, mainAxis: +e }), ft(), yt()];
            return this._arrow && s.push(dt({ element: this._arrow })), s;
        }
        _updateArrow({ placement: t, middlewareData: e }) {
            if (!this._arrow) return;
            const { x: s, y: i } = e.arrow,
                n = { top: "bottom", right: "left", bottom: "top", left: "right" }[t.split("-")[0]];
            Object.assign(this._arrow.style, { left: null != s ? `${s}px` : "", top: null != i ? `${i}px` : "", right: "", bottom: "", [n]: "-5px" });
        }
        _mount() {
            this.contains(this.element) || this.appendChild(this.element);
        }
        _unmount() {
            this.element && this.element.remove();
        }
        show = () => {
            this._mount(), this._setVisible(!0), this._update(), this.emit("show", {});
        };
        hide = () => {
            this._setVisible(!1), this._unmount(), this.emit("hide", {});
        };
        _setVisible(t) {
            this.setAttribute("aria-hidden", t ? "false" : "true");
        }
        get _target() {
            return document.querySelector(`[data-clipboard-button-tooltip-target-id="${this.id}"]`);
        }
        get _placement() {
            return this.dataset.placement || "bottom-end";
        }
    };
    var Di = class extends M {
        constructor() {
            super(),
                (this._resizeObserver = new ResizeObserver(this._handleResize)),
                (this._lastButtonsWidth = 0),
                (this._quickViewBtnSelector = "[data-product-card-quick-view-button]"),
                (this._preloaderSelector = "[data-product-card-preloader]"),
                (this._imagesSelector = "[data-product-card-media-container]"),
                (this._buttonsSelector = "[data-product-card-buttons]"),
                (this._imageListSelector = "[data-product-card-featured-image]"),
                (this._mediaTabsSelector = "[data-product-card-media-tabs]"),
                (this._colorSwatchesSelector = "[data-product-card-color-swatches]"),
                (this._quickViewBtn = this.querySelector(this._quickViewBtnSelector)),
                (this._preloader = this.querySelector(this._preloaderSelector)),
                (this._images = this.querySelector(this._imagesSelector)),
                (this._buttons = this.querySelector(this._buttonsSelector)),
                (this._imageList = [...this.querySelectorAll(this._imageListSelector)]),
                (this._mediaTabs = this.querySelector(this._mediaTabsSelector)),
                (this._colorSwatches = this.querySelector(this._colorSwatchesSelector)),
                (this.imagesLoaded = 0);
        }
        connectedCallback() {
            this._imageList &&
                this._imageList.forEach((t) => {
                    t.addEventListener("load", this.handleImageLoad);
                }),
                this._resizeObserver.observe(this),
                this._preloader && y.observe(this._preloader),
                b(this, "mouseenter", this._handleMouseEnter),
                this._quickViewBtn && b(this._quickViewBtn, "click", this._handleQuickViewBtnClick);
        }
        disconnectedCallback() {
            this._imageList &&
                this._imageList.forEach((t) => {
                    t.removeEventListener("load", this.handleImageLoad);
                }),
                this._resizeObserver.disconnect(),
                this._preloader && y.unobserve(this._preloader),
                v(this, "mouseenter", this._handleMouseEnter),
                this._quickViewBtn && v(this._quickViewBtn, "click", this._handleQuickViewBtnClick);
        }
        _handleMouseEnter = () => {
            const t = this.dataset.url,
                e = this.dataset.id;
            t && e && ai.requestProductFromUrl(t, e);
        };
        _handleQuickViewBtnClick = () => {
            const t = this.dataset.url;
            t && ai.openAndRenderProductByUrl(t);
        };
        _handleResize = (0, ws.debounce)(() => {
            this._buttons && this._setButtonsOverflow(), this._mediaTabs && this._mediaTabs.update(), this._colorSwatches && this._colorSwatches.update();
        }, 100);
        handleImageLoad = () => {
            (this.imagesLoaded += 1), this.imagesLoaded === this._imageList?.length && (this._hidePreloader(), this._showImages());
        };
        _setButtonsOverflow() {
            if (!this._buttons) return;
            const t = this._getButtonsWidth(),
                e = this._buttons.offsetWidth < t;
            e && (this._lastButtonsWidth = this._buttons.offsetWidth), this._buttons.classList.toggle("product-card__btns--overflowed", e);
        }
        _getButtonsWidth() {
            const t = [...this.querySelectorAll("[data-product-card-button]")];
            return t.reduce(
                (t, e) => {
                    const s = e.querySelector("[data-product-card-button-text]");
                    return t + (20 + ((s ? s.offsetWidth : 0) + 8) + 10) + 8;
                },
                t.length > 1 ? 8 : 0
            );
        }
        _hidePreloader() {
            this._preloader && this._preloader.classList.add("hidden");
        }
        _showImages() {
            this._images && this._images.setAttribute("visible", "");
        }
    };
    var qi = class extends M {
        constructor() {
            super(),
                (this._resizeObserver = new ResizeObserver(this._handleResize)),
                (this.targetSelector = "[data-quote-line-clamp-target]"),
                (this.lineClampSelector = "[data-quote-line-clamp]"),
                (this._lineClamp = this.querySelector(this.lineClampSelector)),
                (this._target = this.querySelector(this.targetSelector));
        }
        connectedCallback() {
            this._resizeObserver.observe(this);
        }
        disconnectedCallback() {
            this._resizeObserver.disconnect();
        }
        _handleResize = (0, ws.debounce)(() => {
            this._setMaxLines();
        }, 100);
        _setMaxLines() {
            const t = this._getMaxLines();
            t && this._target && (this._target.style.setProperty("--gsc-max-lines", `${t}`), this.setAttribute("data-line-clamp-setter-is-ready", ""));
        }
        _getMaxLines() {
            if (!this._lineClamp || !this._target) return 0;
            const t = getComputedStyle(this._target),
                e = t.lineHeight,
                s = parseFloat(t.marginBottom),
                i = parseFloat(t.marginTop),
                n = this._lineClamp.offsetHeight - s - i;
            return Math.floor(n / parseFloat(e));
        }
    };
    var Oi = class extends M {
        constructor() {
            super(),
                (this._input = this.querySelector("input")),
                (this._dropdown = this.querySelector("float-element")),
                (this._dropdownBtnLabel = this.querySelector(".dropdown__toggle-label")),
                this._createItems(),
                (this._items = [...this.querySelectorAll(".dropdown__item")]);
        }
        connectedCallback() {
            this._items.forEach((t) => {
                b(t, "click", this._handleItemClick);
            });
        }
        disconnectedCallback() {
            this._items.forEach((t) => {
                v(t, "click", this._handleItemClick);
            });
        }
        _handleItemClick = (t) => {
            this._input &&
                this._dropdownBtnLabel &&
                this._dropdown &&
                (this._input.setAttribute("value", t.target.dataset.value), this._setActiveItem(t.target.dataset.value), (this._dropdownBtnLabel.innerHTML = t.target.dataset.value), this._dropdown.hide());
        };
        _setActiveItem(t) {
            this._items.forEach((e) => {
                e.classList.toggle("active", e.dataset.value === t);
            });
        }
        _createItems() {
            this.querySelectorAll("option").forEach((t) => {
                if (!this._dropdown) return;
                const e = document.createElement("div");
                e.classList.add("dropdown__item"), (e.dataset.value = t.value), (e.dataset.provinces = t.dataset.provinces), (e.innerHTML = t.innerHTML), this._dropdown.appendChild(e);
            });
        }
    };
    var Ri = class extends M {
        constructor() {
            super(),
                (this._inputSelector = "[data-search-field-input]"),
                (this._resetBtnSelector = "[data-search-field-reset-button]"),
                (this._input = this.querySelector(this._inputSelector)),
                (this._resetBtn = this.querySelector(this._resetBtnSelector));
        }
        connectedCallback() {
            b(this._input, "input", this._handleInputChange), b(window, "click", this._handleWindowClick), b(this._resetBtn, "click", this._handleResetBtnClick);
        }
        disconnectedCallback() {
            v(this._input, "input", this._handleInputChange), v(window, "click", this._handleWindowClick), v(this._resetBtn, "click", this._handleResetBtnClick);
        }
        _handleWindowClick = (t) => {
            const e = t.target,
                s = e.closest("search-input");
            !(this._input === e) && !s && this._updateResetButtonVisible();
        };
        _handleInputChange = () => {
            this._updateResetButtonVisible();
        };
        _handleResetBtnClick = (t) => {
            t.preventDefault(), this.reset();
        };
        reset() {
            if (this._input) {
                const t = new Event("input", { bubbles: !0 });
                (this._input.value = ""), this._input.dispatchEvent(t), this._input.focus();
            }
        }
        _updateResetButtonVisible() {
            if (this._resetBtn) {
                const t = this._hasInputValue();
                this._resetBtn.classList.toggle("hidden", !t);
            }
        }
        _hasInputValue() {
            return !!this._input && this._input.value.trim().length > 0;
        }
        get value() {
            return this._input ? this._input.value : "";
        }
    };
    var Fi = class extends M {
        constructor() {
            super(),
                (this._inputSelector = "[data-password-field-input]"),
                (this._buttonSelector = "[data-password-field-button]"),
                (this._input = this.querySelector(this._inputSelector)),
                (this._button = this.querySelector(this._buttonSelector));
        }
        connectedCallback() {
            b(this._button, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this._button, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this._togglePasswordVisible();
        };
        _togglePasswordVisible() {
            if (this._input) {
                const t = "password" === this._input.getAttribute("type"),
                    e = t ? "text" : "password";
                this._input.setAttribute("type", e), this._setButton(t);
            }
        }
        _setButton(t) {
            this._button && this._button.toggleAttribute("password-visible", t);
        }
    };
    var Ni = class extends M {
        constructor() {
            super(), (this.zoomTargetSelector = "[data-zoom-cursor-target]"), (this.mutationObserver = new MutationObserver(this._handleMutations));
        }
        connectedCallback() {
            this._autoCheckTargets();
        }
        disconnectedCallback() {
            v(window, "mousemove", this._handleMouseMove), this.mutationObserver.disconnect(), clearInterval(this.checkTargetsIntervalID);
        }
        _handleMutations = (t) => {
            t.forEach((t) => {
                if ("attributes" === t.type) {
                    const e = t.target.matches(this.zoomTargetSelector);
                    this._setVisible(e);
                }
            });
        };
        _handleMouseMove = (t) => {
            const e = t.target,
                s = !!e.closest(this.zoomTargetSelector),
                i = ke();
            this._isVisible && ((this.style.top = `${t.clientY}px`), (this.style.left = `${t.clientX}px`)), i || (this._setVisible(s), s && this.mutationObserver.observe(e, { attributes: !0 }));
        };
        _setVisible(t) {
            this.toggleAttribute("visible", t), (document.body.style.cursor = t ? "none" : "");
        }
        updateState(t) {
            this.toggleAttribute("zoomed", t);
        }
        _autoCheckTargets() {
            this.checkTargetsIntervalID = setInterval(() => {
                document.querySelectorAll(this.zoomTargetSelector).length && !this.isHandlerSetted && (b(window, "mousemove", this._handleMouseMove), (this.isHandlerSetted = !0));
            }, 1e3);
        }
        get _isVisible() {
            return this.hasAttribute("visible");
        }
    };
    var Hi = class extends M {
        constructor() {
            super(), (this._cache = {}), (this._searchParamsInitial = window.location.search.slice(1)), (this._searchParamsPrev = window.location.search.slice(1)), (this.sortQuery = ""), (this.filterQuery = "");
        }
        connectedCallback() {
            b(window, "popstate", this._handleHistoryChange);
        }
        disconnectedCallback() {
            v(window, "popstate", this._handleHistoryChange);
        }
        _handleHistoryChange = ({ state: { searchParams: t } }) => {
            const e = t || this._searchParamsInitial;
            e !== this._searchParamsPrev && this.updateBySearchParams(e);
        };
        _formatParams(t) {
            this._searchParamsPrev = t;
            return `${this.dataset.baseParams || ""}${t}`;
        }
        updateBySearchParams(t) {
            this.updateShopBySearchParams(t), this.updateFiltersBySearchParams(t);
        }
        updateShopBySearchParams(t) {
            const e = this._createUrl(t);
            this._cache[e] ? this._updateElements(this._cache[e]) : this._getFromUrl(e).then((t) => this._updateElements(t)), this._updateURL(t, e);
        }
        updateFiltersBySearchParams(t) {
            const e = this._createUrl(t),
                s = document.querySelector("#SidebarFiltersMobile"),
                i = document.querySelector("#SidebarFiltersDesktop");
            if (s && i) {
                const t = [s, i];
                t.forEach((t) => {
                    t.loadingOverlay.show();
                });
                const n = (e) => {
                    t.forEach((t) => {
                        t.updateHTML(e), t.loadingOverlay.hide();
                    });
                };
                this._cache[e] ? n(this._cache[e]) : this._getFromUrl(e).then((t) => n(t));
            }
        }
        _getFromUrl(t) {
            const e = this.querySelector("#ShopProductsOverlay"),
                s = e ? new Xs(e) : null;
            s && s.show();
            const i = `${t}&section_id=${this.dataset.sectionId}`;
            return fetch(i)
                .then((t) => t.text())
                .then((e) => {
                    const i = Q(e);
                    return (this._cache[t] = i), s && s.hide(), i;
                })
                .catch(() => {
                    u.notification && u.notification.show("Error in shop component", "warning");
                });
        }
        _updateURL(t, e) {
            history.pushState({ searchParams: t }, "", e);
        }
        _createUrl(t) {
            const e = this._formatParams(t) || "";
            return `${window.location.pathname}?${e}`;
        }
        _updateElements(t) {
            ["ShopProducts", "ShopProductCount", "ShopSortList", "ShopActiveFilters"].forEach((e) => {
                const s = document.getElementById(e),
                    i = t.getElementById(e);
                s && i && (s.innerHTML = i.innerHTML);
            });
        }
        resetQueries() {
            (this.sortQuery = ""), (this.filterQuery = "");
        }
    };
    var Vi = class extends M {
        constructor() {
            super(), (this.optionsSelector = "[data-shop-active-filters-options]"), (this.removeBtnSelector = "[data-shop-active-filters-remove-btn]");
        }
        reset() {
            this.innerHTML = "";
        }
        setDisable() {
            this.options && this.options.setAttribute("disabled", "");
        }
        get options() {
            return this.querySelector(this.optionsSelector);
        }
        get buttons() {
            return [...this.querySelectorAll(this.removeBtnSelector)];
        }
    };
    var zi = class extends Ce {
        constructor() {
            super(), (this.form = this.element.querySelector("[data-filters-form]"));
        }
        connectedCallback() {
            super.connectedCallback(), b(this.form, "scroll", this._handleFormScroll), b(this, "change", this._handleInputChange), b(this, "click", this._handleClick);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), v(this.form, "scroll", this._handleFormScroll), v(this, "change", this._handleInputChange), v(this, "click", this._handleClick);
        }
        _handleFormScroll = () => {
            if (this.form) {
                const t = this.form.scrollTop > 0;
                this.toggleAttribute("header-shadow-visible", t);
            }
        };
        _handleClick = (t) => {
            const e = t.target.closest("[data-filters-checkbox]");
            e && e.setAttribute("selected", "");
        };
        _handleInputChange = (t) => {
            "INPUT" === t.target.tagName && this._change();
        };
        _change() {}
        _createFilterQuery() {
            if (this._form && this._shop) {
                const t = new FormData(this._form),
                    e = new URLSearchParams(t).toString();
                this._shop.filterQuery = e;
            }
        }
        updateHTML(t) {
            const e = this.getAttribute("id"),
                s = e ? t.getElementById(e) : null,
                i = s ? s.querySelector("template") : null;
            if (i) {
                const t = Y(i);
                this.updateFormFromElement(t), this.updateHeaderFromElement(t);
            }
        }
        updateHeaderFromElement(t) {
            const e = this.element.querySelector("[data-filters-header]"),
                s = t.querySelector("[data-filters-header]");
            e && s && (e.innerHTML = s.innerHTML);
        }
        updateFormFromElement(t) {
            const e = this.element.querySelector("[data-filters-form]"),
                s = t.querySelector("[data-filters-form]");
            e && s && (e.innerHTML = s.innerHTML);
        }
        get _form() {
            return this.element.querySelector("form");
        }
        get _shop() {
            return this.element.closest("shop-component");
        }
        get _searchParams() {
            return this._shop ? [this._shop.filterQuery, this._shop.sortQuery].join("&") : "";
        }
        get loadingOverlay() {
            const t = this.element.querySelector("[data-filters-loading-overlay]");
            return t ? new Xs(t) : null;
        }
    };
    var $i = class extends zi {
        _change() {
            this._shop && (this._createFilterQuery(), this._shop.updateBySearchParams(this._searchParams));
        }
    };
    var Ki = class extends zi {
        _change() {
            this._shop && (this._createFilterQuery(), this._shop.updateFiltersBySearchParams(this._searchParams), this._setButtonForReset());
        }
        _setButtonForReset() {
            const t = this.element.querySelector("filter-remove-btn");
            if (t) {
                t.classList.contains("hidden") && V(t);
            }
        }
    };
    var Wi = class extends M {
        connectedCallback() {
            b(this, "focus", this._handleButtonFocus), b(this, "blur", this._handleButtonBlur), b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "focus", this._handleButtonFocus), v(this, "blur", this._handleButtonBlur), v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            this.update();
        };
        _handleButtonFocus = () => {
            this.addEventListener("keydown", this._handleKeyDown);
        };
        _handleButtonBlur = () => {
            this.removeEventListener("keydown", this._handleKeyDown);
        };
        _handleKeyDown = (t) => {
            k(t.key || t.keyCode) && (t.preventDefault(), this.update());
        };
        update() {
            const t = this.closest("shop-active-filters"),
                e = this.closest("shop-component"),
                s = this.dataset.url;
            if (t) {
                const e = this.hasAttribute("data-shop-active-filters-remove-btn");
                if ((this.hasAttribute("data-shop-active-filters-reset") && t.reset(), e)) {
                    1 === t.buttons.length ? t.reset() : (t.setDisable(), this.remove());
                }
            }
            if (s && e) {
                const t = -1 === s.indexOf("?") ? "" : s.slice(s.indexOf("?") + 1);
                e.resetQueries(), e.updateBySearchParams(t);
            }
        }
    };
    var Ui = class extends M {
        constructor() {
            super(), (this.labelSelector = "[data-sort-list-label]");
        }
        connectedCallback() {
            this.setListenersForLabels(), b(this._form, "input", this._handleFormSubmit);
        }
        disconnectedCallback() {
            this.removeListenersForLabels(), v(this._form, "input", this._handleFormSubmit);
        }
        _handleFormSubmit = (0, ws.debounce)((t) => {
            t.preventDefault();
            const e = this.closest("shop-component"),
                s = this.closest("sidebar-component"),
                i = t.target;
            if ((s && s.hide(), e && i)) {
                const t = this._getSortQuery(i),
                    s = [e.filterQuery, t].join("&");
                (e.sortQuery = t), e.updateBySearchParams(s);
            }
        }, 250);
        _handleLabelKeyDown = (t) => {
            if (k(t.key || t.keyCode)) {
                t.preventDefault();
                const e = t.target.querySelector("input");
                if (e) {
                    const t = new MouseEvent("click", { button: 0, which: 1 });
                    e.dispatchEvent(t);
                }
            }
        };
        _getSortQuery(t) {
            const e = t.closest("form");
            if (e) {
                const t = new FormData(e);
                return new URLSearchParams(t).toString();
            }
            return "";
        }
        setListenersForLabels() {
            [...this.querySelectorAll(this.labelSelector)].forEach((t) => {
                t.addEventListener("keydown", this._handleLabelKeyDown);
            });
        }
        removeListenersForLabels() {
            [...this.querySelectorAll(this.labelSelector)].forEach((t) => {
                t.removeEventListener("keydown", this._handleLabelKeyDown);
            });
        }
        get _form() {
            return this.querySelector("form");
        }
    };
    var Yi = class extends M {
        constructor() {
            super(),
                (this._minNumberInput = this.querySelector("[data-price-min-range-number]")),
                (this._maxNumberInput = this.querySelector("[data-price-max-range-number]")),
                (this._rangeWrapper = this.querySelector("[data-price-range-inputs-wrapper]")),
                (this._minRangeInput = this.querySelector("[data-price-min-range-input]")),
                (this._maxRangeInput = this.querySelector("[data-price-max-range-input]")),
                (this._progress = this.querySelector("[data-price-range-progress]"));
        }
        connectedCallback() {
            this._minRangeInput && this._updateMinRangeInput(+this._minRangeInput.value),
                this._maxRangeInput && this._updateMaxRangeInput(+this._maxRangeInput.value),
                b(this._minNumberInput, "input", this._handleNumberChange),
                b(this._maxNumberInput, "input", this._handleNumberChange),
                b(this._minRangeInput, "input", this._handleRangeChange),
                b(this._maxRangeInput, "input", this._handleRangeChange),
                b(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                b(this._rangeWrapper, "mousemove", this._handleRangeInput);
        }
        disconnectedCallback() {
            v(this._minNumberInput, "input", this._handleNumberChange),
                v(this._maxNumberInput, "input", this._handleNumberChange),
                v(this._minRangeInput, "input", this._handleRangeChange),
                v(this._maxRangeInput, "input", this._handleRangeChange),
                v(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                v(this._rangeWrapper, "mousemove", this._handleRangeInput);
        }
        _handleRangeInput = (t) => {
            const e = this.querySelector("[data-price-range-max-input]"),
                s = this.querySelector("[data-price-range-min-input]");
            if (this._progress && s && e) {
                const i = this._progress.offsetLeft + this._progress.offsetWidth / 2,
                    n = t.offsetX < i;
                s.toggleAttribute("targeted", n), e.toggleAttribute("targeted", !n);
            }
        };
        _handleNumberChange = () => {
            if (this._minNumberInput && this._maxNumberInput) {
                const t = parseInt(this._minNumberInput.value),
                    e = parseInt(this._maxNumberInput.value);
                this._updateMinRangeInput(t), this._updateMaxRangeInput(e);
            }
        };
        _handleRangeChange = () => {
            if (this._minRangeInput && this._maxRangeInput) {
                const t = parseInt(this._minRangeInput.value),
                    e = parseInt(this._maxRangeInput.value);
                this._updateMaxPriceInput(e), this._updateMinPriceInput(t), this._updateMinRangeInput(t), this._updateMaxRangeInput(e);
            }
        };
        _updateMaxRangeInput(t) {
            if (this._maxRangeInput && this._progress) {
                const e = 100 - (t / +this._maxRangeInput.max) * 100;
                (this._maxRangeInput.value = `${t}`), (this._progress.style.right = `${e}%`);
            }
        }
        _updateMinRangeInput(t) {
            if (this._minRangeInput && this._progress) {
                const e = (t / +this._minRangeInput.max) * 100;
                (this._minRangeInput.value = `${t}`), (this._progress.style.left = `${e}%`);
            }
        }
        _updateMaxPriceInput(t) {
            this._maxNumberInput && (this._maxNumberInput.value = t.toFixed(2));
        }
        _updateMinPriceInput(t) {
            this._minNumberInput && (this._minNumberInput.value = t.toFixed(2));
        }
    };
    var Xi = class extends M {
        constructor() {
            super(),
                (this.itemSelector = "[data-column-switcher-item]"),
                (this.targetSelector = "[data-column-switcher-target]"),
                (this.items = [...this.querySelectorAll(this.itemSelector)]),
                (this._cssVariable = this.dataset.columnSwitcherCssVariable || "");
        }
        connectedCallback() {
            this._init(),
                this.items.forEach((t) => {
                    b(t, "keydown", this._handleKeyDown), b(t, "click", this._handleItemClick);
                }),
                this._isEditorMode && this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad);
        }
        disconnectedCallback() {
            this.items.forEach((t) => {
                v(t, "keydown", this._handleKeyDown), v(t, "click", this._handleItemClick);
            }),
                this._isEditorMode && this._editor.destroy();
        }
        _handleSectionLoad = (t) => {
            this.dataset.sectionId === t.detail.sectionId && this.reset();
        };
        _handleItemClick = (t) => {
            const e = t.target.closest(this.itemSelector);
            if (e) {
                const t = +(e.dataset.value || 1);
                this._switch(t);
            }
        };
        _handleKeyDown = (t) => {
            if (k(t.key || t.keyCode)) {
                t.preventDefault();
                const e = t.target.closest(this.itemSelector);
                if (e) {
                    const t = +(e.dataset.value || 1);
                    this._switch(t);
                }
            }
        };
        updateByColumnCount(t) {
            this._selectSwitch(t), this._updateColumnCount(t);
        }
        _selectSwitch(t) {
            this.items.forEach((e) => {
                const s = +(e.getAttribute("data-value") || 1);
                e.classList.toggle("selected", s === t);
            });
        }
        _updateColumnCount(t) {
            const e = this.closest(this.targetSelector);
            e && (e.style.setProperty(`--gsc-${this._cssVariable}`, t.toString()), localStorage.setItem(`products-${this._cssVariable}`, t.toString()));
        }
        _init() {
            const t = localStorage.getItem(`products-${this._cssVariable}`);
            if (!t || "null" === t) return;
            const e = Number(t);
            e > 0 && this.updateByColumnCount(e);
        }
        _switch(t) {
            this.updateByColumnCount(t);
        }
        reset() {
            this.dataset.default && this._switch(Number(this.dataset.default));
        }
    };
    var Qi = class extends M {
        connectedCallback() {
            b(this, "click", this._handleButtonClick);
        }
        disconnectedCallback() {
            v(this, "click", this._handleButtonClick);
        }
        _handleButtonClick = () => {
            const t = this.closest("shop-component"),
                e = this.closest("#SidebarFiltersMobile");
            if (t) {
                const e = [t.filterQuery, t.sortQuery].join("&");
                t.updateShopBySearchParams(e);
            }
            e && e.hide();
        };
    };
    var ji = class extends M {
        constructor() {
            super(), (this._btnSelector = "[data-before-after-images-button]"), (this._btn = this.querySelector(this._btnSelector)), (this._isMoved = !1), (this._movingStep = 20);
        }
        connectedCallback() {
            this.setSeparatorPosition(Number(this.dataset.initialDragPosition)),
                b(this._btn, "keyup", this._handleButtonKeyUp),
                b(this._btn, "mousedown", this._handleButtonMouseDown),
                b(document, "mouseup", this._handleButtonMouseUp),
                b(document, "mousemove", this._handleMouseMove),
                b(this._btn, "touchstart", this._handleTouchStart),
                b(this, "touchmove", this._handleTouchMove),
                b(document, "touchend", this._handleTouchEnd);
        }
        disconnectedCallback() {
            v(this._btn, "keyup", this._handleButtonKeyUp),
                v(this._btn, "mousedown", this._handleButtonMouseDown),
                v(document, "mouseup", this._handleButtonMouseUp),
                v(document, "mousemove", this._handleMouseMove),
                v(this._btn, "touchstart", this._handleTouchStart),
                v(this, "touchmove", this._handleTouchMove),
                v(document, "touchend", this._handleTouchEnd);
        }
        _handleButtonMouseDown = (t) => {
            t.preventDefault(), this.startMove();
        };
        _handleButtonMouseUp = () => {
            this.endMove();
        };
        _handleMouseMove = (t) => {
            this._isMoved && this.moveSeparator(t.pageX);
        };
        _handleButtonKeyUp = (t) => {
            if (!this._btn) return;
            const e = t.key || t.keyCode,
                s = x(e),
                i = E(e);
            if (!s && !i) return;
            const n = this._btn.getBoundingClientRect(),
                o = n.right - n.width / 2,
                a = s ? o - this._movingStep : o + this._movingStep;
            this.moveSeparator(a);
        };
        _handleTouchStart = () => {
            this.startMove();
        };
        _handleTouchEnd = () => {
            this.endMove();
        };
        _handleTouchMove = (t) => {
            this._isMoved && (t.preventDefault(), this.moveSeparator(t.targetTouches[0].clientX));
        };
        startMove() {
            this._isMoved = !0;
        }
        endMove() {
            this._isMoved = !1;
        }
        setSeparatorPosition(t) {
            this.style.setProperty("--gsc-drag-position", `${t}%`);
        }
        moveSeparator(t) {
            const e = this.getBoundingClientRect();
            if (t <= e.left) this.setSeparatorPosition(0);
            else if (t >= e.right) this.setSeparatorPosition(100);
            else {
                const s = Math.floor(((t - e.left) / this.offsetWidth) * 1e3) / 10;
                this.setSeparatorPosition(s);
            }
        }
    };
    var Gi = class extends Ce {
        constructor() {
            super(), (this.viewport = this.element.querySelector("[data-product-information-drawer-viewport]"));
        }
        connectedCallback() {
            super.connectedCallback(), b(this.viewport, "scroll", this._handleFormScroll);
        }
        disconnectedCallback() {
            super.disconnectedCallback(), v(this.viewport, "scroll", this._handleFormScroll);
        }
        _handleFormScroll = () => {
            if (!this.viewport) return;
            const t = this.viewport.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", t);
        };
    };
    var Zi = class extends M {
        constructor() {
            super(), (this.content = this.querySelector("[data-tabs-element-content]")), (this.transitionDuration = K(this));
        }
        connectedCallback() {
            this.updateMaxHeight(this.isVisible);
        }
        show() {
            return this.setVisible(!0), g(this.transitionDuration);
        }
        hide() {
            return this.setVisible(!1), g(this.transitionDuration);
        }
        setVisible(t) {
            this.setAttribute("aria-hidden", t ? "false" : "true"), this.updateMaxHeight(t);
        }
        updateMaxHeight(t) {
            if (!this.content) return;
            const e = t ? this.content.offsetHeight : 0;
            this.style.maxHeight = `${e}px`;
        }
        get isVisible() {
            return "false" === this.getAttribute("aria-hidden");
        }
    };
    [
        { tag: "login-component", component: B },
        { tag: "back-to-top-button", component: P },
        { tag: "sticky-cart-button", component: q },
        { tag: "quantity-component", component: O },
        { tag: "quantity-btn", component: R },
        { tag: "localization-selector", component: F },
        { tag: "notification-component", component: N },
        { tag: "tabs-component", component: j },
        { tag: "tab-component", component: Zi },
        { tag: "list-component", component: G },
        { tag: "list-btn", component: Z },
        { tag: "float-element", component: se },
        { tag: "float-element-btn", component: le },
        { tag: "dropdown-opener", component: ce },
        { tag: "tooltip-trigger", component: he },
        { tag: "accordeon-component", component: de },
        { tag: "accordeon-btn", component: ue },
        { tag: "product-media-tabs", component: pe },
        { tag: "color-swatches", component: _e },
        { tag: "modal-component", component: ge },
        { tag: "password-modal", component: fe },
        { tag: "cart-notification-popup", component: be },
        { tag: "modal-opener", component: ve },
        { tag: "password-modal-opener", component: ye },
        { tag: "modal-close-btn", component: Se },
        { tag: "sidebar-button", component: we },
        { tag: "sidebar-component", component: Ce },
        { tag: "search-sidebar", component: xe },
        { tag: "quick-view", component: Le },
        { tag: "carousel-component", component: ks },
        { tag: "carousel-play-button", component: Es },
        { tag: "carousel-dots", component: Hs },
        { tag: "carousel-dot", component: Vs },
        { tag: "carousel-btn", component: zs },
        { tag: "carousel-progress", component: $s },
        { tag: "header-component", component: Ks },
        { tag: "drawer-menu", component: Ws },
        { tag: "drawer-menu-page", component: Us },
        { tag: "drawer-menu-page-link", component: Ys },
        { tag: "pagination-component", component: Qs },
        { tag: "pagination-load-button", component: js },
        { tag: "pagination-link", component: Gs },
        { tag: "pagination-infinite-scroll", component: Zs },
        { tag: "deferred-media", component: Js },
        { tag: "pickup-availability", component: ti },
        { tag: "product-form", component: ri },
        { tag: "product-form-button", component: li },
        { tag: "product-block", component: ci },
        { tag: "product-model", component: di },
        { tag: "cart-item", component: _i },
        { tag: "cart-component", component: gi },
        { tag: "sidebar-cart", component: fi },
        { tag: "cart-free-shipping-bar", component: vi },
        { tag: "product-media", component: yi },
        { tag: "product-media-carousel", component: Si },
        { tag: "variant-picker", component: wi },
        { tag: "color-swatches-picker", component: Ci },
        { tag: "product-modal", component: ki },
        { tag: "product-modal-image-wrap", component: Ei },
        { tag: "product-modal-opener", component: xi },
        { tag: "product-recommendations", component: Ii },
        { tag: "search-sidebar-form-wrapper", component: Mi },
        { tag: "cart-remove-button", component: Bi },
        { tag: "clipboard-button", component: Ai },
        { tag: "clipboard-button-tooltip", component: Pi },
        { tag: "product-card", component: Di },
        { tag: "max-lines-component", component: qi },
        { tag: "country-selector", component: Oi },
        { tag: "search-field", component: Ri },
        { tag: "password-field", component: Fi },
        { tag: "zoom-cursor", component: Ni },
        { tag: "shop-component", component: Hi },
        { tag: "shop-active-filters", component: Vi },
        { tag: "sidebar-filters-desktop", component: $i },
        { tag: "sidebar-filters-mobile", component: Ki },
        { tag: "filter-remove-btn", component: Wi },
        { tag: "sort-list", component: Ui },
        { tag: "price-range", component: Yi },
        { tag: "column-switcher", component: Xi },
        { tag: "filters-submit-btn", component: Qi },
        { tag: "before-after-images", component: ji },
        { tag: "product-information-drawer", component: Gi },
        {
            tag: "sidebar-filters-sticky-mobile-button",
            component: class extends we {
                constructor() {
                    super(), (this.products = document.getElementById("ShopProducts")), (this.footer = document.querySelector(".shopify-section-footer"));
                }
                connectedCallback() {
                    super.connectedCallback(), window.addEventListener("scroll", this._handleWindowScroll);
                }
                disconnectedCallback() {
                    super.disconnectedCallback(), window.removeEventListener("scroll", this._handleWindowScroll);
                }
                _handleWindowScroll = () => {
                    this._lastScrollPosition || (this._lastScrollPosition = window.scrollY), this.updateVisibleStatus(), this.updateExtendStatus();
                };
                updateVisibleStatus() {
                    const t = this.footer ? this.footer.offsetTop : 0,
                        e = this.products.getBoundingClientRect(),
                        s = window.innerHeight + window.scrollY < t,
                        i = e.top < 0,
                        n = s && i;
                    this.toggleAttribute("is-visible", n), document.body.toggleAttribute("is-filters-button-fixed", n);
                }
                updateExtendStatus = (0, ws.debounce)(() => {
                    if (Math.abs(window.scrollY - this._lastScrollPosition) > 24) {
                        const t = this._lastScrollPosition > window.scrollY;
                        this.toggleAttribute("is-extended", t);
                    }
                    this._lastScrollPosition = 0;
                }, 50);
            },
        },
    ].forEach(({ tag: t, component: e }) => {
        customElements.define(t, e);
    }),
        (window.bodyElement = u);
    (window.lazySizesConfig = { ...window.lazySizesConfig, loadHidden: !1, loadMode: 1, expand: 300 }),
        (function (t) {
            const e = t?.lazyClass || "lazy",
                s = t?.lazyBackgroundClass || "lazy-bg",
                i = t?.lazyBackgroundLoaded || "lazy-bg-loaded",
                n = t?.threshold || 200,
                l = t?.events || {},
                c = t?.observeChanges || !1,
                d = t?.observeRootSelector || "body",
                u = t?.mutationObserverOptions || { childList: !0, subtree: !0 },
                p = `video.${e},.${s}`;
            let m = Array.from(document.querySelectorAll(p));
            for (const t of m) o(t, l);
            if (!0 === a && !1 === r) {
                var _ = new IntersectionObserver(
                    (t) => {
                        for (const n of t)
                            if (n.isIntersecting || n.intersectionRatio) {
                                const { target: t } = n;
                                h(t, e, s, i), _.unobserve(t), (m = m.filter((e) => e != t)), 0 === m.length && !1 === c && _.disconnect();
                            }
                    },
                    { rootMargin: `${n}px 0%` }
                );
                for (const t of m) _.observe(t);
                c &&
                    new MutationObserver(() => {
                        const t = document.querySelectorAll(p);
                        for (const e of t) !1 === m.includes(e) && (m.push(e), o(e, l), !0 === a && !1 === r && _.observe(e));
                    }).observe(document.querySelector(d), u);
            } else if (r) for (const t of m) h(t, e, s, i);
        })({ lazyClass: "yall-video-lazy", threshold: 200, observeChanges: !0 });
})();
